const ar: Record<string, string> = {
  // Native push permission explainer (see components/PushPermissionDialog.tsx)
  "push.permission.title": "فعّل الإشعارات",
  "push.permission.body": "وصلك تنبيه بالعروض الجديدة، وسوق الجمعة، وتحديثات طلباتك ورسائلك — أول ما تصير.",
  "push.permission.enable": "تفعيل الإشعارات",
  "push.permission.later": "ليس الآن",
  "notifications.title": "الإشعارات",
  "notifications.empty": "لا توجد إشعارات",
  "notifications.emptyHint": "ستظهر هنا إشعاراتك والرسائل الجماعية",
  "notifications.markAllRead": "تعليم الكل كمقروء",
  "notifications.open": "فتح",
  "header.back": "رجوع",
  "header.home": "الصفحة الرئيسية",
  "header.todayProducts": "منتجات المحلات اليوم",
  "header.fridayMarket": "سوق الجمعة للعروض والمستعمل",
  "header.shorjaMarket": "سوق الشورجة",
  "header.chinaMarket": "سوق الصين",
  "header.turkeyMarket": "سوق تركيا",
  "header.workWithUs": "انضم للعمل معنا",
  "header.virtualStores": "المحلات الافتراضية",
  "header.wholesalePanel": "لوحة الجملة",
  "header.add": "أضف",
  "header.login": "دخول",
  "header.favorites": "المفضلة",
  "header.messages": "محادثاتي",
  "header.addListingFree": "أضف منتجك من هنا",
  "header.user": "مستخدم",
  "header.wholesaler": "تاجر جملة",
  "header.shopOwner": "صاحب محل",
  "header.virtualStore": "متجر افتراضي",
  "header.physicalStore": "محل حقيقي",
  "header.customer": "زبون",
  "header.openVirtualStore": "افتح متجر افتراضي وابدأ العمل",
  "header.dashboard": "لوحة التحكم",
  "header.merchantNotifications": "إشعارات التاجر",
  "header.virtualShopNotifications": "إشعارات متجرك",
  "header.partnerStores": "المتاجر الشريكة",
  "header.virtualStoreOrders": "طلبات المتاجر الافتراضية",
  "header.wholesaleProducts": "منتجات الجملة",
  "header.myListings": "إعلاناتي العادية",
  "header.viewMyStore": "عرض متجري",
  "header.myInventory": "مخزون متجري",
  "header.myProducts": "منتجاتي",
  "header.myOrders": "طلباتي",
  "header.notifications": "الإشعارات",
  "header.physicalStores": "المحلات التجارية",
  "header.stores": "المحلات",
  "header.recentlyViewed": "شوهد مؤخراً",
  "header.myAlerts": "تنبيهاتي",
  "header.compare": "المقارنة",
  "header.mapView": "خريطة الإعلانات",
  "header.myDisputes": "نزاعاتي",
  "header.support": "الرسائل",
  "header.wallet": "المحفظة",
  "header.settings": "إعدادات الحساب",
  "header.logout": "تسجيل خروج",
  "header.logoutConfirmTitle": "تسجيل الخروج",
  "header.logoutConfirmDesc": "هل أنت متأكد من رغبتك في تسجيل الخروج من حسابك؟",
  "header.logoutConfirmYes": "نعم، تسجيل خروج",
  "header.cancel": "إلغاء",
  "header.tagline": "سوق العراق — تسوق وبيع جديد ومستعمل في أنحاء العراق",
  "header.addYourListing": "أضف إعلانك",
  "header.navWholesale": "سوق الجملة",
  "header.navFriday": "سوق الجمعة",
  "header.navToday": "منتجات اليوم",
  "header.menu": "القائمة",
  "header.createAccount": "إنشاء حساب",
  "regCustomer.title": "تسجيل زبون جديد",
  "regCustomer.subtitle": "أنشئ حسابك للتسوق والشراء من سوق العراق",
  "regCustomer.firstName": "الاسم الأول",
  "regCustomer.lastName": "الاسم الأخير",
  "regCustomer.phone": "رقم الهاتف",
  "regCustomer.phoneHint": "يجب أن يبدأ الرقم بـ 07 ويتكون من 11 رقم",
  "regCustomer.phoneFormatError": "رقم الهاتف يجب أن يبدأ بـ 07 ويتكون من 11 رقم",
  "regCustomer.sendOtp": "إرسال رمز",
  "regCustomer.otpSent": "تم إرسال رمز التحقق إلى الواتساب",
  "regCustomer.otpSendFailed": "فشل إرسال رمز التحقق",
  "regCustomer.otpVerified": "تم التحقق بنجاح",
  "regCustomer.otpVerifyFailed": "فشل التحقق",
  "regCustomer.verified": "تم التحقق",
  "regCustomer.testCode": "رمز الاختبار",
  "regCustomer.enterCode": "أدخل الرمز",
  "regCustomer.verify": "تحقق",
  "regCustomer.changeNumber": "تغيير الرقم",
  "regCustomer.password": "كلمة المرور",
  "regCustomer.sixDigits": "6 خانات (أرقام أو أحرف)",
  "regCustomer.passwordHint": "يجب أن تكون كلمة المرور 6 أرقام على الأقل",
  "regCustomer.confirmPassword": "تأكيد كلمة المرور",
  "regCustomer.error": "خطأ",
  "regCustomer.passwordMismatch": "كلمة المرور غير متطابقة",
  "regCustomer.passwordTooShort": "كلمة المرور يجب أن تكون 6 أرقام على الأقل",
  "regCustomer.registerFailed": "فشل التسجيل",
  "regCustomer.serverError": "خطأ في الخادم. يرجى المحاولة مرة أخرى.",
  "regCustomer.registerSuccess": "تم التسجيل بنجاح",
  "regCustomer.registerError": "خطأ في التسجيل",
  "regCustomer.registering": "جاري التسجيل...",
  "regCustomer.registerButton": "إنشاء حساب زبون",
  "regCustomer.haveAccount": "لديك حساب بالفعل؟",
  "regCustomer.login": "تسجيل الدخول",
  "regCustomer.registerOptions": "خيارات التسجيل",
  "regCustomer.home": "الرئيسية",
  "regWholesale.title": "تسجيل تاجر جملة",
  "regWholesale.subtitle": "سجل كتاجر جملة لعرض منتجاتك في سوق الجملة والأسواق الدولية",
  "regWholesale.firstName": "الاسم الأول",
  "regWholesale.lastName": "الاسم الأخير",
  "regWholesale.phone": "رقم الهاتف",
  "regWholesale.phoneHint": "يجب أن يبدأ الرقم بـ 07 ويتكون من 11 رقم",
  "regWholesale.phoneFormatError": "رقم الهاتف يجب أن يبدأ بـ 07 ويتكون من 11 رقم",
  "regWholesale.sendOtp": "إرسال رمز",
  "regWholesale.otpSent": "تم إرسال رمز التحقق إلى الواتساب",
  "regWholesale.otpSendFailed": "فشل إرسال رمز التحقق",
  "regWholesale.otpVerified": "تم التحقق بنجاح",
  "regWholesale.otpVerifyFailed": "فشل التحقق",
  "regWholesale.verified": "تم التحقق",
  "regWholesale.testCode": "رمز الاختبار",
  "regWholesale.enterCode": "أدخل الرمز",
  "regWholesale.verify": "تحقق",
  "regWholesale.changeNumber": "تغيير الرقم",
  "regWholesale.wholesaleType": "نوع تجارة الجملة",
  "regWholesale.chooseBusinessType": "اختر نوع نشاطك التجاري",
  "regWholesale.typeShop": "صاحب محل جملة (داخل العراق)",
  "regWholesale.typeImporter": "مستورد من الصين/تركيا (داخل العراق)",
  "regWholesale.typeExporter": "مُصدِّر من الصين/تركيا (خارج العراق)",
  "regWholesale.shopLocation": "أين يقع محلك؟",
  "regWholesale.selectProvince": "اختر المحافظة",
  "regWholesale.baghdadCenter": "في أي مركز في بغداد؟",
  "regWholesale.selectCenter": "اختر المركز",
  "regWholesale.province": "المحافظة",
  "regWholesale.country": "البلد",
  "regWholesale.selectCountry": "اختر البلد",
  "regWholesale.city": "المدينة",
  "regWholesale.cityPlaceholder": "مثال: يوي، غوانزو، اسطنبول",
  "regWholesale.businessName": "اسم المحل / الشركة",
  "regWholesale.businessNameExample": "مثال: شركة الرافدين للتجارة",
  "regWholesale.businessAddress": "عنوان المحل / المخزن",
  "regWholesale.addressInside": "العنوان داخل",
  "regWholesale.fullAddress": "العنوان الكامل",
  "regWholesale.importExportCountries": "بلدان الاستيراد / التصدير",
  "regWholesale.importExportExample": "مثال: الصين، تركيا",
  "regWholesale.importExportHint": "اكتب البلدان التي تستورد منها أو تصدر إليها",
  "regWholesale.password": "كلمة المرور",
  "regWholesale.sixDigits": "6 خانات (أرقام أو أحرف)",
  "regWholesale.passwordHint": "يجب أن تكون كلمة المرور 6 أرقام على الأقل",
  "regWholesale.confirmPassword": "تأكيد كلمة المرور",
  "regWholesale.error": "خطأ",
  "regWholesale.passwordMismatch": "كلمة المرور غير متطابقة",
  "regWholesale.passwordTooShort": "كلمة المرور يجب أن تكون 6 أرقام على الأقل",
  "regWholesale.fillBusinessInfo": "يرجى ملء جميع بيانات العمل",
  "regWholesale.registerFailed": "فشل التسجيل",
  "regWholesale.serverError": "خطأ في الخادم. يرجى المحاولة مرة أخرى.",
  "regWholesale.registerSuccess": "تم التسجيل بنجاح",
  "regWholesale.registerError": "خطأ في التسجيل",
  "regWholesale.registering": "جاري التسجيل...",
  "regWholesale.registerButton": "تسجيل كتاجر جملة",
  "regWholesale.haveAccount": "لديك حساب بالفعل؟",
  "regWholesale.login": "تسجيل الدخول",
  "regWholesale.registerOptions": "خيارات التسجيل",
  "regWholesale.home": "الرئيسية",
  "regWholesale.pendingTitle": "تم التسجيل بنجاح!",
  "regWholesale.pendingMessage": "حسابك كتاجر جملة قيد المراجعة من قبل إدارة الموقع. سيتم إشعارك فور تفعيل حسابك.",
  "regWholesale.dataSaved": "تم حفظ بياناتك بنجاح",
  "regWholesale.reviewTime": "المراجعة تستغرق عادة من ٢٤ إلى ٤٨ ساعة",
  "regWholesale.goToLogin": "الذهاب لتسجيل الدخول",
  "regWholesale.browseSite": "استمر بتصفح الموقع",
  "regWholesale.china": "الصين",
  "regWholesale.turkey": "تركيا",
  "regWholesale.uae": "الإمارات",
  "regWholesale.iran": "إيران",
  "regWholesale.jordan": "الأردن",
  "regWholesale.syria": "سوريا",
  "regWholesale.lebanon": "لبنان",
  "regWholesale.egypt": "مصر",
  "regWholesale.saudiArabia": "السعودية",
  "regWholesale.other": "أخرى",
  "disputes.title": "نزاعاتي",
  "disputes.loginRequired": "يرجى تسجيل الدخول لعرض نزاعاتك",
  "disputes.empty": "لا توجد نزاعات مسجلة",
  "disputes.emptyHint": "يمكنك فتح نزاع من صفحة طلباتي إذا واجهت مشكلة",
  "disputes.loadError": "حدث خطأ في تحميل النزاعات",
  "disputes.retry": "إعادة المحاولة",
  "disputes.disputeId": "نزاع",
  "disputes.adminResolution": "قرار الإدارة",
  "disputes.closedLabel": "تم الإغلاق",
  "disputes.underReviewMsg": "جاري مراجعة نزاعك من قبل فريق الدعم",
  "disputes.openMsg": "تم استلام نزاعك وسيتم مراجعته قريباً",
  "disputes.status.open": "مفتوح",
  "disputes.status.under_review": "قيد المراجعة",
  "disputes.status.resolved": "تم الحل",
  "disputes.status.closed": "مغلق",
  "disputes.orderType.regular": "طلب عادي",
  "disputes.orderType.dropshipping": "طلب متجر افتراضي",
  "disputes.orderType.store_own": "طلب منتج متجر",
  "home.heroTitle": "سوق العراق - أكبر تطبيق للتسوق في العراق",
  "home.heroSubtitle": "عقارات، سيارات، إلكترونيات والمزيد",
  "home.newAndUsed": "جديد ومستعمل",
  "home.todayProducts": "منتجات اليوم",
  "home.baghdadMarkets": "أسواق بغداد:",
  "home.fridayMarket": "سوق الجمعة للعروض والمستعمل",
  "home.exclusiveOffers": "عروض حصرية كل يوم جمعة",
  "home.wholesaleMarketTitle": "تصفح منتجات الجملة",
  "home.wholesaleMarketDesc": "كصاحب متجر افتراضي يمكنك تصفح جميع منتجات تجار الجملة وإضافتها لمتجرك",
  "home.browseWholesale": "تصفح منتجات الجملة",
  "home.wholesaleTitle": "أسواق الجملة لأصحاب المحلات",
  "home.wholesaleDesc": "اختر من أفضل أسواق الجملة واعرض المنتجات في متجرك الافتراضي بأسعارك الخاصة",
  "home.iraqWholesale": "سوق جملة العراق",
  "home.localProducts": "منتجات محلية بأسعار الجملة",
  "home.fastDelivery": "توصيل سريع",
  "home.chinaMarket": "سوق الصين",
  "home.chineseProducts": "منتجات صينية متنوعة",
  "home.directImport": "استيراد مباشر",
  "home.turkeyMarket": "سوق تركيا",
  "home.turkishBrands": "ماركات تركية أصلية",
  "home.highQuality": "جودة عالية",
  "home.registerAsMerchant": "تسجيل كتاجر",
  "home.merchantDesc": "انضم كتاجر جملة",
  "home.openRetailStore": "افتح محل مفرد",
  "home.openVirtualStore": "افتح متجر افتراضي",
  "home.browseCategories": "تصفح الأقسام",
  "home.viewAll": "عرض الكل",
  "category.unclassified": "بلا قسم فرعي",
  "category.unclassifiedHint": "منتجات هذا القسم غير المسجلة في أي قسم فرعي",
  "home.heroHeadline": "بيع وشراء جديد ومستعمل في كل العراق",
  "home.heroTagline": "اعرض أغراضك، واكتشف المنتجات والمحلات بسهولة",
  "home.heroSearchPlaceholder": "عن ماذا تبحث؟ هاتف، سيارة، أثاث...",
  "home.heroProvinceLabel": "المحافظة",
  "home.allProvinces": "كل المحافظات",
  "home.searchAction": "بحث",
  "home.heroHintEasyPost": "إضافة إعلان بسهولة",
  "home.heroHintByProvince": "تصفّح بحسب المحافظة",
  "home.browseAllCategories": "تصفّح جميع الأقسام",
  "home.mainCategoriesCount": "{count} قسمًا رئيسيًا",
  "home.baghdadMarketsTitle": "أسواق بغداد",
  "home.featureFridayTitle": "سوق الجمعة",
  "home.featureFridayDesc": "إعلانات وعروض تُعرض يوم الجمعة",
  "home.featureTodayDesc": "اكتشف المنتجات المعروضة اليوم",
  "home.featureStoresDesc": "تسوّق من أصحاب المتاجر",
  "home.featureWholesaleTitle": "أسواق الجملة",
  "home.featureWholesaleDesc": "تعرّف إلى عروض تجار الجملة",
  "home.recentListingsTitle": "إعلانات ومنتجات حديثة",
  "home.viewAllListings": "عرض جميع الإعلانات",
  "home.browseAllListings": "تصفّح جميع الإعلانات في كل الأقسام",
  "home.virtualStoresTitle": "المتاجر الافتراضية",
  "home.product": "منتج",
  "home.showFilters": "عرض الفلاتر والأقسام",
  "home.hideFilters": "إخفاء الفلاتر",
  "home.activeFilters": "فلاتر نشطة",
  "home.detailedSearch": "البحث التفصيلي",
  "home.categories": "الأقسام",
  "home.allCategories": "جميع الأقسام",
  "sidebar.allDistricts": "جميع الأقضية",
  "sidebar.searchProvince": "ابحث عن المحافظة...",
  "sidebar.searchDistrict": "ابحث عن القضاء...",
  "home.latestListings": "أحدث الإعلانات",
  "home.noListings": "لا توجد إعلانات حالياً",
  "home.clearFilters": "مسح الفلاتر",
  "home.loadMore": "تحميل المزيد",
  "home.showingOf": "يعرض {shown} من أصل {total} إعلان",
  "home.showPerPage": "عرض في الصفحة",
  "home.allListingsShown": "تم عرض جميع الإعلانات",
  "home.loading": "جاري التحميل...",
  "home.listing": "إعلان",
  "home.searchByPrice": "البحث بالسعر:",
  "home.from": "من",
  "home.to": "إلى",
  "home.iqd": "د.ع",
  "home.usd": "دولار",
  "home.condition": "الحالة:",
  "home.all": "الكل",
  "home.new": "جديد",
  "home.used": "مستعمل",
  "home.price": "السعر:",
  "home.search": "بحث:",
  "home.noResults": "لم يتم العثور على إعلانات",
  "home.noResultsDesc": "لم يتم العثور على إعلانات تطابق معايير البحث. جرب تغيير الفلاتر أو البحث بكلمات مختلفة.",
  "cat.emlak": "العقارات",
  "cat.vasita": "السيارات",
  "cars.pickType": "اختر نوع السيارة",
  "cars.pickBrand": "اختر الماركة",
  "cars.pickSeries": "اختر الفئة",
  "cars.pickModel": "اختر الموديل",
  "cars.breadcrumb": "مسار التصفّح",
  "cars.showResults": "عرض النتائج",
  "cars.listings": "إعلان",
  "cars.noListingsYet": "لا توجد إعلانات بعد",
  "cars.noOptions": "لا توجد خيارات هنا حالياً",
  "cars.allListingsOf": "كل إعلانات",
  "cat.yedek-parca": "قطع غيار واكسسوارات السيارات",
  "cat.alisveris": "التسوق",
  "cat.riyada": "الرياضة",
  "cat.atfal": "الأطفال",
  "cat.tibbi": "المستلزمات الطبية",
  "cat.is-makineleri": "المعدات الثقيلة",
  "cat.hizmetler": "الخدمات",
  "cat.ozel-ders": "الدروس الخصوصية",
  "cat.is-ilanlari": "الوظائف",
  "cat.yardimci-arayanlar": "مطلوب مساعدين",
  "cat.hayvanlar-alemi": "الحيوانات",
  "cat.aghziya": "الأغذية",
  "market.mishn": "مجمع المشن",
  "footer.siteName": "سوق العراق",
  "footer.siteDesc": "أكبر تطبيق للتسوق في العراق. نوفر منصة آمنة وسهلة للبيع والشراء.",
  "footer.quickLinks": "روابط سريعة",
  "footer.addListing": "أضف إعلان",
  "footer.advancedSearch": "البحث المتقدم",
  "footer.workWithUs": "انضم للعمل معنا",
  "footer.contactUs": "اتصل بنا",
  "footer.mainCategories": "الأقسام الرئيسية",
  "footer.realEstate": "العقارات",
  "footer.cars": "السيارات",
  "footer.electronics": "الإلكترونيات",
  "footer.shopping": "الخدمات",
  "footer.contactTitle": "تواصل معنا",
  "footer.location": "بغداد، العراق",
  "footer.copyright": "جميع الحقوق محفوظة",
  "footer.developedBy": "تطوير بواسطة",
  "footer.giturn": "G-Turn",
  "home.downloadApp": "حمّل تطبيق سوق العراق على هاتفك",
  "footer.privacyPolicy": "سياسة الخصوصية",
  "footer.termsOfService": "شروط الاستخدام",
  "footer.legalLinks": "روابط قانونية",
  "legal.privacyTitle": "سياسة الخصوصية",
  "legal.privacyLastUpdated": "آخر تحديث: مارس 2026",
  "legal.privacyIntro": "نحن في سوق العراق نقدر خصوصيتك ونلتزم بحماية بياناتك الشخصية. توضح هذه السياسة كيفية جمع واستخدام وحماية معلوماتك عند استخدام منصتنا.",
  "legal.dataCollectionTitle": "البيانات التي نجمعها",
  "legal.dataCollection": "نجمع المعلومات التالية عند تسجيلك واستخدامك للمنصة: الاسم الكامل، رقم الهاتف، البريد الإلكتروني (اختياري)، الموقع الجغرافي، صور الإعلانات، سجل التصفح والبحث، بيانات المعاملات والطلبات.",
  "legal.dataUseTitle": "كيف نستخدم بياناتك",
  "legal.dataUse": "نستخدم بياناتك لإدارة حسابك، تمكين نشر الإعلانات والتواصل بين المستخدمين، معالجة الطلبات والمدفوعات، تحسين تجربة المستخدم، إرسال إشعارات مهمة حول حسابك، والحفاظ على أمان المنصة.",
  "legal.dataSharingTitle": "مشاركة البيانات",
  "legal.dataSharing": "لا نبيع بياناتك الشخصية لأطراف ثالثة. قد نشارك معلومات محدودة مع أطراف المعاملات (المشترين والبائعين) لإتمام عمليات البيع، ومع مزودي خدمات الدفع لمعالجة المدفوعات، ومع الجهات القانونية عند الطلب بموجب القانون.",
  "legal.dataSecurityTitle": "أمان البيانات",
  "legal.dataSecurity": "نتخذ إجراءات أمنية مناسبة لحماية بياناتك بما في ذلك تشفير كلمات المرور، استخدام بروتوكولات آمنة للاتصال، ومراقبة الوصول غير المصرح به. أرقام الهواتف مخفية ولا تظهر إلا لصاحب الحساب.",
  "legal.userRightsTitle": "حقوق المستخدم",
  "legal.userRights": "لديك الحق في الوصول إلى بياناتك الشخصية وتعديلها من خلال إعدادات الحساب، طلب حذف حسابك وجميع بياناتك نهائياً، سحب موافقتك على معالجة البيانات في أي وقت.",
  "legal.cookiesTitle": "ملفات تعريف الارتباط",
  "legal.cookies": "نستخدم ملفات تعريف الارتباط (الكوكيز) لتحسين تجربتك وتذكر تفضيلاتك مثل اللغة المفضلة وحالة تسجيل الدخول.",
  "legal.childrenTitle": "خصوصية الأطفال",
  "legal.children": "منصتنا غير موجهة للأشخاص دون سن 18 عاماً. لا نجمع عمداً بيانات من القاصرين.",
  "legal.changesTitle": "تحديثات السياسة",
  "legal.changes": "قد نحدث هذه السياسة من وقت لآخر. سنخطرك بأي تغييرات جوهرية عبر إشعار في المنصة.",
  "legal.contactTitle": "تواصل معنا",
  "legal.contactInfo": "إذا كانت لديك أسئلة حول سياسة الخصوصية، يرجى التواصل معنا عبر البريد الإلكتروني: info@iraq-sooq.com",
  "legal.termsTitle": "شروط الاستخدام",
  "legal.termsLastUpdated": "آخر تحديث: أكتوبر 2026",
  "legal.termsIntro": "مرحباً بك في سوق العراق. باستخدامك لمنصتنا فإنك توافق على الالتزام بهذه الشروط والأحكام. يرجى قراءتها بعناية.",
  "legal.acceptanceTitle": "قبول الشروط",
  "legal.acceptance": "Iraqsooq هو سوق هجين يخدم السوق العراقي، يربط بين تجار الجملة وأصحاب المتاجر الافتراضية والبائعين الأفراد. باستخدام المنصة أو التسجيل فيها، فإنك توافق على هذه الشروط والأحكام. إذا كنت لا توافق على أي منها، يرجى عدم استخدام المنصة.",
  "legal.accountTitle": "التسجيل والحساب",
  "legal.account": "يجب أن يكون عمرك 18 عاماً على الأقل للتسجيل. أنت مسؤول عن تقديم معلومات دقيقة والحفاظ على أمان حسابك وكلمة المرور الخاصة بك.",
  "legal.platformUseTitle": "استخدام المنصة",
  "legal.platformUse": "سوق العراق هو سوق إلكتروني للإعلانات المبوبة يتيح البيع والشراء والمتاجر الافتراضية ونظام إعادة البيع. يجب استخدام المنصة لأغراض مشروعة فقط.",
  "legal.prohibitedTitle": "الأنشطة المحظورة",
  "legal.prohibited": "يمنع منعاً باتاً: الاحتيال والغش، بيع البضائع غير القانونية أو المحظورة، التحرش أو الإساءة للمستخدمين الآخرين، نشر إعلانات كاذبة أو مضللة، استخدام صور غير حقيقية، التلاعب بالأسعار، وأي نشاط يخالف القوانين العراقية.",
  "legal.listingRulesTitle": "قواعد الإعلانات",
  "legal.listingRules": "يجب أن تحتوي الإعلانات على أوصاف دقيقة وصور حقيقية وأسعار عادلة. نحتفظ بالحق في إزالة أي إعلان يخالف سياساتنا. بالنسبة للمنتجات الشخصية/المستعملة التي تُباع مباشرة بين المستخدمين، فإن Iraqsooq يعمل كمنصة استضافة إعلانات مبوبة فقط. المنصة لا تتحقق من حالة البضائع المستعملة، وتقع مسؤولية المعاملة بالكامل على عاتق المشتري والبائع.",
  "legal.virtualStoreTitle": "المتاجر الافتراضية وإعادة البيع",
  "legal.virtualStore": "فتح المتجر الافتراضي وإضافة المنتجات مجانيان. عندما يبيع المتجر منتجاته الخاصة يستلم مندوب التوصيل الثمن من الزبون ويسلّمه مباشرة إلى صاحب المتجر؛ لا تستلم المنصة هذا المبلغ ولا تقتطع منه أي عمولة، ولا يُضاف إلى المحفظة الداخلية. وعند إعادة بيع منتجات تجار الجملة تحتفظ المنصة برسوم مخزن سحابي نسبتها 20% من هامش إعادة البيع فقط (الفرق بين سعر البيع وسعر الجملة)، لا من إجمالي السعر، وفق النسبة المعتمدة في إعدادات المنصة. أرباح إعادة بيع منتجات الجملة تخضع لفترة مراجعة أمنية تتراوح بين 24 إلى 48 ساعة بعد تأكيد التسليم قبل أن تصبح مؤهلة للسحب، ويتم إيداعها في المحفظة الداخلية بعد انتهاء فترة المراجعة.",
  "legal.paymentTitle": "الدفع والمحفظة",
  "legal.payment": "تعتمد المنصة حالياً الدفع عند الاستلام (COD) كطريقة الدفع المتاحة، وسنضيف قريباً وسائل دفع إلكترونية (مثل Q-Card وZain Cash وAsiaHawala). رمز التسليم المكوّن من 12 حرفاً هو ضمان الأمان الوحيد للمشتري. بتقديم هذا الرمز لوكيل التوصيل، يقرّ المشتري بأنه فحص المنتج وقبِله. المنصة غير مسؤولة عن أي مشاكل يتم اكتشافها بعد مشاركة الرمز. أرباح إعادة بيع منتجات الجملة ومستحقات تجار الجملة تودع في المحفظة الداخلية ويمكن طلب سحبها وفق الشروط المحددة، أما ثمن المنتجات الخاصة بالمتاجر فيسلّمه مندوب التوصيل مباشرة إلى صاحب المتجر ولا يمر بالمحفظة.",
  "legal.intellectualPropertyTitle": "الملكية الفكرية",
  "legal.intellectualProperty": "جميع محتويات المنصة محمية بحقوق الملكية الفكرية. لا يجوز نسخ أو إعادة توزيع أي محتوى بدون إذن مسبق.",
  "legal.liabilityTitle": "حدود المسؤولية",
  "legal.liability": "Iraqsooq هو وسيط تقني بين البائعين والمشترين. المنصة غير مسؤولة عن تأخيرات الشحن الناتجة عن تجار الجملة أو وكلاء التوصيل من أطراف ثالثة بمجرد مغادرة المنتج للمستودع. لا نتحمل مسؤولية جودة المنتجات أو صحة المعلومات المقدمة من المستخدمين.",
  "legal.terminationTitle": "إنهاء الحساب",
  "legal.termination": "نحتفظ بالحق في تعليق أو إنهاء أي حساب ينتهك هذه الشروط دون إشعار مسبق. يمكنك حذف حسابك في أي وقت من إعدادات الحساب.",
  "legal.governingLawTitle": "القانون المعمول به",
  "legal.governingLaw": "تخضع هذه الشروط للقوانين العراقية. أي نزاعات تنشأ عن استخدام المنصة تحل وفقاً للقانون العراقي.",
  "legal.termsContactInfo": "إذا كانت لديك أسئلة حول شروط الاستخدام، يرجى التواصل معنا عبر البريد الإلكتروني: info@iraq-sooq.com",
  "common.search": "بحث",
  "common.loading": "جاري التحميل...",
  "common.error": "حدث خطأ",
  "common.save": "حفظ",
  "common.delete": "حذف",
  "common.edit": "تعديل",
  "common.close": "إغلاق",
  "common.confirm": "تأكيد",
  "common.price": "السعر",
  "common.send": "إرسال",
  "common.language": "اللغة",
  "common.yes": "نعم",
  "common.no": "لا",
  "common.back": "رجوع",
  "common.next": "التالي",
  "common.previous": "السابق",
  "common.page": "صفحة",
  "common.submit": "إرسال",
  "common.cancel": "إلغاء",
  "common.ok": "حسناً",
  "common.retry": "إعادة المحاولة",
  "common.noData": "لا توجد بيانات",
  "common.seeAll": "عرض الكل",
  "common.details": "التفاصيل",
  "common.status": "الحالة",
  "common.date": "التاريخ",
  "common.amount": "المبلغ",
  "common.total": "المجموع",
  "common.actions": "الإجراءات",
  "common.name": "الاسم",
  "common.description": "الوصف",
  "common.note": "ملاحظة",
  "common.required": "مطلوب",
  "common.optional": "اختياري",
  "common.all": "الكل",
  "common.none": "لا شيء",
  "common.other": "أخرى",
  "common.currencyIQD": "د.ع",
  "common.new": "جديد",
  "common.used": "مستعمل",
  "auth.login": "تسجيل الدخول",
  "auth.register": "تسجيل حساب جديد",
  "auth.phone": "رقم الهاتف",
  "auth.phoneFormat": "(07xxxxxxxxx)",
  "auth.password": "كلمة المرور",
  "auth.passwordDigits": "(6 خانات على الأقل، أرقام أو أحرف)",
  "auth.forgotPassword": "نسيت كلمة المرور؟",
  "auth.noAccount": "ليس لديك حساب؟",
  "auth.registerNow": "سجل الآن",
  "auth.backToHome": "الرئيسية",
  "auth.loginSuccess": "تم تسجيل الدخول",
  "auth.welcomeBack": "مرحباً بك مجدداً!",
  "auth.loginFailed": "فشل تسجيل الدخول",
  "auth.enterCredentials": "أدخل بياناتك للدخول إلى حسابك",
  "auth.tooManyAttempts": "محاولات كثيرة — حاول بعد دقيقة",
  "auth.loggingIn": "جاري تسجيل الدخول...",
  "auth.serverError": "خطأ في الخادم. يرجى المحاولة مرة أخرى.",
  "auth.error": "خطأ",
  "auth.accountUnderReview": "حسابك قيد المراجعة",
  "auth.firstName": "الاسم الأول",
  "auth.lastName": "الاسم الأخير",
  "auth.province": "المحافظة",
  "auth.selectProvince": "اختر المحافظة",
  "auth.registerSuccess": "تم التسجيل بنجاح",
  "auth.welcomeToSouq": "مرحباً بك في سوق العراق!",
  "auth.registerFailed": "فشل التسجيل",
  "auth.registerError": "خطأ في التسجيل",
  "auth.passwordMismatch": "كلمة المرور غير متطابقة",
  "auth.passwordMinLength": "كلمة المرور يجب أن تكون 8 محارف على الأقل",
  "auth.businessInfo": "معلومات التجارة",
  "auth.businessNameLabel": "اسم الشركة / النشاط التجاري",
  "auth.businessCityLabel": "المدينة",
  "auth.baghdadMarketLabel": "السوق في بغداد",
  "auth.businessAddressLabel": "عنوان المكتب / المخزن",
  "auth.confirmPassword": "تأكيد كلمة المرور",
  "auth.buyer": "زبون",
  "auth.buyerDesc": "شراء + متجر افتراضي",
  "auth.wholesalerType": "تاجر جملة",
  "auth.wholesalerDesc": "بيع بالجملة فقط",
  "auth.shopDetails": "معلومات المحل",
  "auth.shopName": "اسم المحل",
  "auth.shopNamePlaceholder": "مثال: محل الرافدين للإلكترونيات",
  "auth.shopType": "نوع المحل",
  "auth.selectShopType": "اختر نوع المحل",
  "auth.retailShop": "محل مفرد (تجزئة)",
  "auth.wholesaleShop": "محل جملة",
  "auth.shopCity": "مدينة المحل",
  "auth.selectCity": "اختر المدينة",
  "auth.shopAddress": "عنوان المحل",
  "auth.shopAddressPlaceholder": "العنوان التفصيلي للمحل",
  "auth.haveAccount": "لديك حساب بالفعل؟",
  "auth.loginNow": "سجل دخول",
  "auth.phoneRequired": "يجب أن يبدأ الرقم بـ 07 ويتكون من 11 رقم",
  "auth.securityQuestion": "سؤال الأمان",
  "auth.securityAnswer": "جواب سؤال الأمان",
  "auth.selectSecurityQuestion": "اختر سؤال الأمان",
  "auth.resetPassword": "استعادة كلمة المرور",
  "auth.newPassword": "كلمة المرور الجديدة",
  "auth.currentPassword": "كلمة المرور الحالية",
  "auth.changePassword": "تغيير كلمة المرور",
  "auth.accountType": "نوع الحساب",
  "auth.chooseAccountType": "اختر نوع الحساب",
  "listing.create": "إنشاء إعلان",
  "listing.edit": "تعديل الإعلان",
  "listing.delete": "حذف الإعلان",
  "listing.deleteConfirm": "هل أنت متأكد من حذف هذا الإعلان؟",
  "listing.title": "عنوان الإعلان",
  "listing.description": "الوصف",
  "listing.price": "السعر",
  "listing.category": "القسم",
  "listing.selectCategory": "اختر القسم",
  "createListing.title": "إضافة إعلان جديد",
  "createListing.wholesaleTitle": "إضافة منتج جملة",
  "createListing.changeCategory": "تغيير القسم",
  "createListing.changeSubcategory": "تغيير القسم الفرعي",
  "createListing.backToCategories": "رجوع للأقسام",
  "createListing.selectSubcategoryTitle": "اختر القسم الفرعي *",
  "createListing.searchCategories": "ابحث عن القسم...",
  "createListing.noResultsFor": "لا توجد نتائج لـ",
  "createListing.allSubcategories": "كل الأقسام الفرعية",
  "createListing.selectSubcategoryHere": "اختر الفئة الفرعية",
  "listing.subcategory": "القسم الفرعي",
  "listing.condition": "الحالة",
  "listing.new": "جديد",
  "listing.used": "مستعمل",
  "listing.location": "الموقع",
  "listing.city": "المدينة",
  "listing.images": "الصور",
  "listing.uploadImages": "رفع الصور",
  "listing.publish": "نشر الإعلان",
  "listing.update": "تحديث الإعلان",
  "listing.details": "تفاصيل الإعلان",
  "listing.seller": "البائع",
  "listing.contactSeller": "تواصل مع البائع",
  "listing.addToCart": "أضف إلى السلة",
  "listing.addToFavorites": "أضف إلى المفضلة",
  "listing.removeFromFavorites": "إزالة من المفضلة",
  "listing.share": "مشاركة",
  "listing.report": "الإبلاغ",
  "listing.views": "المشاهدات",
  "listing.postedOn": "تاريخ النشر",
  "listing.listingCode": "كود الإعلان",
  "listing.wholesalePrice": "سعر الجملة",
  "listing.minOrder": "الحد الأدنى (شراء مباشر من التاجر)",
  "listing.quantity": "الكمية",
  "listing.available": "متوفر",
  "listing.soldOut": "نفد المخزون",
  "listing.featured": "مميز",
  "listing.verified": "موثق",
  "listing.noImages": "لا توجد صور",
  "listing.similarListings": "إعلانات مشابهة",
  "listing.sellerListings": "إعلانات البائع",
  "listing.currency": "العملة",
  "listing.iqd": "دينار عراقي",
  "listing.usd": "دولار أمريكي",
  "listing.piece": "قطعة",
  "listing.dozen": "درزن",
  "listing.carton": "كرتون",
  "listing.pallet": "بالت",
  "listing.sendMessage": "إرسال رسالة",
  "listing.buyNow": "شراء الآن",
  "listing.addToStore": "أضف إلى متجرك",
  "listing.requestReviewed": "سيتم مراجعة طلبك من قبل الإدارة والتواصل معك قريباً",
  "listing.reviewSent": "تم إرسال التقييم بنجاح",
  "listing.reviewFailed": "فشل في إرسال التقييم",
  "listing.noListing": "لا يوجد إعلان",
  "listing.notFound": "الإعلان غير موجود",
  "listing.backToHome": "العودة للصفحة الرئيسية",
  "listing.writeReview": "اكتب تقييمك",
  "listing.submitReview": "إرسال التقييم",
  "listing.rateExperience": "قيم تجربتك",
  "listing.titleMin": "اسم الإعلان يجب أن يكون 5 أحرف على الأقل",
  "listing.descMin": "الوصف يجب أن يكون 20 حرف على الأقل",
  "listing.pricePositive": "السعر يجب أن يكون رقم موجب",
  "listing.priceMax": "السعر يجب أن لا يتجاوز 12 رقم",
  "listing.categoryRequired": "يجب اختيار القسم",
  "listing.publishSuccess": "تم نشر الإعلان بنجاح",
  "listing.updateSuccess": "تم تحديث الإعلان بنجاح",
  "listing.deleteSuccess": "تم حذف الإعلان بنجاح",
  "listing.selectSubcategory": "اختر القسم الفرعي",
  "listing.selectCondition": "اختر الحالة",
  "listing.selectCity": "اختر المدينة",
  "listing.selectLocation": "اختر الموقع",
  "listing.additionalInfo": "معلومات إضافية",
  "listing.contactInfo": "معلومات التواصل",
  "listing.productType": "نوع المنتج",
  "listing.foodProducts": "المواد الغذائية",
  "listing.cleaningProducts": "مواد التنظيف",
  "listing.cosmetics": "مستحضرات التجميل",
  "listing.mobileAccessories": "اكسسوارات الموبايل",
  "listing.lighting": "الإنارة",
  "listing.clothing": "الملابس",
  "listing.stationery": "القرطاسية",
  "listing.autoParts": "قطع غيار واكسسوارات السيارات",
  "listing.sportsEquipment": "مستلزمات رياضية",
  "listing.kidsProducts": "مستلزمات أطفال",
  "listing.medicalSupplies": "مستلزمات طبية",
  "listing.wholesaleOnly": "جملة فقط",
  "listing.serviceType": "نوع الخدمة",
  "listing.wholesale": "جملة",
  "listing.wholesaler": "تاجر جملة",
  "listing.importer": "مستورد",
  "listing.exporter": "مصدّر",
  "listing.shipsFrom": "يشحن من",
  "listing.virtualStore": "متجر افتراضي",
  "listing.storeProduct": "منتج محل",
  "listing.storeService": "خدمة",
  "listing.serviceContactOnly": "خدمة: تواصل مع المتجر لطلبها، ولا تُضاف إلى السلة",
  "createListing.serviceInfo": "خدمة: يتواصل الزبون معك مباشرة. لا سلة ولا طلب شراء ولا توصيل، ولا كمية أو حالة.",
  "createListing.serviceCreated": "نُشرت الخدمة في متجرك وفي قسم الخدمات",
  "ownCondition.isService": "هذه خدمة — انقلها إلى قسم الخدمات",
  "listing.locatedInProvince": "موجود في {province}",
  "listing.offeredInMarket": "معروض في",
  "listing.deliversToProvince": "متاح للتوصيل إلى {province}",
  "listing.loginRequired": "يرجى تسجيل الدخول",
  "listing.loginRequiredDesc": "يجب تسجيل الدخول لإضافة المنتجات إلى السلة",
  "listing.addedToCart": "تمت الإضافة للسلة",
  "listing.editButton": "تعديل",
  "listing.addToCartButton": "إضافة للسلة",
  "listing.wholesaleMarketLabel": "سوق الجملة",
  "listing.wholesaleMarketPlaceholder": "اختر سوق الجملة (اختياري)",
  "listing.wholesaleMarketNoClassification": "بدون تصنيف سوق",
  "listing.wholesaleMarketIraq": "سوق الجملة العراقي",
  "listing.wholesaleMarketChina": "السوق الصيني",
  "listing.wholesaleMarketTurkey": "السوق التركي",
  "listing.wholesaleMarketHint": "اختر سوق الجملة لعرض المنتج في قسم السوق المحدد",
  "listing.addToMyStore": "إضافة لمحلي",
  "listing.alreadyInStore": "موجود في محلي",
  "listing.piecesPerUnit": "قطعة",
  "settings.title": "إعدادات الحساب",
  "settings.personalInfo": "المعلومات الشخصية",
  "settings.phone": "رقم الهاتف",
  "settings.email": "البريد الإلكتروني",
  "settings.changePhone": "تغيير رقم الهاتف",
  "settings.changeEmail": "تغيير البريد الإلكتروني",
  "settings.changePassword": "تغيير كلمة المرور",
  "settings.virtualStore": "المتجر الافتراضي",
  "settings.activateStore": "تفعيل المتجر الافتراضي",
  "settings.storeName": "اسم المتجر",
  "settings.storeSpecialty": "اختصاص المتجر",
  "settings.selectSpecialty": "اختر اختصاص المتجر",
  "settings.customSpecialty": "اختصاص مخصص",
  "settings.updateSuccess": "تم التحديث",
  "settings.updateSuccessDesc": "تم تحديث المعلومات بنجاح",
  "settings.updateFailed": "فشل التحديث",
  "settings.noChanges": "لم تقم بإجراء أي تغييرات",
  "settings.enterStoreName": "يرجى إدخال اسم المتجر",
  "settings.enterSpecialty": "يرجى اختيار اختصاص المتجر",
  "settings.writeSpecialty": "يرجى كتابة اختصاص المتجر",
  "settings.validPhone": "يرجى إدخال رقم هاتف عراقي صحيح (07xxxxxxxxx)",
  "settings.validEmail": "يرجى إدخال بريد إلكتروني صحيح",
  "settings.currentPasswordRequired": "يرجى إدخال كلمة المرور الحالية",
  "settings.newPasswordMin": "كلمة المرور الجديدة يجب أن تكون 6 أرقام على الأقل",
  "settings.storeActivated": "أصبح لديك الآن متجر افتراضي!",
  "settings.pendingRequest": "طلب تعديل قيد المراجعة",
  "settings.pendingRequestMsg": "تم إرسال طلبك بنجاح وهو قيد المراجعة من قبل الإدارة. يرجى الانتظار حتى تتم الموافقة عليه.",
  "settings.contactAdminIfNeeded": "للاستعجال أو الاستفسار، يرجى التواصل مع إدارة الموقع عبر صفحة اتصل بنا",
  "settings.editRequestSentTitle": "تم إرسال طلب التعديل",
  "settings.editRequestSentMsg": "طلبك قيد المراجعة من الإدارة. سيتم تحديث بيانات متجرك عند الموافقة.",
  "settings.requestPending": "الطلب قيد المراجعة",
  "settings.computers": "الكمبيوتر والتابلت",
  "settings.phones": "الهواتف",
  "settings.electronics": "الإلكترونيات",
  "settings.homeAppliances": "الأجهزة المنزلية",
  "settings.clothingCat": "الملابس",
  "settings.accessories": "إكسسوارات",
  "settings.furniture": "المنزل والأثاث",
  "settings.garden": "الحديقة",
  "settings.sports": "الرياضة",
  "settings.hobbies": "الهوايات",
  "settings.babyMother": "الأم والطفل",
  "settings.beauty": "مستحضرات التجميل",
  "settings.yourVirtualStore": "متجرك الافتراضي",
  "settings.openVirtualStore": "افتح متجر افتراضي",
  "settings.storeInfoReadOnly": "معلومات متجرك الافتراضي (للتعديل، أرسل طلباً للإدارة)",
  "settings.createStoreDesc": "أنشئ متجرك الافتراضي لعرض وبيع منتجاتك",
  "settings.activeStore": "متجر نشط",
  "settings.storePhone": "رقم هاتف المتجر",
  "settings.notSpecified": "غير محدد",
  "settings.newStoreName": "اسم المتجر الجديد",
  "settings.newPhone": "رقم الهاتف الجديد",
  "settings.noNumber": "بدون رقم",
  "settings.newSpecialty": "الاختصاص الجديد",
  "settings.newDescription": "الوصف الجديد",
  "settings.noDescription": "بدون وصف",
  "settings.waitPreviousRequest": "انتظر مراجعة الطلب السابق",
  "settings.requestStoreEdit": "طلب تعديل معلومات المتجر",
  "settings.requestStoreEditDesc": "أدخل المعلومات الجديدة التي تريد تغييرها. سيتم مراجعة طلبك من قبل الإدارة.",
  "settings.viewStorePage": "عرض صفحة المتجر",
  "settings.editStoreInfo": "تعديل معلومات المتجر",
  "settings.editStoreInfoDesc": "يمكنك تعديل اسم المتجر والوصف ورقم الهاتف والاختصاص. التغييرات ستطبق فوراً.",
  "settings.editRequestSent": "تم إرسال طلب التعديل",
  "settings.editRequestSentDesc": "طلبك قيد المراجعة من الإدارة. سيتم تحديث بيانات متجرك عند الموافقة.",
  "settings.sendEditRequest": "إرسال طلب تعديل",
  "settings.pendingEditRequest": "طلب تعديل قيد المراجعة",
  "settings.pendingEditRequestDesc": "لديك طلب تعديل قيد المراجعة من الإدارة. لا يمكنك إرسال طلب جديد حتى تتم معالجة الطلب الحالي.",
  "settings.editRequestReason": "سبب التعديل (اختياري)",
  "settings.editRequestReasonPlaceholder": "اكتب سبب طلب التعديل...",
  "settings.saving": "جاري الحفظ...",
  "settings.editReason": "سبب التعديل (اختياري)",
  "settings.editReasonPlaceholder": "لماذا تريد تغيير هذه المعلومات؟",
  "settings.sending": "جاري الإرسال...",
  "settings.sendRequest": "إرسال الطلب",
  "settings.trustNote": "للحفاظ على موثوقية المتجر، يتم مراجعة طلبات التعديل من قبل الإدارة",
  "settings.physicalStoreSection": "المتجر الفعلي",
  "settings.editPhysicalStore": "تعديل موقع المتجر الفعلي",
  "settings.noPhysicalStoreYet": "متجرك افتراضي فقط حالياً. يمكنك إضافة موقع متجر فعلي.",
  "settings.storeNameLabel": "اسم المكتب أو المتجر *",
  "settings.storeNamePlaceholder": "مثال: متجر النجم الذهبي",
  "settings.storeDescriptionLabel": "وصف المتجر",
  "settings.storeDescriptionPlaceholder": "اكتب وصفاً قصيراً لمتجرك...",
  "settings.storePhoneOptional": "رقم هاتف المكتب (اختياري)",
  "settings.customSpecialtyLabel": "أضف اختصاص متجرك الافتراضي *",
  "settings.customSpecialtyPlaceholder": "مثال: أجهزة طبية، معدات مطاعم...",
  "settings.virtualStoreAdvantages": "مزايا المتجر الافتراضي:",
  "settings.advantage1": "الشراء من تجار الجملة بأسعار مميزة",
  "settings.advantage2": "صفحة متجر خاصة بك",
  "settings.advantage3": "شارة متجر افتراضي على إعلاناتك",
  "settings.advantage4": "إمكانية إعادة بيع المنتجات",
  "settings.activating": "جاري التفعيل...",
  "settings.phoneUpdateDesc": "تحديث رقم هاتفك المستخدم لتسجيل الدخول",
  "settings.phoneHint": "رقم الهاتف العراقي (يبدأ بـ 07)",
  "settings.updating": "جاري التحديث...",
  "settings.updatePhone": "تحديث رقم الهاتف",
  "settings.emailDesc": "تحديث بريدك الإلكتروني (اختياري)",
  "settings.updateEmail": "تحديث البريد الإلكتروني",
  "settings.passwordDesc": "تغيير كلمة المرور الخاصة بحسابك",
  "settings.confirmNewPassword": "تأكيد كلمة المرور الجديدة",
  "settings.confirmNewPasswordPlaceholder": "أعد إدخال كلمة المرور الجديدة",
  "settings.currentPasswordPlaceholder": "أدخل كلمة المرور الحالية",
  "settings.newPasswordPlaceholder": "أدخل كلمة المرور الجديدة (6 خانات على الأقل)",
  "settings.passwordHint": "كلمة المرور يجب أن تكون 6 أرقام على الأقل",
  "settings.changing": "جاري التغيير...",
  "settings.passwordChanged": "تم التغيير",
  "settings.passwordChangedDesc": "تم تغيير كلمة المرور بنجاح",
  "settings.passwordMismatch": "كلمة المرور الجديدة غير متطابقة",
  "settings.requestSent": "تم الإرسال",
  "settings.requestSentDesc": "تم إرسال طلب التعديل بنجاح. سيتم مراجعته من قبل الإدارة.",
  "settings.editRequestFailed": "فشل إرسال طلب التعديل",
  "settings.activateStoreFailed": "فشل تفعيل المتجر الافتراضي",
  "settings.storeActivatedTitle": "تم تفعيل المتجر",
  "settings.storeInfoUpdated": "تم تحديث معلومات المتجر بنجاح",
  "settings.phoneUpdated": "تم تحديث رقم الهاتف بنجاح",
  "settings.phoneUpdateFailed": "فشل تحديث رقم الهاتف",
  "settings.emailUpdated": "تم تحديث البريد الإلكتروني بنجاح",
  "settings.emailUpdateFailed": "فشل تحديث البريد الإلكتروني",
  "settings.passwordChangeFailed": "فشل تغيير كلمة المرور",
  "settings.legal": "السياسات والشروط",
  "settings.deleteAccount": "حذف الحساب",
  "settings.deleteAccountDesc": "حذف حسابك نهائياً وجميع بياناتك",
  "settings.deleteAccountWarning": "سيتم حذف جميع إعلاناتك وطلباتك ومحادثاتك وبيانات حسابك بشكل نهائي. لا يمكن التراجع عن هذا الإجراء.",
  "settings.confirmDeleteAccount": "تأكيد حذف الحساب",
  "settings.confirmDeleteDesc": "هذا الإجراء لا يمكن التراجع عنه. سيتم حذف حسابك وجميع بياناتك نهائياً.",
  "settings.enterPasswordToConfirm": "أدخل كلمة المرور للتأكيد",
  "settings.deletingAccount": "جاري حذف الحساب...",
  "settings.deleteAccountBtn": "حذف حسابي نهائياً",
  "settings.accountDeleted": "تم حذف حسابك بنجاح",
  "auth.agreeToTerms": "بالتسجيل فإنك توافق على",
  "auth.termsOfService": "شروط الاستخدام",
  "auth.and": "و",
  "auth.privacyPolicy": "سياسة الخصوصية",
  "auth.disclaimer": "الموقع لا يتحمل أي مسؤولية قانونية عن أي تلاعب أو غش يحدث من قبل الناشرين سواء كانوا زبائن أو أصحاب متاجر افتراضية أو محلات مفرد أو تجار جملة. يجب على المشتري التأكد والتحقق من المنتج والبائع قبل إتمام عملية الشراء. سوق العراق يخلي مسؤوليته القانونية تماماً ولا يتحمل أي مسؤولية عن المعاملات بين المستخدمين.",
  "settings.customSpecialtyRequired": "اختصاص مخصص *",
  "messages.title": "محادثاتي",
  "messages.noMessages": "لا توجد رسائل",
  "messages.typeMessage": "اكتب رسالة...",
  "messages.send": "إرسال",
  "messages.online": "متصل",
  "messages.offline": "غير متصل",
  "messages.newMessage": "رسالة جديدة",
  "messages.conversations": "المحادثات",
  "messages.noConversations": "لا توجد محادثات",
  "messages.searchMessages": "البحث في الرسائل",
  "messages.deleteConversation": "حذف المحادثة",
  "messages.you": "أنت",
  "messages.selectConversation": "اختر محادثة للبدء",
  "messages.yourMessages": "محادثاتي",
  "messages.loginToView": "سجل دخولك لعرض محادثاتك.",
  "messages.noMessagesYet": "لا توجد محادثات بعد",
  "messages.contactSellers": "تواصل مع البائعين لبدء محادثة!",
  "messages.browseListings": "تصفح الإعلانات",
  "messages.selectToView": "اختر محادثة لعرضها",
  "messages.user": "مستخدم",
  "messages.virtualStore": "متجر افتراضي",
  "messages.retailShop": "محل مفرد",
  "messages.wholesaler": "تاجر جملة",
  "favorites.title": "المفضلة",
  "favorites.noFavorites": "لا توجد إعلانات في المفضلة",
  "favorites.browseListings": "تصفح الإعلانات",
  "orders.title": "مشترياتي",
  "orders.noOrders": "لا توجد طلبات",
  "orders.orderNumber": "رقم الطلب",
  "orders.orderDate": "تاريخ الطلب",
  "orders.status": "الحالة",
  "orders.pending": "معلق",
  "orders.confirmed": "مؤكد",
  "orders.shipped": "تم التسليم لمندوب التوصيل",
  "orders.deliveryOtpLabel": "رمز الاستلام الخاص بك",
  "orders.deliveryOtpWarning": "⚠️ لا تُعطِ هذا الرمز للمندوب إلا بعد استلام المنتج والتحقق منه",
  "orders.delivered": "تم التوصيل",
  "orders.cancelled": "ملغي",
  "orders.statusPending": "معلق",
  "orders.statusDelivered": "تم التوصيل",
  "orders.statusRejected": "مرفوض",
  "orders.statusCancelledByYou": "ألغيت الطلب",
  "orders.statusAwaitingReview": "قيد الانتظار",
  "orders.statusApproved": "تمت الموافقة",
  "orders.statusApprovedShort": "موافق عليه",
  "orders.statusDismissed": "مرفوض",
  "orders.statusPaid": "مدفوع",
  "orders.statusPendingShort": "معلق",
  "orders.statusDeliveredShort": "تم التوصيل",
  "orders.total": "المجموع",
  "orders.items": "المنتجات",
  "orders.trackOrder": "تتبع الطلب",
  "orders.cancelOrder": "إلغاء الطلب",
  "orders.cancelConfirmTitle": "تأكيد إلغاء الطلب",
  "orders.cancelConfirmMessage": "هل أنت متأكد من إلغاء هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء.",
  "orders.cancelSuccess": "تم إلغاء الطلب بنجاح",
  "orders.cancelledByBuyer": "تم الإلغاء من قبل المشتري",
  "orders.buyerOrders": "طلبات المشترين",
  "orders.sellerOrders": "طلبات البائعين",
  "orders.processing": "قيد المعالجة",
  "orders.deliveryToken": "رمز التسليم",
  "orders.acceptOrder": "قبول الطلب",
  "orders.rejectOrder": "رفض الطلب",
  "orders.shipOrder": "شحن الطلب",
  "orders.buyer": "المشتري",
  "orders.orderDetails": "تفاصيل الطلب",
  "orders.shippingAddress": "عنوان الشحن",
  "orders.paymentMethod": "طريقة الدفع",
  "orders.loginRequired": "يجب تسجيل الدخول لعرض طلباتك",
  "orders.login": "تسجيل الدخول",
  "orders.backToHome": "العودة للرئيسية",
  "orders.noOrdersMade": "لم تقم بأي طلبات بعد",
  "orders.browseProducts": "تصفح المنتجات",
  "orders.order": "طلب",
  "orders.quantity": "الكمية",
  "orders.notes": "ملاحظات",
  "orders.awaitingConfirmation": "بانتظار التأكيد",
  "orders.awaitingPayment": "بانتظار الدفع",
  "orders.paymentPaid": "مدفوع",
  "orders.paymentFailed": "فشل الدفع",
  "orders.cashOnDelivery": "الدفع عند الاستلام",
  "orders.asiaHawala": "آسيا حوالة",
  "orders.bankTransferMethod": "تحويل بنكي",
  "inventory.title": "مخزون متجري",
  "inventory.addProduct": "إضافة منتج",
  "inventory.editProduct": "تعديل المنتج",
  "inventory.deleteProduct": "حذف المنتج",
  "inventory.stock": "المخزون",
  "inventory.resalePrice": "سعر البيع",
  "inventory.profit": "الربح",
  "inventory.noProducts": "لا توجد منتجات في المتجر",
  "inventory.browseWholesale": "تصفح منتجات الجملة",
  "inventory.quantity": "الكمية",
  "inventory.wholesalePrice": "سعر الجملة",
  "inventory.wholesaleSource": "مصدر الجملة",
  "inventory.wholesaleSourceHint": "السوق الذي عُرض فيه منتج الجملة، وليس بالضرورة بلد التصنيع",
  "inventory.yourPrice": "سعرك",
  "inventory.originalProduct": "المنتج الأصلي",
  "inventory.updateStock": "تحديث المخزون",
  "inventory.removeProduct": "إزالة المنتج",
  "dashboard.title": "لوحة التحكم",
  "dashboard.sellerDashboard": "لوحة تحكم البائع",
  "dashboard.supplierDashboard": "لوحة تحكم الموردين",
  "dashboard.totalSales": "إجمالي المبيعات",
  "dashboard.totalOrders": "إجمالي الطلبات",
  "dashboard.totalProducts": "إجمالي المنتجات",
  "dashboard.totalRevenue": "إجمالي الإيرادات",
  "dashboard.recentOrders": "الطلبات الأخيرة",
  "dashboard.statistics": "الإحصائيات",
  "dashboard.pendingOrders": "الطلبات المعلقة",
  "dashboard.completedOrders": "الطلبات المكتملة",
  "dashboard.partnerStores": "المتاجر الشريكة",
  "dashboard.notifications": "الإشعارات",
  "dashboard.merchantNotifications": "إشعارات التاجر",
  "dashboard.virtualShopNotifications": "إشعارات متجرك",
  "dashboard.virtualShopNotificationsEmpty":
    "ستظهر هنا إشعارات الطلبات والرسائل والتحديثات المتعلقة بمتجرك الافتراضي.",
  "dashboard.myProducts": "إعلاناتي الشخصية",
  "dashboard.orderManagement": "إدارة الطلبات",
  "market.shorjaPage": "سوق الشورجة",
  "market.baghdad": "أسواق بغداد",
  "market.iraqWholesale": "سوق جملة العراق",
  "market.china": "سوق الصين",
  "market.turkey": "سوق تركيا",
  "market.friday": "سوق الجمعة للعروض والمواد المستعملة",
  "market.fridayBadge": "سوق الجمعة",
  "market.fridayExpiry": "ينتهي اليوم",
  "market.today": "منتجات اليوم",
  "market.allProducts": "جميع المنتجات",
  "market.noProducts": "لا توجد منتجات",
  "market.productsCount": "منتجات",
  "market.searchProducts": "البحث في المنتجات",
  "market.filterByCategory": "تصفية حسب القسم",
  "market.wholesaleMarkets": "أسواق الجملة",
  "market.browseProducts": "تصفح المنتجات",
  "market.allCategories": "جميع الأقسام",
  "market.productAvailable": "منتج متوفر",
  "market.addWholesaleGoodsHere": "أضف بضاعتك في هذا السوق",
  "market.suppliersTitle": "موردو هذا السوق",
  "market.storeOwnersOnly": "قسم خاص بأصحاب المتاجر",
  "market.wholesaleProtection": "لحماية أسعار الجملة، يجب أن يكون لديك متجر افتراضي أو محل مسجل لمشاهدة هذه المنتجات وأسعارها",
  "market.openVirtualStore": "فتح متجر افتراضي",
  "market.registerAsMerchant": "سجل كتاجر جملة",
  "market.registerMerchantDesc": "انضم كتاجر جملة واعرض منتجاتك في أسواق الجملة",
  "market.backToHome": "العودة للرئيسية",
  "market.noProductsNow": "لا توجد منتجات حالياً",
  "market.noIraqWholesaleProducts": "لم يتم العثور على منتجات من تجار الجملة العراقيين بعد",
  "market.noChinaProducts": "لم يتم العثور على منتجات من الصين بعد",
  "market.noTurkeyProducts": "لم يتم العثور على منتجات من تركيا بعد",
  "market.browseAllProducts": "تصفح جميع المنتجات",
  "market.iraqWholesaleDesc": "تجار الجملة العراقيين - أفضل الأسعار للكميات الكبيرة",
  "market.chinaDesc": "منتجات مستوردة من الصين بأسعار الجملة - تسوّق وأعد البيع في العراق",
  "market.turkeyDesc": "منتجات تركية أصلية بأسعار الجملة - ملابس، أثاث، مواد غذائية وأكثر",
  "market.todayTitle": "منتجات المحلات الافتراضية اليوم",
  "market.todayMerchantTitle": "منتجات اليوم من التجار",
  "market.todayMerchantDesc": "منتجات مضافة اليوم من التجار ومناسبة للمتاجر الافتراضية",
  "market.todayDesc": "تصفح أحدث منتجات المحلات الافتراضية المضافة اليوم لزيادة فرص بيعها",
  "market.allProductsDesc": "تصفح جميع الإعلانات المتاحة في سوق العراق",
  "market.searchAndFilter": "البحث والفلترة",
  "market.categories": "الأقسام",
  "market.foundListingsToday": "تم العثور على {count} منتج من المحلات الافتراضية اليوم",
  "market.foundListings": "تم العثور على {count} إعلان",
  "market.listing": "إعلان",
  "market.priceRange": "السعر: {min} - {max} د.ع",
  "market.noListingsToday": "لا توجد منتجات للمحلات الافتراضية اليوم",
  "market.noMatchingListings": "لم يتم العثور على إعلانات تطابق معايير البحث. جرب تغيير الفلاتر.",
  "market.noNewListingsToday": "لم تتم إضافة منتجات جديدة من المحلات الافتراضية اليوم.",
  "market.clearAllFilters": "مسح جميع الفلاتر",
  "market.clearFilters": "مسح الفلاتر",
  "market.browseAllListings": "تصفح جميع الإعلانات",
  "market.noListingsFound": "لم يتم العثور على إعلانات",
  "market.noListingsMatchSearch": "لم يتم العثور على إعلانات تطابق معايير البحث. جرب تغيير الفلاتر أو البحث بكلمات مختلفة.",
  "market.home": "الرئيسية",
  "market.fridayClosed": "سوق الجمعة مغلق حالياً",
  "market.howFridayWorks": "كيف يعمل سوق الجمعة؟",
  "market.fridayDescription": "سوق الجمعة سوق خاص يعمل فقط يوم الجمعة حسب توقيت العراق من 00:00 حتى 23:59. الإعلانات المنشورة من داخله تظهر داخل سوق الجمعة فقط، ولا تدخل القوائم العامة أو البحث العادي.",
  "market.timeUntilOpening": "الوقت المتبقي حتى افتتاح السوق",
  "market.day": "يوم",
  "market.hour": "ساعة",
  "market.minute": "دقيقة",
  "market.second": "ثانية",
  "market.marketOpensOn": "سيفتح السوق يوم:",
  "market.fridayDesc": "سوق المستعمل الأصيل — يظهر فقط يوم الجمعة من 00:00 إلى 23:59 بتوقيت العراق",
  "market.fridayRulesTitle": "قواعد سوق الجمعة للعروض والمستعمل",
  "market.fridayRule1": "النشر في سوق الجمعة يتم من داخل هذه الصفحة فقط",
  "market.fridayRule2": "إعلان سوق الجمعة يظهر فقط داخل هذا السوق ويختفي تلقائياً عند نهاية يوم الجمعة",
  "market.fridayRule3": "أي إعلان يُنشر خارج سوق الجمعة يُعامل كنشر عادي ولا يظهر هنا",
  "market.addYourProduct": "أضف منتجك المستعمل الآن",
  "market.addYourProductDesc": "أضف إعلانك هنا ليظهر داخل سوق الجمعة فقط خلال يوم الجمعة حسب توقيت العراق",
  "listing.scheduledForFriday": "سيظهر إعلانك تلقائياً مع بداية يوم الجمعة القادم",
  "listing.scheduledDesc": "أكمل النشر الآن، وسيظهر إعلانك داخل سوق الجمعة فقط عند بداية يوم الجمعة بتوقيت العراق، ثم يختفي تلقائياً عند نهاية اليوم.",
  "market.scheduledPreview": "ينتظر الجمعة القادمة",
  "market.comingFriday": "الجمعة القادمة",
  "market.scheduleForFriday": "انشر منتجاً ليظهر يوم الجمعة 🕌",
  "market.marketOpenNow": "السوق مفتوح الآن",
  "market.marketOpen": "السوق مفتوح",
  "market.canBrowseUntilEnd": "يمكنك إضافة وتصفح إعلانات سوق الجمعة فقط حتى نهاية اليوم بتوقيت العراق",
  "market.searchFilters": "فلاتر البحث",
  "market.foundFridayListings": "تم العثور على {count} إعلان في سوق الجمعة",
  "market.noFridayListings": "لا توجد إعلانات في سوق الجمعة",
  "market.noFridayListingsYet": "لم يتم إضافة أي إعلانات اليوم. أضف إعلانك الآن!",
  "market.addListingNow": "أضف إعلانك الآن",
  "search.title": "البحث المتقدم",
  "search.keyword": "الكلمة المفتاحية",
  "search.searchPlaceholder": "ابحث عن...",
  "search.minPrice": "الحد الأدنى للسعر",
  "search.maxPrice": "الحد الأقصى للسعر",
  "search.allConditions": "الكل",
  "search.results": "نتائج البحث",
  "search.noResults": "لا توجد نتائج",
  "search.filter": "تصفية",
  "search.sort": "ترتيب",
  "search.sortNewest": "الأحدث",
  "search.sortOldest": "الأقدم",
  "search.sortPriceAsc": "السعر: من الأقل",
  "search.sortPriceDesc": "السعر: من الأعلى",
  "search.reset": "إعادة تعيين",
  "wallet.title": "المحفظة",
  "wallet.balance": "الرصيد",
  "wallet.withdraw": "سحب",
  "wallet.deposit": "إيداع",
  "wallet.transactions": "المعاملات",
  "wallet.noTransactions": "لا توجد معاملات",
  "wallet.withdrawRequest": "طلب سحب",
  "wallet.amount": "المبلغ",
  "wallet.pendingWithdrawals": "سحوبات معلقة",
  "wallet.totalEarnings": "إجمالي الأرباح",
  "wallet.platformCommission": "عمولة المنصة",
  "wallet.netProfit": "صافي الربح",
  "wallet.availableBalance": "الرصيد المتاح",
  "wallet.withdrawMin": "الحد الأدنى للسحب",
  "wallet.withdrawSuccess": "تم إرسال طلب السحب بنجاح",
  "wallet.insufficientBalance": "الرصيد غير كافي",
  "wallet.myWallet": "محفظتي",
  "wallet.totalBalance": "الرصيد الإجمالي",
  "wallet.availableForWithdraw": "الرصيد المتاح للسحب",
  "wallet.lockedBalance": "رصيد محجوز",
  "wallet.pendingPayouts": "طلبات سحب قيد المعالجة",
  "wallet.requestPayout": "طلب سحب الأرباح",
  "wallet.transactionLog": "سجل المعاملات",
  "wallet.allFinancialOps": "جميع العمليات المالية على محفظتك",
  "wallet.noTransactionsYet": "لا توجد معاملات بعد",
  "wallet.payoutRequests": "طلبات السحب",
  "wallet.allPayoutRequests": "جميع طلبات سحب الأرباح",
  "wallet.noPayoutRequests": "لا توجد طلبات سحب بعد",
  "wallet.loginRequired": "يجب تسجيل الدخول",
  "wallet.loginToView": "قم بتسجيل الدخول لعرض محفظتك",
  "wallet.underReview": "قيد المراجعة",
  "wallet.approved": "تمت الموافقة",
  "wallet.paid": "تم الدفع",
  "wallet.rejected": "مرفوض",
  "wallet.zainCash": "زين كاش",
  "wallet.bankTransfer": "حوالة مصرفية",
  "wallet.cash": "نقداً",
  "wallet.enterValidAmount": "أدخل مبلغاً صحيحاً",
  "wallet.amountExceedsBalance": "المبلغ أكبر من الرصيد المتاح",
  "wallet.requestSent": "تم إرسال الطلب",
  "wallet.requestSentDesc": "سيتم مراجعة طلب السحب وإعلامك بالنتيجة",
  "wallet.withdrawAmount": "المبلغ المطلوب سحبه",
  "wallet.enterAmount": "أدخل المبلغ",
  "wallet.withdrawMethod": "طريقة السحب",
  "wallet.selectMethod": "اختر طريقة السحب",
  "wallet.phoneZainCash": "رقم الهاتف (زين كاش)",
  "wallet.additionalNotes": "ملاحظات إضافية",
  "wallet.additionalDetails": "أي تفاصيل إضافية...",
  "wallet.sendRequest": "إرسال الطلب",
  "wallet.requestDate": "تاريخ الطلب",
  "wallet.rejectionReason": "سبب الرفض",
  "wallet.paymentDate": "تاريخ الدفع",
  "wallet.availableForWithdrawLabel": "الرصيد المتاح للسحب",
  "cart.title": "سلة المشتريات",
  "cart.empty": "السلة فارغة",
  "cart.total": "المجموع",
  "cart.checkout": "إتمام الشراء",
  "cart.remove": "إزالة",
  "cart.quantity": "الكمية",
  "cart.continueShopping": "متابعة التسوق",
  "cart.items": "منتجات",
  "cart.addedToCart": "تمت الإضافة إلى السلة",
  "cart.differentSeller": "سلتك تحتوي على منتجات من بائع آخر",
  "cart.differentSellerDesc": "لا يمكن إضافة منتجات من بائعين مختلفين في نفس الطلب. هل تريد إفراغ السلة وإضافة هذا المنتج؟",
  "cart.clearAndAdd": "إفراغ السلة وإضافة المنتج",
  "cart.keepCart": "الاحتفاظ بالسلة الحالية",
  "checkout.title": "إتمام الشراء",
  "checkout.orderSummary": "ملخص الطلب",
  "checkout.shippingInfo": "معلومات الشحن",
  "checkout.paymentMethod": "طريقة الدفع",
  "checkout.cashOnDelivery": "الدفع عند الاستلام",
  "checkout.creditCard": "بطاقة ائتمان",
  "checkout.walletBalance": "رصيد المحفظة",
  "checkout.placeOrder": "تأكيد الطلب",
  "checkout.orderSuccess": "تم تأكيد الطلب بنجاح",
  "checkout.name": "الاسم",
  "checkout.address": "العنوان",
  "checkout.phone": "رقم الهاتف",
  "checkout.notes": "ملاحظات",
  "checkout.city": "المدينة",
  "checkout.area": "القضاء",
  "checkout.subtotal": "المجموع الفرعي",
  "checkout.shipping": "الشحن",
  "checkout.freeShipping": "مجاني",
  "contact.title": "اتصل بنا",
  "contact.name": "الاسم",
  "contact.email": "البريد الإلكتروني",
  "contact.message": "الرسالة",
  "contact.send": "إرسال",
  "contact.subject": "الموضوع",
  "contact.success": "تم إرسال رسالتك بنجاح",
  "contact.whatsapp": "تواصل عبر واتساب",
  "contact.phone": "رقم الهاتف",
  "contact.subtitle": "نحن هنا لمساعدتك. أرسل لنا رسالتك وسنتواصل معك في أقرب وقت ممكن.",
  "contact.sendMessage": "أرسل رسالة",
  "contact.formDescription": "املأ النموذج أدناه وسنرد عليك في أقرب وقت",
  "contact.fullName": "الاسم الكامل",
  "contact.submitting": "جاري الإرسال...",
  "contact.sendTheMessage": "إرسال الرسالة",
  "contact.contactInfo": "معلومات التواصل",
  "contact.address": "العنوان",
  "contact.addressValue": "بغداد، العراق",
  "contact.liveChat": "محادثة مباشرة",
  "contact.liveChatDesc": "تواصل مباشرة مع فريق الدعم عبر الدردشة الفورية",
  "contact.startChat": "بدء المحادثة",
  "contact.error": "خطأ",
  "contact.requiredFields": "يرجى ملء جميع الحقول المطلوبة",
  "contact.sent": "تم الإرسال",
  "contact.sentSuccess": "تم إرسال رسالتك بنجاح، سنتواصل معك قريباً",
  "contact.sendError": "حدث خطأ أثناء إرسال الرسالة",
  "compare.title": "المقارنة",
  "compare.noItems": "لا توجد إعلانات للمقارنة",
  "compare.addToCompare": "أضف للمقارنة",
  "compare.removeFromCompare": "إزالة من المقارنة",
  "compare.maxItems": "الحد الأقصى للمقارنة",
  "compare.compareListings": "مقارنة الإعلانات",
  "compare.cleared": "تم مسح قائمة المقارنة",
  "compare.clearAll": "مسح الكل",
  "compare.addSameCategory": "أضف إعلانات من نفس الفئة لمقارنتها",
  "compare.browseListings": "تصفح الإعلانات",
  "compare.specs": "المواصفات",
  "compare.price": "السعر",
  "compare.location": "الموقع",
  "compare.date": "التاريخ",
  "compare.brand": "الماركة",
  "compare.year": "سنة الصنع",
  "compare.mileage": "المسافة المقطوعة",
  "compare.fuelType": "نوع الوقود",
  "compare.transmission": "ناقل الحركة",
  "compare.color": "اللون",
  "compare.condition": "الحالة",
  "compare.rooms": "عدد الغرف",
  "compare.area": "المساحة",
  "compare.buildingAge": "عمر البناء",
  "compare.floor": "الطابق",
  "alerts.title": "تنبيهاتي",
  "alerts.noAlerts": "لا توجد تنبيهات",
  "alerts.priceAlert": "تنبيه السعر",
  "alerts.searchAlert": "تنبيه البحث",
  "alerts.deleteAlert": "حذف التنبيه",
  "alerts.priceDropped": "انخفض السعر",
  "alerts.newResults": "نتائج جديدة",
  "alerts.loginRequired": "يجب تسجيل الدخول",
  "alerts.loginToManage": "سجل دخولك لإدارة تنبيهاتك",
  "alerts.login": "تسجيل الدخول",
  "alerts.myAlerts": "تنبيهاتي",
  "alerts.priceAlerts": "تنبيهات الأسعار",
  "alerts.searchAlerts": "تنبيهات البحث",
  "alerts.noPriceAlerts": "لا توجد تنبيهات أسعار",
  "alerts.addPriceAlertDesc": "أضف تنبيه سعر من صفحة أي إعلان لتتلقى إشعاراً عند انخفاض السعر",
  "alerts.browseListings": "تصفح الإعلانات",
  "alerts.noSearchAlerts": "لا توجد تنبيهات بحث",
  "alerts.createSearchAlertDesc": "أنشئ تنبيه بحث لتتلقى إشعاراً عند إضافة إعلانات جديدة تطابق معاييرك",
  "alerts.addSearchAlert": "إضافة تنبيه بحث",
  "alerts.currentPrice": "السعر الحالي",
  "alerts.targetPrice": "السعر المستهدف",
  "alerts.priceReachedTarget": "السعر وصل للهدف!",
  "alerts.listingDeleted": "الإعلان محذوف",
  "alerts.alertDeleted": "تم حذف التنبيه",
  "alerts.createSearchAlert": "إنشاء تنبيه بحث",
  "alerts.notifyNewListings": "سنعلمك عند إضافة إعلانات جديدة تطابق معاييرك",
  "alerts.alertName": "اسم التنبيه *",
  "alerts.alertNamePlaceholder": "مثال: سيارات تويوتا في بغداد",
  "alerts.category": "الفئة",
  "alerts.allCategories": "جميع الفئات",
  "alerts.province": "المحافظة",
  "alerts.allCities": "جميع المدن",
  "alerts.keywords": "كلمات مفتاحية",
  "alerts.keywordsPlaceholder": "مثال: كامري، لاند كروزر",
  "alerts.minPrice": "الحد الأدنى للسعر",
  "alerts.maxPrice": "الحد الأقصى للسعر",
  "alerts.enterAlertName": "أدخل اسم التنبيه",
  "alerts.searchAlertCreated": "تم إنشاء تنبيه البحث",
  "alerts.createAlertFailed": "فشل في إنشاء التنبيه",
  "map.title": "خريطة الإعلانات",
  "map.noListings": "لا توجد إعلانات على الخريطة",
  "map.showList": "عرض القائمة",
  "map.showMap": "عرض الخريطة",
  "delivery.title": "تأكيد التوصيل",
  "delivery.token": "رمز التسليم",
  "delivery.orderId": "رقم الطلب",
  "delivery.lastFourDigits": "آخر 4 أرقام من هاتف المشتري",
  "delivery.confirm": "تأكيد التسليم",
  "delivery.success": "تم تأكيد التوصيل بنجاح",
  "workWithUs.title": "انضم للعمل معنا",
  "workWithUs.subtitle": "انضم إلى فريق سوق العراق",
  "workWithUs.applyNow": "قدم الآن",
  "workWithUs.openRetailStore": "افتح محل مفرد",
  "workWithUs.openVirtualStore": "افتح متجر افتراضي",
  "workWithUs.becomeWholesaler": "كن تاجر جملة",
  "workWithUs.benefits": "المزايا",
  "workWithUs.howItWorks": "كيف يعمل",
  "sort.oldest": "من الأقدم إلى الأحدث تاريخاً",
  "sort.priceAsc": "السعر: من الأقل للأعلى",
  "sort.priceDesc": "السعر: من الأعلى للأقل",
  "sort.popular": "الأكثر شعبية",
  "sort.sortBy": "ترتيب حسب",
  "recent.title": "شوهد مؤخراً",
  "recent.noItems": "لا توجد إعلانات تم مشاهدتها",
  "recent.clearAll": "مسح الكل",
  "recent.viewedRecently": "شاهدتها مؤخراً",
  "recent.clearHistory": "مسح السجل",
  "recent.noRecentViews": "لا توجد مشاهدات حديثة",
  "recent.startBrowsing": "ابدأ بتصفح الإعلانات وستظهر هنا",
  "recent.browseListings": "تصفح الإعلانات",
  "recent.historyClear": "تم مسح سجل المشاهدات",
  "recent.viewedOn": "شوهد",
  "notFound.title": "الصفحة غير موجودة",
  "notFound.description": "الصفحة التي تبحث عنها غير موجودة",
  "notFound.backHome": "العودة للرئيسية",
  "upload.dragDrop": "اسحب وأفلت الصور هنا",
  "upload.or": "أو",
  "upload.browse": "استعرض الملفات",
  "upload.maxSize": "الحجم الأقصى",
  "upload.maxFiles": "الحد الأقصى للملفات",
  "upload.uploading": "جاري الرفع...",
  "upload.uploadSuccess": "تم الرفع بنجاح",
  "upload.uploadFailed": "فشل الرفع",
  "wholesale.addToStore": "إضافة إلى متجرك",
  "wholesale.setPrice": "حدد سعر البيع",
  "wholesale.minQuantity": "الحد الأدنى للكمية",
  "wholesale.addSuccess": "تمت إضافة المنتج إلى متجرك",
  "wholesale.commission": "عمولة المنصة",
  "wholesale.yourProfit": "ربحك",
  "admin.title": "لوحة الإدارة",
  "admin.users": "المستخدمين",
  "admin.listings": "الإعلانات",
  "admin.categories": "الأقسام",
  "admin.reports": "التقارير",
  "admin.settings": "الإعدادات",
  "admin.approve": "موافقة",
  "admin.reject": "رفض",
  "admin.ban": "حظر",
  "admin.unban": "إلغاء الحظر",
  "admin.totalUsers": "إجمالي المستخدمين",
  "admin.totalListings": "إجمالي الإعلانات",
  "admin.activeListings": "الإعلانات النشطة",
  "admin.pendingApproval": "بانتظار الموافقة",
  "admin.payoutRequests": "طلبات السحب",
  "admin.passwordRecovery": "استعادة كلمات المرور",
  "admin.featured": "الإعلانات المميزة",
  "admin.support": "الدعم الفني",
  "install.title": "تثبيت التطبيق",
  "install.description": "أضف سوق العراق إلى شاشتك الرئيسية",
  "install.ios": "لأجهزة آيفون",
  "install.android": "لأجهزة أندرويد",
  "share.title": "مشاركة",
  "share.copyLink": "نسخ الرابط",
  "share.copied": "تم نسخ الرابط",
  "priceAlert.title": "تنبيه انخفاض السعر",
  "priceAlert.setAlert": "تفعيل التنبيه",
  "priceAlert.targetPrice": "السعر المستهدف",
  "priceAlert.success": "تم تفعيل تنبيه السعر",
  "rating.title": "تقييم البائع",
  "rating.reviews": "التقييمات",
  "rating.noReviews": "لا توجد تقييمات",
  "rating.writeReview": "اكتب تقييماً",
  "rating.stars": "نجوم",
  "feature.title": "تمييز الإعلان",
  "feature.promote": "ترويج",
  "feature.featured": "مميز",
  "feature.duration": "المدة",
  "feature.days": "أيام",
  "myListings.title": "إعلانات بضاعتي الخاصة",
  "myListings.noListings": "ليس لديك إعلانات",
  "myListings.createFirst": "أنشئ إعلانك الأول",
  "myListings.active": "نشط",
  "myListings.pending": "معلق",
  "myListings.expired": "منتهي",
  "myListings.manageListings": "إدارة إعلاناتك",
  "myListings.loginToManage": "سجل دخولك لعرض وإدارة إعلاناتك.",
  "myListings.noListingsYet": "لا توجد إعلانات",
  "myListings.createFirstDesc": "أنشئ منتجك الأول لبدء البيع من خلال زر 'أضف منتجك من هنا' في الأعلى!",
  "myListings.back": "رجوع",
  "myListings.fetchError": "فشل في جلب الإعلانات",
  "registerChoice.title": "انضم إلى سوق العراق",
  "registerChoice.customer": "تسجيل كزبون",
  "registerChoice.customerDesc": "شراء المنتجات وإمكانية فتح متجر افتراضي",
  "registerChoice.wholesale": "تسجيل كتاجر جملة",
  "registerChoice.wholesaleDesc": "لتجار الجملة والموردين",
  "virtualStore.title": "المتجر الافتراضي",
  "virtualStore.products": "منتجات المتجر",
  "virtualStore.noProducts": "لا توجد منتجات في هذا المتجر",
  "virtualStore.owner": "صاحب المتجر",
  "virtualStore.specialty": "الاختصاص",
  "virtualStore.contactStore": "تواصل مع المتجر",
  "virtualStore.visitStore": "زيارة المتجر",
  "virtualStore.storeNotFound": "المتجر غير موجود",
  "virtualStore.storeNotFoundDesc": "لم يتم العثور على هذا المتجر",
  "virtualStore.storeSuspended": "هذا المتجر موقوف",
  "virtualStore.storeSuspendedDesc": "تم إيقاف هذا المتجر من قِبَل الإدارة. يرجى التواصل مع الدعم.",
  "virtualStore.storeNotActive": "هذا المتجر غير نشط",
  "virtualStore.shopInMarket": "محل في",
  "virtualStore.backToHome": "العودة للرئيسية",
  "virtualStore.virtualStoreBadge": "متجر افتراضي",
  "virtualStore.verifiedStore": "متجر موثق",
  "virtualStore.featuredStore": "متجر مميز",
  "virtualStore.memberSince": "عضو منذ",
  "virtualStore.virtualStoreNotice": "هذا متجر افتراضي - البائع يعمل من خلال منصة سوق العراق ويبيع منتجات من التجار",
  "virtualStore.orderProduct": "طلب المنتج",
  "virtualStore.orderNow": "اطلب الآن",
  "virtualStore.outOfStock": "غير متوفر",
  "virtualStore.soldOut": "نفذت الكمية",
  "virtualStore.available": "متوفر",
  "virtualStore.fullName": "الاسم الكامل *",
  "virtualStore.phoneNumber": "رقم الهاتف *",
  "virtualStore.city": "المدينة *",
  "virtualStore.fullAddress": "العنوان الكامل *",
  "virtualStore.addressPlaceholder": "العنوان التفصيلي للتوصيل",
  "virtualStore.additionalNotes": "ملاحظات إضافية",
  "virtualStore.orderNotesPlaceholder": "أي ملاحظات خاصة بالطلب...",
  "virtualStore.total": "المجموع:",
  "virtualStore.confirmOrder": "تأكيد الطلب",
  "virtualStore.sending": "جاري الإرسال...",
  "virtualStore.orderSent": "تم إرسال الطلب بنجاح!",
  "virtualStore.orderSentDesc": "سيتواصل معك صاحب المتجر قريباً لتأكيد الطلب",
  "virtualStore.orderFailed": "فشل في إرسال الطلب",
  "virtualStore.editProduct": "تعديل المنتج",
  "virtualStore.deleteProduct": "حذف المنتج",
  "virtualStore.sellingPrice": "سعر البيع (د.ع) *",
  "virtualStore.availableQuantity": "الكمية المتوفرة",
  "virtualStore.saving": "جاري الحفظ...",
  "virtualStore.saveChanges": "حفظ التغييرات",
  "virtualStore.productUpdated": "تم تحديث المنتج بنجاح",
  "virtualStore.updateFailed": "فشل في تحديث المنتج",
  "virtualStore.deleteConfirm": "هل أنت متأكد من حذف هذا المنتج من متجرك؟",
  "virtualStore.deleteNote": "لن يتم حذف المنتج من مخزون التاجر، فقط من متجرك الافتراضي",
  "virtualStore.deleting": "جاري الحذف...",
  "virtualStore.yesDelete": "نعم، حذف المنتج",
  "virtualStore.productDeleted": "تم حذف المنتج من متجرك",
  "virtualStore.deleteFailed": "فشل في حذف المنتج",
  "virtualStore.noProductsYet": "لا توجد منتجات",
  "virtualStore.noProductsDesc": "لم يقم صاحب المتجر بإضافة منتجات بعد",
  "virtualStore.cityPlaceholder": "مثال: بغداد",
  "virtualStore.backToHomePage": "العودة للصفحة الرئيسية",
  "virtualStore.validationNameRequired": "الاسم مطلوب",
  "virtualStore.validationPhoneInvalid": "رقم الهاتف غير صحيح - يجب أن يبدأ بـ 07",
  "virtualStore.validationAddressRequired": "العنوان يجب أن يكون 10 أحرف على الأقل",
  "virtualStore.validationAddressInvalid": "يرجى إدخال عنوان حقيقي (يجب أن يحتوي على أحرف عربية أو أرقام)",
  "virtualStore.validationCityRequired": "المدينة مطلوبة",
  "virtualStore.validationQuantityMin": "الكمية يجب أن تكون 1 على الأقل",
  "virtualStore.validationPriceRequired": "السعر مطلوب",
  "virtualStore.validationQuantityZeroMin": "الكمية يجب أن تكون 0 أو أكثر",
  "virtualStore.storeOf": "متجر",
  "checkout.loginRequired": "يجب تسجيل الدخول لإتمام الشراء",
  "checkout.loginRequiredDesc": "سجل دخولك للاستفادة من جميع خدمات سوق العراق",
  "checkout.goToLogin": "تسجيل الدخول",
  "checkout.goToHome": "العودة للرئيسية",
  "checkout.emptyCart": "السلة فارغة",
  "checkout.emptyCartDesc": "أضف منتجات للسلة لإتمام عملية الشراء",
  "checkout.browseProducts": "تصفح المنتجات",
  "checkout.shippingDetails": "معلومات التوصيل",
  "checkout.fullName": "الاسم الكامل",
  "checkout.phoneNumber": "رقم الهاتف",
  "checkout.province": "المحافظة",
  "checkout.selectProvince": "اختر المحافظة",
  "checkout.selectArea": "اختر القضاء",
  "checkout.selectProvinceFirst": "اختر المحافظة أولاً",
  "checkout.neighborhood": "المحلة",
  "checkout.neighborhoodPlaceholder": "اسم أو رقم المحلة",
  "checkout.alley": "الزقاق",
  "checkout.alleyPlaceholder": "رقم أو اسم الزقاق",
  "checkout.house": "الدار",
  "checkout.housePlaceholder": "رقم الدار",
  "checkout.landmark": "أقرب نقطة دالة",
  "checkout.landmarkPlaceholder": "مثال: قرب جامع الرحمن، مقابل مدرسة النور...",
  "checkout.savedShippingBannerTitle": "عنوان التوصيل من طلبك السابق",
  "checkout.savedShippingBannerDesc": "تم تعبئة حقول المحافظة والقضاء والعنوان التفصيلي تلقائياً. يمكنك تعديلها أو مسحها وإدخال عنوان جديد.",
  "checkout.savedAddressesTitle": "عناوين محفوظة",
  "checkout.pickSavedAddress": "اختر عنواناً محفوظاً",
  "checkout.savedAddressNewManual": "عنوان جديد (يدوي)",
  "checkout.wholesaleShopAddressHint": "لطلبات الجملة المباشرة للمحل، يُفضّل اختيار نوع «محل» أو عنوان يصف الموقع التجاري بوضوح.",
  "checkout.saveCurrentAddressButton": "حفظ الحقول الحالية في دفتر العناوين",
  "checkout.saveAddressDialogTitle": "حفظ عنوان",
  "checkout.addressLabelField": "اسم العنوان (مثال: البيت، المحل)",
  "checkout.addressKindField": "نوع العنوان",
  "checkout.kindHome": "البيت",
  "checkout.kindShop": "المحل / العمل",
  "checkout.kindOther": "آخر",
  "checkout.saveAddressConfirm": "حفظ",
  "checkout.addressSavedToast": "تم حفظ العنوان",
  "checkout.manageAddresses": "إدارة العناوين المحفوظة",
  "checkout.deleteAddress": "حذف",
  "checkout.setAsDefault": "افتراضي",
  "checkout.defaultShort": "افتراضي",
  "checkout.saveAddressMissingFields": "يرجى تعبئة المحافظة والقضاء وجميع حقول العنوان التفصيلي قبل الحفظ.",
  "checkout.enterDifferentAddress": "مسح الحقول وإدخال عنوان جديد",
  "checkout.additionalNotes": "ملاحظات إضافية (اختياري)",
  "checkout.notesPlaceholder": "أي ملاحظات خاصة بالطلب...",
  "checkout.paymentMethodTitle": "طريقة الدفع",
  "checkout.cashOnDeliveryName": "الدفع عند الاستلام",
  "checkout.cashOnDeliveryDesc": "ادفع نقداً عند استلام طلبك",
  "checkout.creditCardName": "بطاقة ائتمانية",
  "checkout.creditCardDesc": "فيزا، ماستركارد، أو بطاقات أخرى",
  "checkout.zainCashName": "زين كاش",
  "checkout.zainCashDesc": "ادفع عبر تطبيق زين كاش",
  "checkout.asiaHawalaName": "آسيا حوالة",
  "checkout.asiaHawalaDesc": "تحويل عبر آسيا حوالة",
  "checkout.bankTransferName": "تحويل بنكي",
  "checkout.bankTransferDesc": "تحويل إلى حساب بنكي",
  "checkout.orderSummaryTitle": "ملخص الطلب",
  "checkout.quantityLabel": "الكمية:",
  "checkout.productCount": "عدد المنتجات:",
  "checkout.deliveryLabel": "التوصيل:",
  "checkout.deliveryTBD": "يُحدد لاحقاً",
  "checkout.totalLabel": "المجموع:",
  "checkout.placingOrder": "جاري إنشاء الطلب...",
  "checkout.confirmOrder": "تأكيد الطلب",
  "checkout.backToShopping": "العودة للتسوق",
  "checkout.orderCreated": "تم إنشاء الطلب بنجاح",
  "checkout.orderNumber": "رقم الطلب",
  "checkout.orderCreateError": "خطأ في إنشاء الطلب",
  "checkout.electronicPayment": "الدفع الإلكتروني",
  "checkout.orderNum": "طلب رقم:",
  "checkout.amountRequired": "المبلغ المطلوب",
  "checkout.cardNumber": "رقم البطاقة",
  "checkout.expiryDate": "تاريخ الانتهاء",
  "checkout.cvv": "رمز الأمان (CVV)",
  "checkout.cardHolder": "اسم حامل البطاقة",
  "checkout.cardHolderPlaceholder": "الاسم كما يظهر على البطاقة",
  "checkout.testModeTitle": "وضع تجريبي — الدفع الإلكتروني غير مفعّل بعد",
  "checkout.testModeNote": "هذه الصفحة في وضع تجريبي. لا يُطلب منك إدخال أي بيانات بطاقة ائتمانية. سيُؤكَّد طلبك تلقائياً بعد الضغط على الزر.",
  "checkout.processingPayment": "جاري معالجة الدفع...",
  "checkout.payNow": "ادفع الآن",
  "checkout.payLater": "الدفع لاحقاً (عند الاستلام)",
  "checkout.paymentSuccess": "تم الدفع بنجاح",
  "checkout.paymentSuccessDesc": "تم تأكيد الدفع وسيتم معالجة طلبك",
  "checkout.paymentError": "خطأ في عملية الدفع",
  "checkout.paymentErrorDesc": "حدث خطأ أثناء معالجة الدفع",
  "checkout.orderSuccessTitle": "تم إنشاء طلبك بنجاح!",
  "checkout.viewOrders": "متابعة طلباتي",
  "checkout.continueShopping": "متابعة التسوق",
  "checkout.cashOnDeliveryTitle": "الدفع عند الاستلام",
  "checkout.cashOnDeliveryStep1": "سيتم التواصل معك لتأكيد الطلب وترتيب التوصيل",
  "checkout.cashOnDeliveryStep2": "ادفع المبلغ نقداً عند استلام طلبك من مندوب التوصيل",
  "checkout.creditCardPaidTitle": "تم الدفع بالبطاقة الائتمانية",
  "checkout.creditCardPaidStep1": "تم استلام الدفع بنجاح وتأكيد طلبك",
  "checkout.creditCardPaidStep2": "سيتم تجهيز طلبك وشحنه في أقرب وقت",
  "checkout.zainCashTitle": "الدفع عبر زين كاش",
  "checkout.zainCashStep1": "حوّل المبلغ إلى رقم زين كاش: 07801234567",
  "checkout.zainCashStep3": "أرسل صورة إيصال التحويل عبر رسائل الموقع أو واتساب",
  "checkout.zainCashStep4": "سيتم تأكيد طلبك بعد التحقق من الدفع",
  "checkout.zainCashNote": "يرجى ذكر رقم الطلب عند التحويل",
  "checkout.asiaHawalaTitle": "الدفع عبر آسيا حوالة",
  "checkout.asiaHawalaStep1": "حوّل المبلغ عبر آسيا حوالة إلى الرقم: 07901234567",
  "checkout.asiaHawalaStep3": "أرسل رقم الحوالة عبر رسائل الموقع أو واتساب",
  "checkout.asiaHawalaStep4": "سيتم تأكيد طلبك بعد التحقق من الدفع",
  "checkout.bankTransferTitle": "التحويل البنكي",
  "checkout.bankName": "اسم البنك: مصرف الرشيد",
  "checkout.accountName": "اسم الحساب: شركة سوق العراق",
  "checkout.accountNumber": "رقم الحساب: 1234567890",
  "checkout.bankStep5": "أرسل صورة إيصال التحويل عبر رسائل الموقع",
  "checkout.bankNote": "يرجى ذكر رقم الطلب في خانة الملاحظات عند التحويل",
  "checkout.amountRequiredLabel": "المبلغ المطلوب:",
  "checkout.namePlaceholder": "أحمد محمد",
  "checkout.validationNameMin": "الاسم يجب أن يكون 3 أحرف على الأقل",
  "checkout.validationPhoneFormat": "رقم الهاتف يجب أن يبدأ بـ 07 ويتكون من 11 رقم",
  "checkout.validationProvinceRequired": "يرجى اختيار المحافظة",
  "checkout.validationAreaRequired": "يرجى اختيار القضاء",
  "checkout.validationNeighborhoodRequired": "يرجى إدخال اسم المحلة",
  "checkout.validationAlleyRequired": "يرجى إدخال رقم أو اسم الزقاق",
  "checkout.validationHouseRequired": "يرجى إدخال رقم الدار",
  "checkout.validationLandmarkRequired": "يرجى إدخال أقرب نقطة دالة",
  "checkout.validationPaymentRequired": "يرجى اختيار طريقة الدفع",
  "inventory.myInventory": "مخزني",
  "inventory.inventoryDesc": "المنتجات التي اشتريتها وخزنتها لإعادة البيع",
  "inventory.loginRequired": "يجب تسجيل الدخول",
  "inventory.loginRequiredDesc": "سجل دخولك لعرض مخزنك",
  "inventory.backToWorkWithUs": "العودة إلى صفحة انضم للعمل معنا",
  "inventory.stored": "مخزّن",
  "inventory.listedForSale": "معروض للبيع",
  "inventory.sold": "مباع",
  "inventory.purchasePrice": "سعر الشراء:",
  "inventory.sellingPrice": "سعر البيع:",
  "inventory.expectedProfit": "الربح المتوقع:",
  "inventory.listForSale": "اعرض للبيع",
  "inventory.listProductForSale": "عرض المنتج للبيع",
  "inventory.listProductDesc": "حدد السعر الذي تريد بيع المنتج به. سيتم عرضه في السوق كإعلان جديد.",
  "inventory.purchasePriceLabel": "سعر الشراء",
  "inventory.sellingPriceLabel": "سعر البيع (د.ع)",
  "inventory.enterSellingPrice": "أدخل سعر البيع",
  "inventory.expectedProfitLabel": "الربح المتوقع:",
  "inventory.listing": "جاري العرض...",
  "inventory.listNow": "عرض للبيع",
  "inventory.editPrice": "تعديل السعر",
  "inventory.editSellingPrice": "تعديل سعر البيع",
  "inventory.editSellingPriceDesc": "غيّر السعر الذي تريد بيع المنتج به",
  "inventory.currentPrice": "السعر الحالي",
  "inventory.newPriceLabel": "السعر الجديد (د.ع)",
  "inventory.enterNewPrice": "أدخل السعر الجديد",
  "inventory.updating": "جاري التحديث...",
  "inventory.updatePrice": "تحديث السعر",
  "inventory.removing": "إزالة...",
  "inventory.removeFromSale": "إزالة من البيع",
  "inventory.viewListing": "عرض الإعلان",
  "inventory.soldSuccess": "تم البيع بنجاح",
  "inventory.emptyInventory": "مخزنك فارغ",
  "inventory.emptyInventoryDesc": "لم تشتري أي منتجات بعد. تصفح السوق واشتري المنتجات لتخزينها وإعادة بيعها.",
  "inventory.browseProducts": "تصفح المنتجات",
  "inventory.virtualStoreInventory": "مخزون متجري الافتراضي",
  "inventory.virtualStoreInventoryDesc": "إدارة المنتجات التي أضفتها من تجار الجملة لمتجرك الافتراضي",
  "inventory.virtualStoreRequired": "متجر افتراضي مطلوب",
  "inventory.virtualStoreRequiredDesc": "يجب أن يكون لديك متجر افتراضي للوصول إلى هذه الصفحة",
  "inventory.activateVirtualStore": "تفعيل المتجر الافتراضي",
  "inventory.addNewProducts": "إضافة منتجات جديدة",
  "inventory.viewMyStore": "عرض متجري",
  "inventory.totalProducts": "إجمالي المنتجات",
  "inventory.activeProducts": "منتجات نشطة",
  "inventory.active": "نشط",
  "inventory.inactive": "غير نشط",
  "inventory.outOfStock": "نفذت الكمية",
  "inventory.inStock": "متوفر",
  "inventory.profitPerPiece": "الربح للقطعة:",
  "inventory.editProductTitle": "تعديل المنتج",
  "inventory.editProductDesc": "تعديل سعر البيع والكمية المتوفرة للمنتج",
  "inventory.availableQuantity": "الكمية المتوفرة",
  "inventory.enterQuantity": "أدخل الكمية",
  "inventory.saving": "جاري الحفظ...",
  "inventory.saveChanges": "حفظ التغييرات",
  "inventory.updateSuccess": "تم التحديث بنجاح",
  "inventory.updateError": "فشل في تحديث المنتج",
  "inventory.confirmDelete": "تأكيد الحذف",
  "inventory.confirmDeleteDesc": "هل أنت متأكد من حذف هذا المنتج من مخزونك؟ سيتم إزالته من متجرك الافتراضي.",
  "inventory.deleteSuccess": "تم الحذف بنجاح",
  "inventory.deleteError": "فشل في حذف المنتج",
  "inventory.deleting": "جاري الحذف...",
  "inventory.noProductsAdded": "لم تضف أي منتجات بعد",
  "inventory.noProductsAddedDesc": "تصفح منتجات تجار الجملة وأضفها إلى متجرك الافتراضي لبدء البيع",
  "inventory.browseVirtualStoreProducts": "تصفح منتجات تجار الجملة",
  "inventory.sellingPriceIQD": "سعر البيع:",
  "inventory.validationPriceRequired": "السعر مطلوب",
  "inventory.validationQuantityMin": "الكمية يجب أن تكون 0 أو أكثر",
  "inventory.priceMustBeHigher": "سعر البيع يجب أن يكون أعلى من سعر الجملة",
  "orders.manageShopOrders": "إدارة طلبات متجرك",
  "orders.virtualStoreOnly": "هذه الصفحة للمتاجر الافتراضية فقط",
  "orders.virtualStoreOnlyDesc": "يجب أن يكون لديك متجر افتراضي لرؤية الطلبات الواردة",
  "orders.createVirtualStore": "إنشاء متجر افتراضي",
  "orders.awaitingAcceptance": "بانتظار القبول",
  "orders.inProgress": "قيد التنفيذ",
  "orders.completed": "مكتملة",
  "orders.totalProfits": "إجمالي الأرباح",
  "orders.awaitingMerchant": "بانتظار التاجر",
  "orders.merchantPreparing": "التاجر يحضّر",
  "orders.rejected": "مرفوض",
  "orders.orderHash": "طلب #",
  "orders.expectedProfit": "ربح متوقع:",
  "orders.buyerNotes": "ملاحظات المشتري:",
  "orders.merchantNotes": "ملاحظات التاجر:",
  "orders.rejectionReason": "سبب الرفض:",
  "orders.accept": "قبول",
  "orders.reject": "رفض",
  "orders.profitDetails": "تفاصيل الربح",
  "orders.salePrice": "سعر البيع",
  "orders.costPrice": "سعر التكلفة",
  "orders.platformFee": "رسوم المخزن السحابي (20%)",
  "orders.netProfit": "صافي ربحك",
  "orders.noPendingOrders": "لا توجد طلبات بانتظار القبول",
  "orders.newOrdersAppearHere": "ستظهر الطلبات الجديدة هنا",
  "orders.noActiveOrders": "لا توجد طلبات قيد التنفيذ",
  "orders.activeOrdersAppearHere": "الطلبات المقبولة ستظهر هنا مع تتبع حالتها",
  "orders.noCompletedOrders": "لا توجد طلبات مكتملة",
  "orders.completedOrdersAppearHere": "الطلبات المكتملة مع تفاصيل الأرباح ستظهر هنا",
  "orders.acceptOrderTitle": "قبول الطلب",
  "orders.acceptOrderDesc": "سيتم إرسال إشعار للتاجر لتحضير المنتج وشحنه للمشتري.",
  "orders.notesForMerchant": "ملاحظات للتاجر (اختياري)",
  "orders.notesForMerchantPlaceholder": "أي ملاحظات خاصة تريد إرسالها للتاجر...",
  "orders.accepting": "جاري القبول...",
  "orders.confirmAccept": "تأكيد القبول",
  "orders.orderAccepted": "تم قبول الطلب",
  "orders.orderAcceptedDesc": "تم إرسال إشعار للتاجر لتحضير الطلب",
  "orders.rejectOrderTitle": "رفض الطلب",
  "orders.rejectOrderConfirm": "هل أنت متأكد من رفض هذا الطلب؟",
  "orders.rejectionReasonLabel": "سبب الرفض (اختياري)",
  "orders.rejectionReasonPlaceholder": "سبب رفض الطلب...",
  "orders.rejecting": "جاري الرفض...",
  "orders.confirmReject": "تأكيد الرفض",
  "orders.orderRejected": "تم رفض الطلب",
  "dashboard.loginToAccessDashboard": "سجل دخولك للوصول إلى لوحة التحكم",
  "dashboard.retailShopOwner": "صاحب محل مفرد",
  "dashboard.wholesalerType": "تاجر جملة",
  "dashboard.sellerType": "بائع",
  "dashboard.addNewProduct": "نشر إعلان جديد",
  "dashboard.noProducts": "لا توجد إعلانات شخصية بعد",
  "dashboard.addFirstProductDesc": "هذه الصفحة لإعلاناتك الشخصية المبوّبة فقط. أمّا منتجات متجرك فتُدار من «منتجاتي»، وتظهر طلباتها في «طلبات متجري».",
  "dashboard.addProduct": "نشر إعلان",
  "dashboard.incomingOrders": "الطلبات الواردة",
  "dashboard.noIncomingOrders": "لا توجد طلبات على إعلاناتك الشخصية",
  "dashboard.ordersAppearWhenBuy": "ستظهر هنا طلبات الزبائن على إعلاناتك الشخصية المبوّبة",
  "dashboard.buyerInfo": "معلومات المشتري",
  "dashboard.nameLabel": "الاسم:",
  "dashboard.phoneLabel": "الهاتف:",
  "dashboard.cityLabel": "المدينة:",
  "dashboard.addressLabel": "العنوان:",
  "dashboard.notesLabel": "ملاحظات:",
  "dashboard.productsCount": "المنتجات",
  "dashboard.deliveryTokenForDriver": "رمز التوصيل للمندوب",
  "dashboard.tokenCopied": "تم النسخ",
  "dashboard.tokenCopiedDesc": "تم نسخ رمز التوصيل",
  "dashboard.shareTokenWithDriver": "شارك هذا الرمز مع مندوب التوصيل ليؤكد تسليم الطلب",
  "dashboard.driverNeedsLastFour": "يحتاج المندوب أيضاً لآخر 4 أرقام من رقم هاتف المشتري",
  "dashboard.deliveryConfirmPage": "صفحة تأكيد التوصيل للمندوب",
  "dashboard.totalLabel": "المجموع:",
  "dashboard.updateStatusLabel": "تحديث الحالة:",
  "dashboard.confirmOrderStatus": "تأكيد الطلب",
  "dashboard.processingStatus": "قيد التجهيز",
  "dashboard.shippedStatus": "تم التسليم لمندوب التوصيل",
  "dashboard.deliveredStatus": "تم التوصيل",
  "dashboard.cancelStatus": "إلغاء",
  "dashboard.salesStatistics": "إحصائيات المبيعات",
  "dashboard.revenue": "الإيرادات",
  "dashboard.activeListings": "المنتجات النشطة",
  "dashboard.awaitingConfirmation": "بانتظار التأكيد",
  "dashboard.inExecution": "قيد التنفيذ",
  "dashboard.cancelledOrders": "ملغية",
  "dashboard.orderUnit": "طلب",
  "dashboard.productUnit": "منتج",
  "dashboard.completedOrdersRevenue": "د.ع (من الطلبات المكتملة)",
  "dashboard.orderStatusUpdated": "تم تحديث حالة الطلب",
  "dashboard.orderStatusUpdatedSuccess": "تم تحديث حالة الطلب بنجاح",
  "dashboard.orderStatusUpdateError": "خطأ",
  "dashboard.orderStatusUpdateFailed": "فشل في تحديث حالة الطلب",
  "dashboard.fetchListingsError": "فشل في جلب الإعلانات",
  "dashboard.loginToAccessSupplier": "يرجى تسجيل الدخول للوصول إلى لوحة المورد",
  "dashboard.trackStoresAndSales": "تابع المتاجر التي تعرض منتجاتك وإحصائيات المبيعات",
  "dashboard.stores": "المتاجر",
  "dashboard.displayedProducts": "منتجات معروضة",
  "dashboard.salesByStore": "المبيعات حسب المتجر",
  "dashboard.salesByStoreDesc": "إحصائيات المبيعات لكل متجر افتراضي يعرض منتجاتك",
  "dashboard.store": "متجر",
  "dashboard.completedCount": "مكتمل",
  "dashboard.quantityLabel": "الكمية",
  "dashboard.yourRevenue": "إيراداتك",
  "dashboard.noSalesYet": "لا توجد مبيعات بعد",
  "dashboard.storesDisplayingProducts": "المتاجر التي تعرض منتجاتك",
  "dashboard.storesDisplayingProductsDesc": "قائمة بجميع المتاجر الافتراضية التي أضافت منتجاتك لمخزونها",
  "dashboard.activeStatus": "نشط",
  "dashboard.stoppedStatus": "متوقف",
  "dashboard.noStoresYet": "لا توجد متاجر تعرض منتجاتك حتى الآن",
  "dashboard.enableDropshipping": "فعّل خيار المتجر الافتراضي في منتجاتك",
  "dashboard.dropshippingOrders": "طلبات المتاجر الافتراضية",
  "dashboard.noOrdersYet": "لا توجد طلبات بعد",
  "dashboard.ordersAppearWhenCustomersBuy": "ستظهر هنا الطلبات عندما يبدأ العملاء بالشراء من المتاجر الافتراضية",
  "dashboard.yourShare": "حصتك",
  "dashboard.privacyNotice": "ملاحظة الخصوصية:",
  "dashboard.privacyNoticeDesc": "أسعار البيع النهائية وهوامش ربح المتاجر الافتراضية محمية ولا تظهر لك. تظهر لك فقط حصتك من كل طلب وإحصائيات المبيعات العامة.",
  "dashboard.statusPending": "قيد الانتظار",
  "dashboard.statusAcceptedByShop": "قبلها المتجر",
  "dashboard.statusPreparing": "قيد التحضير",
  "dashboard.statusShipped": "تم التسليم لمندوب التوصيل",
  "dashboard.statusDelivered": "تم التوصيل",
  "dashboard.statusRejected": "مرفوض",
  "dashboard.loginRequired": "يجب تسجيل الدخول",
  "dashboard.loginToSeeNotifications": "سجل دخولك لرؤية إشعاراتك",
  "dashboard.unauthorized": "غير مصرح",
  "dashboard.merchantsOnly": "هذه الصفحة متاحة للتجار وأصحاب المحلات فقط",
  "dashboard.newCount": "جديد",
  "dashboard.markAllRead": "تعليم الكل كمقروء",
  "dashboard.noNotifications": "لا توجد إشعارات",
  "dashboard.notificationsAppearHere": "ستظهر هنا إشعارات عندما يختار أحد الموزعين منتجاتك للبيع",
  "dashboard.viewProduct": "عرض المنتج",
  "dashboard.merchantsOnlyPage": "هذه الصفحة للتجار فقط",
  "dashboard.mustBeWholesalerOrShop": "يجب أن تكون تاجر جملة أو صاحب محل لعرض المتاجر الشريكة",
  "dashboard.backToHome": "العودة للرئيسية",
  "dashboard.storesSellingYourProducts": "المتاجر التي تبيع منتجاتك",
  "dashboard.partnerStore": "متجر شريك",
  "dashboard.deliveredLabel": "تم التسليم",
  "dashboard.noPartnerStores": "لا يوجد متاجر شريكة حتى الآن",
  "dashboard.partnerStoresAppearHere": "عندما يضيف أصحاب المتاجر الافتراضية منتجاتك إلى مخزونهم، ستظهر هنا",
  "dashboard.viewMyProducts": "عرض منتجاتي",
  "dashboard.productCount": "منتج",
  "dashboard.deliveredCount": "مُسلّم",
  "dashboard.joinedDate": "انضم",
  "dashboard.productsLabel": "المنتجات:",
  "dashboard.virtualStoreOrders": "طلبات المحلات الافتراضية",
  "dashboard.mustBeWholesalerOrShopOrders": "يجب أن تكون تاجر جملة أو صاحب محل لإدارة طلبات المحلات الافتراضية",
  "dashboard.incomingVirtualStoreOrders": "طلبات المحلات الافتراضية الواردة",
  "dashboard.ordersFromVirtualStores": "هذه الطلبات من المتاجر الافتراضية التي اختارت منتجاتك",
  "dashboard.ordersAppearWhenAccepted": "عندما تقبل المتاجر الافتراضية الطلبات، ستظهر هنا للتحضير",
  "dashboard.ordersToPrepare": "طلبات تحتاج للتحضير",
  "dashboard.fromStore": "من متجر:",
  "dashboard.buyerLabel": "المشتري:",
  "dashboard.shopNotes": "ملاحظات المتجر:",
  "dashboard.startPreparing": "بدء التحضير",
  "dashboard.ordersPreparing": "طلبات قيد التحضير",
  "dashboard.confirmShipping": "تم التسليم لمندوب التوصيل",
  "dashboard.shippedOrders": "طلبات سُلِّمت لمندوب التوصيل",
  "dashboard.confirmDelivery": "تأكيد التسليم",
  "dashboard.completedOrdersTitle": "طلبات مكتملة",
  "dashboard.startPrepareOrder": "بدء تحضير الطلب",
  "dashboard.prepareNotification": "سيتم إرسال إشعار للمتجر الافتراضي بأنك بدأت بتحضير الطلب.",
  "dashboard.productLabel": "المنتج:",
  "dashboard.quantityLabelColon": "الكمية:",
  "dashboard.addressLabelColon": "العنوان:",
  "dashboard.phoneLabelColon": "الهاتف:",
  "dashboard.notesOptional": "ملاحظات (اختياري)",
  "dashboard.anySpecialNotes": "أي ملاحظات خاصة...",
  "dashboard.confirmingStatus": "جاري التأكيد...",
  "dashboard.confirmStartPrepare": "تأكيد بدء التحضير",
  "dashboard.preparationStarted": "تم بدء التحضير",
  "dashboard.notificationSentToStore": "تم إرسال إشعار للمتجر الافتراضي",
  "dashboard.shippingConfirmed": "تم التسليم لمندوب التوصيل",
  "dashboard.deliveryConfirmed": "تم تأكيد التسليم",
  "dashboard.operationSuccess": "تمت العملية بنجاح",
  "dashboard.awaitingShop": "بانتظار المتجر",
  "dashboard.awaitingPrepare": "بانتظار التحضير",
  "dashboard.preparingStatus": "جاري التحضير",
  "dashboard.virtualStoreProducts": "منتجات المتاجر الافتراضية",
  "dashboard.virtualStoreProductsDesc": "اختر المنتجات من تجار الجملة وأضفها إلى متجرك الافتراضي بسعرك الخاص",
  "dashboard.myInventory": "مخزوني",
  "dashboard.sellViaVirtualStores": "للبيع عبر المتاجر الافتراضية",
  "dashboard.loginThenCreateStore": "سجّل دخولك ثم أنشئ متجر افتراضي لتتمكن من إضافة هذه المنتجات لمتجرك",
  "dashboard.toBuyVirtualStoreProducts": "للشراء من منتجات المتاجر الافتراضية",
  "dashboard.createStoreOrRegister": "أنشئ متجر افتراضي أو سجّل كصاحب محل لتتمكن من إضافة هذه المنتجات لمتجرك",
  "dashboard.createVirtualStore": "إنشاء متجر افتراضي",
  "dashboard.registerAsShopOwner": "التسجيل كصاحب محل",
  "dashboard.searchDropshippingProducts": "ابحث في منتجات المتاجر الافتراضية...",
  "dashboard.filtersLabel": "الفلاتر",
  "dashboard.categoryLabel": "القسم",
  "dashboard.allCategories": "جميع الأقسام",
  "dashboard.provinceLabel": "المحافظة",
  "dashboard.allProvinces": "جميع المحافظات",
  "dashboard.clearFilters": "مسح الفلاتر",
  "dashboard.productsAvailable": "منتج متاح للمتاجر الافتراضية",
  "dashboard.noProductsAvailable": "لا توجد منتجات",
  "dashboard.noProductsAvailableDesc": "لا توجد منتجات متاحة للمتاجر الافتراضية حالياً",
  "dashboard.virtualStoresBadge": "متاجر افتراضية",
  "dashboard.wholesalePrice": "سعر الجملة:",
  "dashboard.retailPrice": "سعر التجزئة:",
  "dashboard.addToMyStore": "أضف لمتجري",
  "dashboard.loginFirstRequired": "يجب تسجيل الدخول أولاً",
  "dashboard.loginThenCreateStoreDesc": "سجّل دخولك ثم أنشئ متجر افتراضي للبيع عبر المتاجر الافتراضية",
  "dashboard.virtualStoreOrShopRequired": "يتطلب متجر افتراضي أو محل",
  "dashboard.createStoreOrRegisterDesc": "أنشئ متجر افتراضي أو سجّل كصاحب محل لتتمكن من إضافة المنتجات",
  "dashboard.addProductToStore": "إضافة منتج للمتجر",
  "dashboard.setYourPrice": "حدد سعر البيع الخاص بك لهذا المنتج",
  "dashboard.wholesalePriceYouPay": "سعر الجملة (تدفعه للتاجر):",
  "dashboard.yourSellingPrice": "سعر البيع الخاص بك (د.ع)",
  "dashboard.enterSellingPrice": "أدخل سعر البيع",
  "dashboard.expectedProfit": "ربحك المتوقع:",
  "dashboard.addToInventory": "إضافة للمخزون",
  "dashboard.addedSuccessfully": "تمت الإضافة بنجاح",
  "dashboard.productAddedToStore": "تم إضافة المنتج إلى متجرك الافتراضي",
  "dashboard.addProductFailed": "فشل في إضافة المنتج",
  "dashboard.enterValidPrice": "يرجى إدخال سعر صحيح",
  "dashboard.priceAboveWholesale": "سعر البيع يجب أن يكون أعلى من سعر الجملة",
  "dashboard.createAccount": "إنشاء حساب",
  "dashboard.myStore": "متجري",
  "workWithUs.heroTitle": "اعمل في سوق العراق",
  "workWithUs.heroSubtitle": "افتح متجرك الافتراضي واختر منتجات تجار الجملة وأعد بيعها واربح من بيتك!",
  "workWithUs.viewMyStore": "عرض متجري",
  "workWithUs.myInventory": "مخزني",
  "workWithUs.activateNow": "فعّل متجرك الآن",
  "workWithUs.registerFree": "سجل مجاناً",
  "workWithUs.browseProducts": "تصفح المنتجات",
  "workWithUs.activateTitle": "فعّل متجرك الافتراضي",
  "workWithUs.activateDesc": "أنشئ متجرك الخاص واعرض منتجاتك للبيع بالتجزئة",
  "workWithUs.storeName": "اسم المتجر *",
  "workWithUs.storeNamePlaceholder": "مثال: متجر أحمد للإلكترونيات",
  "workWithUs.storeNameHint": "هذا الاسم سيظهر للمشترين",
  "workWithUs.storeDesc": "وصف المتجر (اختياري)",
  "workWithUs.storeDescPlaceholder": "صف ما تبيعه في متجرك...",
  "workWithUs.whatHappens": "ماذا سيحدث بعد التفعيل؟",
  "workWithUs.getBenefit1": "ستحصل على صفحة متجر خاصة بك",
  "workWithUs.getBenefit2": "يمكنك شراء منتجات الجملة وإعادة بيعها",
  "workWithUs.getBenefit3": "تحدد أسعار البيع بنفسك",
  "workWithUs.activating": "جاري التفعيل...",
  "workWithUs.activateMyStore": "فعّل متجري الآن",
  "workWithUs.storeActivated": "تم تفعيل المتجر!",
  "workWithUs.canStartSelling": "يمكنك الآن البدء بإعادة بيع المنتجات",
  "workWithUs.error": "خطأ",
  "workWithUs.storeNameError": "يرجى إدخال اسم المتجر (3 أحرف على الأقل)",
  "workWithUs.activateError": "حدث خطأ أثناء تفعيل المتجر",
  "workWithUs.storeActive": "متجرك مفعّل!",
  "workWithUs.viewStore": "عرض المتجر",
  "workWithUs.browseWholesale": "تصفح منتجات الجملة للشراء",
  "workWithUs.howItWorksTitle": "كيف يعمل النظام؟",
  "workWithUs.step1Title": "فعّل متجرك",
  "workWithUs.step1Desc": "أنشئ متجرك الافتراضي بضغطة زر واحدة وابدأ البيع فوراً",
  "workWithUs.step2Title": "اختر من تجار الجملة",
  "workWithUs.step2Desc": "تصفح منتجات تجار الجملة واختر ما تريد بيعه وأضفه لمتجرك بسعرك",
  "workWithUs.step3Title": "حدد سعر البيع",
  "workWithUs.step3Desc": "أنت تحدد سعر البيع للزبون، والفرق بين سعر الجملة وسعرك هو ربحك بعد حصة الموقع البالغة 20% من هذا الفرق فقط",
  "workWithUs.step4Title": "اربح من بيتك",
  "workWithUs.step4Desc": "عند البيع، التاجر يشحن للزبون وأنت تربح الفرق بعد حصة الموقع، دون أن تشتري البضاعة مسبقاً",
  "workWithUs.whyWorkTitle": "لماذا تعمل معنا؟",
  "workWithUs.noCapital": "بدون رأس مال",
  "workWithUs.noCapitalDesc": "لا تحتاج شراء بضاعة مسبقاً، فقط اعرض وابدأ البيع",
  "workWithUs.trustedMerchants": "تجار موثوقون",
  "workWithUs.trustedMerchantsDesc": "منتجات من تجار جملة موثوقين ومعتمدين في المنصة",
  "workWithUs.autoShipping": "شحن تلقائي",
  "workWithUs.autoShippingDesc": "التاجر يشحن المنتج مباشرة للزبون بدون تدخل منك",
  "workWithUs.realProfits": "أرباح حقيقية",
  "workWithUs.realProfitsDesc": "احتفظ بالفرق كربح، بعد رسوم مخزن سحابي 20% من هامش الربح فقط، لا من سعر البيع",
  "workWithUs.startProfit": "ابدأ الربح اليوم!",
  "workWithUs.joinSellers": "انضم إلى آلاف البائعين الذين يحققون أرباحاً من إعادة البيع في سوق العراق",
  "workWithUs.browseAndBuy": "تصفح واشتري الآن",
  "workWithUs.viewInventory": "عرض مخزني",
  "workWithUs.haveAccount": "لديك حساب؟ سجل دخول",
  "workWithUs.backToHome": "العودة للرئيسية",
  "workWithUs.landingHeroTitle": "افتح متجرك الافتراضي مجاناً",
  "workWithUs.landingHeroSubtitle": "اربح من بيتك بدون رأس مال، بدون تعب، وبدون مخزون!",
  "workWithUs.landingHeroNote": "نظام المحلات الافتراضية الأول في العراق",
  "workWithUs.whatIsVirtualStore": "ما هي المحلات الافتراضية؟",
  "workWithUs.virtualStoreExplain": "المحلات الافتراضية هي نموذج تجاري ذكي يتيح لك بيع منتجات تجار الجملة دون الحاجة لشرائها مسبقاً أو تخزينها. أنت تعرض المنتج في متجرك بالسعر الذي تحدده، وعند البيع يقوم التاجر بشحن المنتج مباشرة للزبون، وأنت تأخذ الفرق كربح صافي!",
  "workWithUs.landingStep1Title": "أنشئ متجرك الافتراضي مجاناً",
  "workWithUs.landingStep1Desc": "سجّل حسابك وفعّل متجرك الافتراضي بضغطة زر واحدة.",
  "workWithUs.landingStep2Title": "اختر منتجات من تجار الجملة",
  "workWithUs.landingStep2Desc": "تصفح آلاف المنتجات من تجار الجملة الموثوقين، اختر ما يعجبك وأضفه لمتجرك بالسعر الذي تريده أنت!",
  "workWithUs.landingStep3Title": "الزبون يشتري من متجرك",
  "workWithUs.landingStep3Desc": "عندما يشتري زبون من متجرك، يصلك الطلب مباشرة. ويصل للتاجر أيضاً ليقوم بتجهيز الطلب لشركة الشحن.",
  "workWithUs.landingStep4Title": "التاجر يشحن والربح يصلك",
  "workWithUs.landingStep4Desc": "التاجر يشحن المنتج مباشرة للزبون، وعند التسليم يُضاف ربحك تلقائياً لمحفظتك!",
  "workWithUs.noInventory": "بدون مخزون",
  "workWithUs.noShipping": "بدون شحن",
  "workWithUs.fromHome": "من بيتك فقط!",
  "workWithUs.howMuchProfit": "كم تربح؟",
  "workWithUs.youSetPrice": "أنت تحدد سعر البيع!",
  "workWithUs.profitExplain": "الفرق بين سعرك وسعر التاجر هو ربحك الصافي.",
  "workWithUs.practicalExample": "مثال عملي:",
  "workWithUs.merchantPrice": "سعر التاجر",
  "workWithUs.yourStorePrice": "سعرك في المتجر",
  "workWithUs.netProfit": "ربحك الصافي",
  "workWithUs.commissionNote": "رسوم المخزن السحابي هي 20% فقط من ربحك الصافي عند التسليم الناجح",
  "workWithUs.systemFeatures": "مميزات النظام",
  "workWithUs.thousandsProducts": "آلاف المنتجات المتاحة",
  "workWithUs.fromTrustedMerchants": "من تجار جملة موثوقين",
  "workWithUs.eWallet": "محفظة إلكترونية",
  "workWithUs.autoAccumulate": "أرباحك تتجمع تلقائياً",
  "workWithUs.easyWithdraw": "سحب سهل للأرباح",
  "workWithUs.withdrawMethods": "زين كاش، تحويل بنكي، أو نقدي",
  "workWithUs.trackOrders": "تتبع الطلبات",
  "workWithUs.trackOrdersDesc": "راقب كل طلباتك بسهولة",
  "workWithUs.continuousSupport": "دعم فني متواصل",
  "workWithUs.supportDesc": "نساعدك في كل خطوة",
  "workWithUs.whoIsThisFor": "لمن هذه الفرصة؟",
  "workWithUs.housewives": "ربات البيوت الباحثات عن دخل إضافي",
  "workWithUs.students": "الطلاب والخريجين الجدد",
  "workWithUs.employees": "الموظفين الراغبين بعمل جانبي",
  "workWithUs.anyone": "أي شخص يريد البدء بالتجارة الإلكترونية",
  "workWithUs.allYouNeed": "كل ما تحتاجه هو هاتف واتصال بالإنترنت!",
  "workWithUs.faq": "الأسئلة الشائعة",
  "workWithUs.faqSubtitle": "كل اللي لازم تعرفه عن سوق العراق",
  "workWithUs.faq1Q": "شنو يعني \"محل افتراضي\" وشلون أربح منه؟",
  "workWithUs.faq1A": "المحل الافتراضي هو مساحتك الخاصة بموقعنا، تختار بضاعة التجار اللي تعجبك وتعرضها بسعرك الخاص. ربحك هو الفرق بين سعر التاجر والسعر اللي أنت حددته. لا تحتاج مخزن ولا تحتاج تشتري البضاعة مسبقاً.",
  "workWithUs.faq2Q": "زين، التاجر الأصلي راح يشوف السعر اللي أني حطيته؟",
  "workWithUs.faq2A": "أبداً. نظامنا متطور ويحفظ خصوصيتك؛ التاجر يوصله إشعار إن بضاعته انعرضت، بس ما يقدر يشوف السعر النهائي اللي حطيته للزبون. هذا \"سر مهنتك\" ومحفوظ يمنا.",
  "workWithUs.faq3Q": "شلون أضمن حقي وأعرف التاجر جهّز البضاعة وشحنها؟",
  "workWithUs.faq3A": "أول ما يجي طلب، يوصل إشعار إلك وللتاجر ولشركة الشحن بنفس اللحظة. راح تظهر عندك \"لوحة تتبع\" حية، تشوف بيها المنتج من يطلع من المخزن، يروح للشحن، لحد ما يوصل ليد الزبون. الكل يشوف نفس الحالة لضمان الشفافية.",
  "workWithUs.faq4Q": "منو المسؤول عن توصيل الطلبات للزبائن؟",
  "workWithUs.faq4A": "إحنا متعاقدين مع شركات شحن موثوقة. التاجر يجهز الغرض، وشركة الشحن تستلمه منه وتوصله للعنوان اللي حدده زبونك. أنت دورك المتابعة والتسويق فقط.",
  "workWithUs.faq5Q": "شوكت أستلم أرباحي من المبيعات؟",
  "workWithUs.faq5A": "الأرباح تتصرف إلك بعد ما يتم استلام المنتج من قبل الزبون وتأكيد الدفع. نظامنا المحاسبي دقيق ويحول أرباحك للمحفظة الخاصة بيك بالموقع، وتقدر تسحبها بالطريقة اللي تناسبك.",
  "workWithUs.faq6Q": "هل يحتاج أدفع رسوم حتى أفتح محل افتراضي؟",
  "workWithUs.faq6A": "حالياً، هدفنا ندعم الشباب والتجار العراقيين، فالتسجيل وفتح المحل متاح وبسهولة. ابدأ تجارتك ويانا بدون أي مخاطرة مالية.",
  "workWithUs.faq7Q": "أنا تاجر وعندي بضاعة، ليش أعرضها بسوق العراق؟",
  "workWithUs.faq7A": "لأننا نوفر لك جيش من المسوقين (أصحاب المحلات الافتراضية) اللي راح يروجون لبضاعتك بكل مكان بالعراق. أنت ركز على جودة المنتج والتجهيز، وإحنا والمسوقين علينا المبيعات.",
  "workWithUs.moreInfoContact": "لمعلومات أكثر اكتب لنا وسنجيبك عن أي استفسار",
  "workWithUs.contactUs": "راسلنا الآن",
  "workWithUs.contactAdmin": "تواصل مع إدارة الموقع",
  "workWithUs.writeInquiry": "اكتب لنا استفسارك وسنرد عليك في أقرب وقت",
  "workWithUs.name": "الاسم",
  "workWithUs.fullNamePlaceholder": "اسمك الكامل",
  "workWithUs.phone": "رقم الهاتف",
  "workWithUs.address": "العنوان",
  "workWithUs.addressPlaceholder": "المحافظة / المنطقة",
  "workWithUs.yourMessage": "رسالتك",
  "workWithUs.messagePlaceholder": "اكتب استفسارك هنا...",
  "workWithUs.sendMessage": "إرسال الرسالة",
  "workWithUs.sending": "جاري الإرسال...",
  "workWithUs.sent": "تم الإرسال",
  "workWithUs.sentDesc": "سنتواصل معك في أقرب وقت",
  "workWithUs.sendError": "حدث خطأ أثناء الإرسال",
  "workWithUs.enterNamePhone": "يرجى إدخال اسمك ورقم هاتفك",
  "workWithUs.enterMessage": "يرجى كتابة رسالتك",
  "workWithUs.startFree": "ابدأ الآن مجاناً!",
  "workWithUs.createAndProfit": "أنشئ متجرك الافتراضي واختر منتجاتك وابدأ الربح",
  "workWithUs.earnFromHome": "اربح وانت جالس في بيتك!",
  "workWithUs.openYourStore": "افتح متجرك الافتراضي",
  "workWithUs.registeredCustomerWarning": "أنت مسجل كزبون عادي - لا يمكنك الشراء من سوق الجملة",
  "workWithUs.createStoreForWholesale": "أنشئ متجرك الافتراضي للشراء بالجملة",
  "workWithUs.loginForWholesale": "سجل دخولك للشراء من سوق الجملة",
  "physicalStore.dialogTitle": "هل لديك محل حقيقي؟",
  "physicalStore.dialogDescription": "إذا كان متجرك الافتراضي يمثل أيضاً محلاً حقيقياً موجوداً على أرض الواقع، يمكنك إضافة عنوانه ليتمكن الزوار والزبائن من زيارتك شخصياً",
  "physicalStore.yesHaveStore": "نعم، لدي محل حقيقي",
  "physicalStore.noVirtualOnly": "لا، متجر افتراضي فقط",
  "physicalStore.province": "المحافظة",
  "physicalStore.selectProvince": "اختر المحافظة",
  "physicalStore.area": "المنطقة",
  "physicalStore.selectArea": "اختر المنطقة",
  "physicalStore.areaPlaceholder": "مثال: المنصور، الكرادة، الشورجة",
  "physicalStore.address": "الحي",
  "physicalStore.selectNeighborhood": "اختر الحي",
  "physicalStore.addressPlaceholder": "مثال: شارع الربيعي، قرب جامع...",
  "physicalStore.save": "حفظ معلومات المحل",
  "physicalStore.skipForNow": "تخطي الآن",
  "physicalStore.saved": "تم حفظ معلومات المحل بنجاح",
  "physicalStore.badge": "محل حقيقي",
  "physicalStore.physicalLocation": "موقع المحل الحقيقي",
  "physicalStore.alsoPhysicalStore": "هذا المتجر الافتراضي له محل حقيقي يمكنك زيارته",
  "physicalStore.addPhysicalStore": "إضافة محل حقيقي",
  "physicalStore.editLocation": "تعديل الموقع",
  "physicalStore.storeName": "اسم المتجر الفعلي",
  "physicalStore.storeNamePlaceholder": "أدخل اسم المتجر الفعلي (اختياري)",
  "map.allCategories": "جميع الفئات",
  "map.allCities": "جميع المدن",
  "map.listing": "إعلان",
  "map.listingsIn": "إعلانات",
  "map.allListings": "جميع الإعلانات",
  "map.noListingsFound": "لا توجد إعلانات",
  "delivery.pageTitle": "تأكيد التوصيل",
  "delivery.driverPage": "صفحة مندوب التوصيل",
  "delivery.confirmOrder": "تأكيد تسليم الطلب",
  "delivery.orderNumber": "رقم الطلب",
  "delivery.enterOrderNumber": "أدخل رقم الطلب",
  "delivery.deliveryToken": "رمز التوصيل",
  "delivery.enterToken": "أدخل رمز التوصيل",
  "delivery.buyerPhoneLast4": "آخر 4 أرقام من رقم هاتف المشتري",
  "delivery.phonePlaceholder": "مثال: 1234",
  "delivery.deliveryOtp": "رمز الاستلام",
  "delivery.otpPlaceholder": "أدخل الرمز المكوّن من 4 أرقام",
  "delivery.otpRequired": "رمز الاستلام يجب أن يكون 4 أرقام",
  "delivery.confirming": "جاري التأكيد...",
  "delivery.confirmDelivery": "تأكيد التوصيل",
  "delivery.orderIdRequired": "رقم الطلب مطلوب",
  "delivery.tokenRequired": "رمز التوصيل مطلوب",
  "delivery.tokenMaxLength": "رمز التوصيل يجب ألا يتجاوز 12 حرف",
  "delivery.phoneLast4Required": "يجب إدخال آخر 4 أرقام",
  "delivery.confirmSuccess": "تم تأكيد التوصيل بنجاح",
  "delivery.confirmError": "حدث خطأ في تأكيد التوصيل",
  "market.filterProducts": "فلترة المنتجات",
  "market.searchLabel": "البحث",
  "market.searchInProducts": "ابحث في المنتجات...",
  "market.categoryLabel": "الفئة",
  "market.resetFilters": "إعادة تعيين",
  "market.productsOf": "منتجات",
  "market.product": "منتج",
  "market.foundCount": "تم العثور على",
  "market.noProductsCurrently": "لا توجد منتجات حالياً",
  "market.addProductHere": "أضف منتجًا في هذا السوق",
  "market.shopsTitle": "محلات السوق",
  "market.noShops": "لا توجد محلات مسجلة في هذا السوق بعد",
  "market.shopKindAll": "كل المحلات",
  "market.shopKindStore": "محل مفرد",
  "market.shopKindWholesaler": "تاجر جملة",
  "market.shopProducts": "منتجاته",
  "market.showingShopProducts": "منتجات المحل:",
  "market.goToMyMarket": "اذهب إلى سوق محلك",
  "market.noMerchantProducts": "لم يتم إضافة منتجات من تجار",
  "market.yet": "بعد",
  "market.browseOther": "تصفح المنتجات الأخرى",
  "market.shorjaTitle": "سوق الشورجة",
  "market.shorjaSubtitle": "سوق الجملة الإلكتروني - أسعار جملة حصرية للتجار وأصحاب المحلات",
  "market.verifiedSuppliers": "+500 مورد موثق",
  "market.profitsUp50": "أرباح تصل 50%",
  "market.deliveryAllIraq": "توصيل لكل العراق",
  "market.addWholesaleProduct": "أضف منتج جملة للبيع",
  "market.openWholesaleAccount": "فتح حساب بائع جملة",
  "market.all": "الكل",
  "market.filters": "الفلاتر",
  "market.filterResults": "فلترة النتائج",
  "market.wholesaleProduct": "منتج جملة",
  "market.sortByLabel": "ترتيب حسب:",
  "market.noWholesaleProducts": "لا توجد منتجات جملة",
  "market.noWholesaleDesc": "لم يتم العثور على منتجات جملة حالياً. يمكنك إضافة منتج جملة جديد.",
  "market.resetFiltersBtn": "إعادة ضبط الفلاتر",
  "market.inWarehouse": "متوفر بالمخزن",
  "market.loginLabel": "تسجيل الدخول",
  "auth.enterRegisteredPhone": "أدخل رقم هاتفك لإرسال طلب إعادة تعيين كلمة المرور إلى الإدارة",
  "auth.phoneLabel": "رقم الهاتف",
  "auth.searching": "جاري البحث...",
  "auth.continue": "متابعة",
  "auth.answer": "الإجابة",
  "auth.sixDigits": "(6 أرقام)",
  "auth.changing": "جاري التغيير...",
  "auth.forgotSecurityAnswer": "نسيت إجابة سؤال الأمان؟",
  "auth.contactAdmin": "التواصل مع الإدارة",
  "auth.contactAdminDesc": "يرجى التواصل مع إدارة الموقع عبر واتساب لإعادة تعيين كلمة المرور",
  "auth.sendAdminRequest": "إرسال طلب للإدارة",
  "auth.requestSentSuccess": "تم إرسال الطلب بنجاح",
  "auth.contactWhatsapp": "التواصل عبر واتساب",
  "auth.contactAdminForReset": "يرجى التواصل مع الإدارة لإعادة تعيين كلمة المرور",
  "auth.afterApproval": "بعد موافقة الإدارة على طلبك، سيتم التواصل معك عبر واتساب بكلمة المرور الجديدة",
  "auth.backToLogin": "العودة لتسجيل الدخول",
  "auth.backToHomePage": "العودة للصفحة الرئيسية",
  "auth.errorOccurred": "حدث خطأ",
  "auth.passwordMust6Digits": "كلمة المرور يجب أن تكون 6 أرقام",
  "auth.passwordChanged": "تم تغيير كلمة المرور بنجاح",
  "auth.requestSent": "تم إرسال الطلب",
  "auth.willContactYou": "سيتم التواصل معك قريباً",
  "search.advancedSearch": "البحث المتقدم",
  "search.filtersLabel": "الفلاتر",
  "search.resetFilters": "إعادة تعيين",
  "search.resultsLabel": "النتائج",
  "search.listingUnit": "إعلان",
  "search.sortNewestLabel": "الأحدث",
  "search.sortOldestLabel": "الأقدم",
  "search.sortPriceLow": "السعر: من الأقل",
  "search.sortPriceHigh": "السعر: من الأعلى",
  "search.mostViewed": "الأكثر مشاهدة",
  "search.searchBadge": "البحث:",
  "search.noResultsFound": "لا توجد نتائج",
  "search.tryChangingFilters": "جرب تغيير معايير البحث أو إزالة بعض الفلاتر",
  "search.resetAllFilters": "إعادة تعيين الفلاتر",
  "listing.sectionNotFound": "القسم غير موجود",
  "listing.allSections": "جميع الأقسام",
  "listing.home": "الرئيسية",
  "listing.listingUnit": "إعلان",
  "listing.detailedSearch": "البحث التفصيلي",
  "listing.productDetails": "تفاصيل المنتج",
  "listing.selectOption": "اختر",
  "listing.all": "الكل",
  "listing.carBrand": "ماركة السيارة",
  "listing.brand": "الماركة",
  "listing.sportsProductDetails": "تفاصيل المنتج الرياضي",
  "listing.animalDetails": "تفاصيل الحيوان",
  "listing.animalType": "نوع الحيوان",
  "listing.foundListings": "تم العثور على",
  "listing.noListings": "لا توجد إعلانات",
  "listing.noListingsInSection": "لم يتم العثور على إعلانات في هذا القسم",
  "listing.addFirstListing": "أضف أول إعلان",
  "listing.hideCategories": "إخفاء الأقسام",
  "listing.showCategories": "عرض الأقسام",
  "wholesale.dropshippingTitle": "منتجات المتاجر الافتراضية",
  "wholesale.dropshippingSubtitle": "اختر المنتجات من تجار الجملة وأضفها إلى متجرك الافتراضي بسعرك الخاص",
  "wholesale.myInventoryBtn": "مخزوني",
  "wholesale.forVirtualStores": "للبيع عبر المتاجر الافتراضية",
  "wholesale.loginCreateStore": "سجّل دخولك ثم أنشئ متجر افتراضي لتتمكن من إضافة هذه المنتجات لمتجرك",
  "wholesale.loginBtn": "تسجيل الدخول",
  "wholesale.createAccountBtn": "إنشاء حساب",
  "wholesale.forBuyingVirtual": "للشراء من منتجات المتاجر الافتراضية",
  "wholesale.createStoreOrRegister": "أنشئ متجر افتراضي أو سجّل كصاحب محل لتتمكن من إضافة هذه المنتجات لمتجرك",
  "wholesale.createVirtualStore": "إنشاء متجر افتراضي",
  "wholesale.registerAsShopOwner": "التسجيل كصاحب محل",
  "wholesale.searchPlaceholder": "ابحث في منتجات المتاجر الافتراضية...",
  "wholesale.filtersBtn": "الفلاتر",
  "wholesale.sectionLabel": "القسم",
  "wholesale.allSections": "جميع الأقسام",
  "wholesale.provinceLabel": "المحافظة",
  "wholesale.allProvinces": "جميع المحافظات",
  "wholesale.clearFilters": "مسح الفلاتر",
  "wholesale.availableProducts": "منتج متاح للمتاجر الافتراضية",
  "wholesale.noProducts": "لا توجد منتجات",
  "wholesale.noProductsAvailable": "لا توجد منتجات متاحة للمتاجر الافتراضية حالياً",
  "wholesale.virtualStoresBadge": "متاجر افتراضية",
  "wholesale.wholesalePrice": "سعر الجملة:",
  "wholesale.retailPrice": "سعر التجزئة:",
  "wholesale.addProductToStore": "إضافة منتج للمتجر",
  "wholesale.setYourPrice": "حدد سعر البيع الخاص بك لهذا المنتج",
  "wholesale.wholesalePriceLabel": "سعر الجملة (تدفعه للتاجر):",
  "wholesale.yourSellingPrice": "سعر البيع الخاص بك (د.ع)",
  "wholesale.enterSellingPrice": "أدخل سعر البيع",
  "wholesale.expectedProfit": "ربحك المتوقع:",
  "wholesale.grossProfit": "الربح الإجمالي",
  "wholesale.platformFee": "رسوم المخزن السحابي",
  "wholesale.netProfit": "صافي ربحك",
  "wholesale.cancel": "إلغاء",
  "wholesale.addToInventory": "إضافة للمخزون",
  "wholesale.addedSuccess": "تمت الإضافة بنجاح",
  "wholesale.addedDesc": "تم إضافة المنتج إلى متجرك الافتراضي",
  "wholesale.addError": "فشل في إضافة المنتج",
  "wholesale.enterValidPrice": "يرجى إدخال سعر صحيح",
  "wholesale.priceAboveWholesale": "سعر البيع يجب أن يكون أعلى من سعر الجملة",
  "wholesale.loginFirstRequired": "يجب تسجيل الدخول أولاً",
  "wholesale.loginCreateStoreDesc": "سجّل دخولك ثم أنشئ متجر افتراضي للبيع عبر المتاجر الافتراضية",
  "wholesale.storeOrShopRequired": "يتطلب متجر افتراضي أو محل",
  "wholesale.storeOrShopDesc": "أنشئ متجر افتراضي أو سجّل كصاحب محل لتتمكن من إضافة المنتجات",
  "market.searchPlaceholder": "ابحث في المنتجات...",
  "market.resetLabel": "إعادة تعيين",
  "market.productUnit": "منتج",
  "market.foundAds": "تم العثور على",
  "market.ad": "إعلان",
  "market.noMerchantProductsYet": "لم يتم إضافة منتجات من تجار",
  "market.browseOtherProducts": "تصفح المنتجات الأخرى",
  "market.wholesaleOnlyWarning": "أنت مسجل كزبون عادي - لا يمكنك الشراء من سوق الجملة",
  "market.createVirtualForWholesale": "أنشئ متجرك الافتراضي للشراء بالجملة",
  "market.loginForWholesale": "سجل دخولك للشراء من سوق الجملة",
  "market.trustedSuppliers": "+500 مورد موثق",
  "market.profitsUpTo": "أرباح تصل 50%",
  "market.allLabel": "الكل",
  "market.filtersLabel": "الفلاتر",
  "market.filterResultsTitle": "فلترة النتائج",
  "market.wholesaleProductCount": "منتج جملة",
  "market.noWholesaleFound": "لم يتم العثور على منتجات جملة حالياً. يمكنك إضافة منتج جملة جديد.",
  "market.resetFiltersLabel": "إعادة ضبط الفلاتر",
  "market.resetFiltersCount": "إعادة ضبط الفلاتر",
  "market.searchFilterTitle": "البحث",
  "market.searchProductPlaceholder": "ابحث عن منتج...",
  "market.governorateFilter": "المحافظة",
  "market.areaFilter": "المنطقة",
  "market.sellerTypeFilter": "نوع البائع",
  "market.moqFilter": "الحد الأدنى (شراء مباشر من التاجر)",
  "market.wholesalePriceFilter": "سعر الجملة (د.ع)",
  "market.fromLabel": "من",
  "market.toLabel": "إلى",
  "market.lessThan": "أقل من",
  "market.tieredPricingFilter": "التسعير المتدرج",
  "market.tieredPricingSupport": "يدعم التسعير المتدرج",
  "market.fixedPriceOnly": "سعر ثابت فقط",
  "market.warehouseFilter": "التوفر بالمخزن",
  "market.inWarehouseOnly": "متوفر بالمخزن فقط",
  "market.showAllLabel": "عرض الكل",
  "market.leadTimeFilter": "وقت التسليم",
  "market.packagingFilter": "نوع التغليف",
  "market.originFilter": "بلد المنشأ",
  "market.brandFilter": "العلامة التجارية",
  "listing.showSections": "عرض الأقسام",
  "listing.hideSections": "إخفاء الأقسام",
  "listing.adCount": "إعلان",
  "wholesale.virtualStoreProducts": "منتجات المتاجر الافتراضية",
  "wholesale.chooseFromWholesalers": "اختر المنتجات من تجار الجملة وأضفها إلى متجرك الافتراضي بسعرك الخاص",
  "wholesale.myStock": "مخزوني",
  "wholesale.forVirtualSelling": "للبيع عبر المتاجر الافتراضية",
  "wholesale.loginAndCreateStore": "سجّل دخولك ثم أنشئ متجر افتراضي لتتمكن من إضافة هذه المنتجات لمتجرك",
  "wholesale.loginButton": "تسجيل الدخول",
  "wholesale.createAccountButton": "إنشاء حساب",
  "wholesale.forVirtualBuying": "للشراء من منتجات المتاجر الافتراضية",
  "wholesale.createOrRegister": "أنشئ متجر افتراضي أو سجّل كصاحب محل لتتمكن من إضافة هذه المنتجات لمتجرك",
  "wholesale.searchDropshipping": "ابحث في منتجات المتاجر الافتراضية...",
  "wholesale.filtersLabel": "الفلاتر",
  "wholesale.governorateLabel": "المحافظة",
  "wholesale.allGovernorates": "جميع المحافظات",
  "wholesale.clearFiltersButton": "مسح الفلاتر",
  "wholesale.availableForVirtual": "منتج متاح للمتاجر الافتراضية",
  "wholesale.virtualStoreBadge": "متاجر افتراضية",
  "wholesale.addedToStore": "تم إضافة المنتج إلى متجرك الافتراضي",
  "wholesale.priceMustBeHigher": "سعر البيع يجب أن يكون أعلى من سعر الجملة",
  "wholesale.loginFirst": "يجب تسجيل الدخول أولاً",
  "wholesale.loginFirstDesc": "سجّل دخولك ثم أنشئ متجر افتراضي للبيع عبر المتاجر الافتراضية",
  "wholesale.requiresStore": "يتطلب متجر افتراضي أو محل",
  "wholesale.requiresStoreDesc": "أنشئ متجر افتراضي أو سجّل كصاحب محل لتتمكن من إضافة المنتجات",
  "wholesale.wholesalePayMerchant": "سعر الجملة (مستحق للتاجر عند البيع):",
  "wholesale.addToInventoryButton": "إضافة للمخزون",
  "filter.searchPlaceholder": "ابحث عما تريد...",
  "filter.category": "القسم",
  "filter.allCategories": "جميع الأقسام",
  "filter.mainCategory": "القسم الرئيسي",
  "filter.subcategory": "القسم الفرعي",
  "filter.allSubcategories": "جميع الأقسام الفرعية",
  "filter.classification": "التصنيف",
  "filter.allClassifications": "جميع التصنيفات",
  "filter.all": "الكل",
  "filter.governorate": "المحافظة",
  "filter.allGovernorates": "جميع المحافظات",
  "filter.district": "القضاء",
  "filter.allDistricts": "جميع الأحياء",
  "filter.priceRange": "نطاق السعر",
  "filter.from": "من",
  "filter.to": "إلى",
  "filter.condition": "الحالة",
  "filter.realEstateFilters": "فلاتر العقارات",
  "filter.roomCount": "عدد الغرف",
  "filter.area": "المساحة (م²)",
  "filter.buildingAge": "عمر البناء",
  "filter.floor": "الطابق",
  "filter.heating": "التدفئة",
  "filter.carFilters": "فلاتر السيارات",
  "filter.brand": "الماركة",
  "filter.manufacturingYear": "سنة الصنع",
  "filter.kilometers": "الكيلومترات",
  "filter.fuelType": "نوع الوقود",
  "filter.transmission": "ناقل الحركة",
  "filter.color": "اللون",
  "filter.optionStudio": "استوديو",
  "filter.optionNewBuilding": "0 (جديد)",
  "filter.optionGardenFloor": "طابق الحديقة",
  "filter.optionGroundFloor": "الطابق الأرضي",
  "filter.optionFloorHeating": "تدفئة أرضية",
  "filter.optionAC": "تكييف",
  "filter.optionSolar": "طاقة شمسية",
  "filter.optionNaturalGas": "غاز طبيعي",
  "filter.optionFireplace": "مدفأة",
  "filter.optionCentral": "مركزي",
  "filter.optionGasoline": "بنزين",
  "filter.optionDiesel": "ديزل",
  "filter.optionGas": "غاز",
  "filter.optionGasPlusGasoline": "بنزين وغاز",
  "filter.optionHybrid": "هجين",
  "filter.optionElectric": "كهرباء",
  "filter.optionManual": "يدوي",
  "filter.optionAutomatic": "أوتوماتيك",
  "filter.optionSemiAuto": "نصف أوتوماتيك",
  "filter.optionNew": "جديد",
  "filter.optionUsed": "مستعمل",
  "filter.optionWhite": "أبيض",
  "filter.optionRed": "أحمر",
  "filter.optionGreen": "أخضر",
  "filter.optionBlue": "أزرق",
  "filter.optionBlack": "أسود",
  "filter.optionBrown": "بني",
  "filter.optionBeige": "بيج",
  "filter.optionGray": "رمادي",
  "filter.optionSilver": "فضي",
  "filter.optionNavy": "كحلي",
  "filter.optionAudi": "أودي",
  "filter.optionOpel": "أوبل",
  "filter.optionBMW": "بي إم دبليو",
  "filter.optionPeugeot": "بيجو",
  "filter.optionToyota": "تويوتا",
  "filter.optionRenault": "رينو",
  "filter.optionSkoda": "سكودا",
  "filter.optionSubaru": "سوبارو",
  "filter.optionChevrolet": "شيفروليه",
  "filter.optionVolvo": "فولفو",
  "filter.optionVolkswagen": "فولكس واجن",
  "filter.optionFord": "فورد",
  "filter.optionFiat": "فيات",
  "filter.optionKia": "كيا",
  "filter.optionMazda": "مازدا",
  "filter.optionMercedes": "مرسيدس",
  "filter.optionMitsubishi": "ميتسوبيشي",
  "filter.optionNissan": "نيسان",
  "filter.optionHonda": "هوندا",
  "filter.optionHyundai": "هيونداي",
  "landing.heroTitle": "افتح متجرك الافتراضي مجاناً",
  "landing.heroSubtitle": "اربح من بيتك بدون رأس مال، بدون تعب، وبدون مخزون!",
  "landing.heroTagline": "نظام المحلات الافتراضية الأول في العراق",
  "landing.whatIsTitle": "ما هي المحلات الافتراضية؟",
  "landing.whatIsDesc": "المحلات الافتراضية هي نموذج تجاري ذكي يتيح لك بيع منتجات تجار الجملة دون الحاجة لشرائها مسبقاً أو تخزينها. أنت تعرض المنتج في متجرك بالسعر الذي تحدده، وعند البيع يقوم التاجر بشحن المنتج للزبون، ويكون الفرق ربحك بعد حصة الموقع البالغة 20% من هذا الفرق فقط.",
  "landing.howItWorksTitle": "كيف يعمل النظام؟",
  "landing.step1Title": "أنشئ متجرك الافتراضي مجاناً",
  "landing.step1Desc": "سجّل حسابك وفعّل متجرك الافتراضي بضغطة زر واحدة.",
  "landing.step2Title": "اختر منتجات من تجار الجملة",
  "landing.step2Desc": "تصفح آلاف المنتجات من تجار الجملة الموثوقين، اختر ما يعجبك وأضفه لمتجرك بالسعر الذي تريده أنت!",
  "landing.step3Title": "الزبون يشتري من متجرك",
  "landing.step3Desc": "عندما يشتري زبون من متجرك، يصلك الطلب مباشرة. ويصل للتاجر أيضاً ليقوم بتجهيز الطلب لشركة الشحن.",
  "landing.step4Title": "التاجر يشحن والربح يصلك",
  "landing.step4Desc": "التاجر يشحن المنتج مباشرة للزبون، وعند التسليم يُضاف ربحك تلقائياً لمحفظتك!",
  "landing.badgeNoInventory": "بدون مخزون",
  "landing.badgeNoCapital": "بدون رأس مال",
  "landing.badgeNoShipping": "بدون شحن",
  "landing.badgeFromHome": "من بيتك فقط!",
  "landing.profitTitle": "كم تربح؟",
  "landing.profitYouSetPrice": "أنت تحدد سعر البيع!",
  "landing.profitDifference": "الفرق بين سعرك وسعر التاجر هو هامش ربحك.",
  "landing.profitExample": "مثال عملي:",
  "landing.merchantPrice": "سعر التاجر",
  "landing.price50k": "50,000 د.ع",
  "landing.yourStorePrice": "سعرك في المتجر",
  "landing.price75k": "75,000 د.ع",
  "landing.yourNetProfit": "هامش ربحك",
  "landing.price25k": "25,000 د.ع",
  "landing.platformCommission": "رسوم المخزن السحابي 20% من هامش الربح فقط، لا من سعر البيع، وتُحتسب عند التسليم الناجح. في هذا المثال: 5,000 د.ع من هامش 25,000 د.ع، ويبقى لك 20,000 د.ع. أما منتجات متجرك الخاصة فلا يقتطع الموقع منها أي عمولة، ويسلّمك المندوب ثمنها مباشرة.",
  "landing.featuresTitle": "مميزات النظام",
  "landing.feature1Title": "آلاف المنتجات المتاحة",
  "landing.feature1Desc": "من تجار جملة موثوقين",
  "landing.feature2Title": "محفظة إلكترونية",
  "landing.feature2Desc": "أرباحك تتجمع تلقائياً",
  "landing.feature3Title": "سحب سهل للأرباح",
  "landing.feature3Desc": "زين كاش، تحويل بنكي، أو نقدي",
  "landing.feature4Title": "تتبع الطلبات",
  "landing.feature4Desc": "راقب كل طلباتك بسهولة",
  "landing.feature5Title": "دعم فني متواصل",
  "landing.feature5Desc": "نساعدك في كل خطوة",
  "landing.whoIsForTitle": "لمن هذه الفرصة؟",
  "landing.audience1": "ربات البيوت الباحثات عن دخل إضافي",
  "landing.audience2": "الطلاب والخريجين الجدد",
  "landing.audience3": "الموظفين الراغبين بعمل جانبي",
  "landing.audience4": "أي شخص يريد البدء بالتجارة الإلكترونية",
  "landing.allYouNeed": "كل ما تحتاجه هو هاتف واتصال بالإنترنت!",
  "landing.faqTitle": "الأسئلة الشائعة",
  "landing.faqSubtitle": "كل اللي لازم تعرفه عن سوق العراق",
  "landing.faq1Q": 'شنو يعني "محل افتراضي" وشلون أربح منه؟',
  "landing.faq1A": "المحل الافتراضي هو مساحتك الخاصة بموقعنا، تختار بضاعة التجار اللي تعجبك وتعرضها بسعرك الخاص. ربحك هو الفرق بين سعر التاجر والسعر اللي أنت حددته، بعد حصة الموقع البالغة 20% من هذا الفرق فقط. لا تحتاج مخزن ولا تحتاج تشتري البضاعة مسبقاً.",
  "landing.faq2Q": "زين، التاجر الأصلي راح يشوف السعر اللي أني حطيته؟",
  "landing.faq2A": 'أبداً. نظامنا متطور ويحفظ خصوصيتك؛ التاجر يوصله إشعار إن بضاعته انعرضت، بس ما يقدر يشوف السعر النهائي اللي حطيته للزبون. هذا "سر مهنتك" ومحفوظ يمنا.',
  "landing.faq3Q": "شلون أضمن حقي وأعرف التاجر جهّز البضاعة وشحنها؟",
  "landing.faq3A": 'أول ما يجي طلب، يوصل إشعار إلك وللتاجر ولشركة الشحن بنفس اللحظة. راح تظهر عندك "لوحة تتبع" حية، تشوف بيها المنتج من يطلع من المخزن، يروح للشحن، لحد ما يوصل ليد الزبون. الكل يشوف نفس الحالة لضمان الشفافية.',
  "landing.faq4Q": "منو المسؤول عن توصيل الطلبات للزبائن؟",
  "landing.faq4A": "إحنا متعاقدين مع شركات شحن موثوقة. التاجر يجهز الغرض، وشركة الشحن تستلمه منه وتوصله للعنوان اللي حدده زبونك. أنت دورك المتابعة والتسويق فقط.",
  "landing.faq5Q": "شوكت أستلم أرباحي من المبيعات؟",
  "landing.faq5A": "أرباحك من إعادة بيع منتجات الجملة تتصرف إلك بعد ما يتم استلام المنتج من قبل الزبون وتأكيد الدفع؛ نظامنا المحاسبي يحولها للمحفظة الخاصة بيك بالموقع، وتقدر تسحبها بالطريقة اللي تناسبك. أما منتجاتك الخاصة فثمنها يسلّمك إياه مندوب التوصيل مباشرة عند التسليم، وما يمر بالمحفظة.",
  "landing.faq6Q": "هل يحتاج أدفع رسوم حتى أفتح محل افتراضي؟",
  "landing.faq6A": "لا، فتح المتجر الافتراضي وإضافة المنتجات مجانيان. بيع منتجات متجرك الخاصة بلا عمولة للموقع ويسلّمك المندوب ثمنها مباشرة، وعند إعادة بيع بضائع تجار الجملة تكون حصة الموقع 20% من هامش الربح فقط عند إتمام البيع.",
  "landing.faq7Q": "أنا تاجر وعندي بضاعة، ليش أعرضها بسوق العراق؟",
  "landing.faq7A": "لأننا نوفر لك جيش من المسوقين (أصحاب المحلات الافتراضية) اللي راح يروجون لبضاعتك بكل مكان بالعراق. أنت ركز على جودة المنتج والتجهيز، وإحنا والمسوقين علينا المبيعات.",
  "landing.moreInfoText": "لمعلومات أكثر اكتب لنا وسنجيبك عن أي استفسار",
  "landing.contactUsNow": "راسلنا الآن",
  "landing.contactDialogTitle": "تواصل مع إدارة الموقع",
  "landing.contactDialogDesc": "اكتب لنا استفسارك وسنرد عليك في أقرب وقت",
  "landing.labelName": "الاسم",
  "landing.placeholderName": "اسمك الكامل",
  "landing.labelPhone": "رقم الهاتف",
  "landing.labelAddress": "العنوان",
  "landing.placeholderAddress": "المحافظة / المنطقة",
  "landing.labelMessage": "رسالتك",
  "landing.placeholderMessage": "اكتب استفسارك هنا...",
  "landing.sendMessage": "إرسال الرسالة",
  "landing.error": "خطأ",
  "landing.errorNamePhone": "يرجى إدخال اسمك ورقم هاتفك",
  "landing.errorMessage": "يرجى كتابة رسالتك",
  "landing.sent": "تم الإرسال",
  "landing.sentDesc": "سنتواصل معك في أقرب وقت",
  "landing.errorSending": "حدث خطأ أثناء الإرسال",
  "landing.ctaTitle": "ابدأ الآن مجاناً!",
  "landing.ctaSubtitle": "أنشئ متجرك الافتراضي واختر منتجاتك وابدأ الربح",
  "landing.ctaEarnFromHome": "اربح وانت جالس في بيتك!",
  "landing.openYourStore": "افتح متجرك الافتراضي",
  "listing.requestSent": "تم إرسال الطلب",
  "listing.requestSentDesc": "سيتم مراجعة طلبك من قبل الإدارة والتواصل معك قريباً",
  "listing.error": "خطأ",
  "listing.errorSendingRequest": "حدث خطأ أثناء إرسال الطلب",
  "listing.failedToSubmitRating": "فشل في إرسال التقييم",
  "listing.ratingSubmitted": "تم إرسال التقييم بنجاح",
  "listing.failedToSubmitReport": "فشل في إرسال البلاغ",
  "listing.reportSubmitted": "تم إرسال البلاغ بنجاح. سيتم مراجعته من قبل الإدارة.",
  "listing.linkCopied": "تم نسخ رابط الإعلان!",
  "listing.back": "العودة",
  "listing.saved": "محفوظ",
  "listing.save": "حفظ",
  "listing.nextImage": "الصورة التالية",
  "listing.prevImage": "الصورة السابقة",
  "listing.thumbnail": "صورة مصغرة",
  "listing.premiumListing": "إعلان مميز",
  "listing.iraqiWholesaler": "تاجر جملة عراقي",
  "listing.importerFrom": "مستورد من",
  "listing.exporterFrom": "مصدّر من",
  "listing.listingNumber": "رقم الإعلان",
  "listing.publishDate": "تاريخ النشر",
  "listing.verifiedListing": "إعلان موثق",
  "listing.detailsEmlak": "تفاصيل العقار",
  "listing.detailsVasita": "تفاصيل السيارة",
  "listing.detailsYedekParca": "تفاصيل قطع غيار واكسسوارات السيارات",
  "listing.detailsAlisveris": "تفاصيل المنتج",
  "listing.detailsMakineleri": "تفاصيل الآلة",
  "listing.detailsHizmetler": "تفاصيل الخدمة",
  "listing.detailsDers": "تفاصيل الدرس",
  "listing.detailsIsIlanlari": "تفاصيل الوظيفة",
  "listing.detailsYardimci": "تفاصيل الطلب",
  "listing.detailsHayvanlar": "تفاصيل الحيوان",
  "listing.attrListingType": "نوع الإعلان",
  "listing.attrNegotiable": "قابل للتفاوض",
  "listing.attrExchangeable": "قابل للمبادلة",
  "listing.attrCondition": "الحالة",
  "listing.attrPropertyType": "نوع العقار",
  "listing.attrRooms": "عدد الغرف",
  "listing.attrLivingRooms": "غرف المعيشة",
  "listing.attrBathrooms": "الحمامات",
  "listing.attrGrossArea": "المساحة الإجمالية",
  "listing.attrNetArea": "المساحة الصافية",
  "listing.maxValue": "الحد الأقصى",
  "listing.attrLandArea": "مساحة الأرض",
  "listing.attrFloor": "الطابق",
  "listing.attrTotalFloors": "عدد الطوابق",
  "listing.attrBuildingAge": "عمر البناء",
  "listing.attrUnitsPerFloor": "شقق/طابق",
  "listing.attrFurnishing": "التأثيث",
  "listing.attrHeating": "التدفئة",
  "listing.attrCooling": "التبريد",
  "listing.attrWaterHeating": "سخان المياه",
  "listing.attrFacade": "الواجهة",
  "listing.attrView": "الإطلالة",
  "listing.attrTitleDeed": "سند الملكية",
  "listing.attrEligible": "مناسب لـ",
  "listing.attrDeposit": "التأمين",
  "listing.attrRentPeriod": "مدة الإيجار",
  "listing.attrBrand": "الماركة",
  "listing.attrSeries": "الفئة",
  "listing.attrModel": "الموديل",
  "listing.attrYear": "سنة الصنع",
  "listing.attrMileage": "المسافة المقطوعة",
  "listing.attrFuelType": "نوع الوقود",
  "listing.attrTransmission": "ناقل الحركة",
  "listing.attrEngineSize": "حجم المحرك",
  "listing.attrColor": "اللون",
  "listing.attrBodyType": "نوع الهيكل",
  "listing.attrDriveType": "نظام الدفع",
  "listing.attrOrigin": "المنشأ",
  "listing.attrWarranty": "الضمان",
  "listing.attrServiceHistory": "سجل الصيانة",
  "listing.attrAccidents": "الحوادث",
  "listing.attrSeats": "عدد المقاعد",
  "listing.attrDoors": "عدد الأبواب",
  "listing.attrImportType": "نوع الاستيراد",
  "listing.attrChassis": "رقم الشاصي (VIN)",
  "listing.attrDamagedParts": "القطع المتضررة",
  "listing.attrPaintedParts": "القطع المصبوغة",
  "listing.attrProductCondition": "حالة المنتج",
  "listing.attrAvailableSizes": "المقاسات المتوفرة",
  "listing.attrAgeGroup": "الفئة العمرية",
  "listing.attrAnimalType": "نوع الحيوان",
  "listing.attrAge": "العمر",
  "listing.attrGender": "الجنس",
  "listing.attrVaccinated": "التطعيم",
  "listing.bodyConditionReport": "تقرير حالة الهيكل",
  "listing.partFrontBumper": "الدعامية الأمامية",
  "listing.partRearBumper": "الدعامية الخلفية",
  "listing.partHood": "البنيد",
  "listing.partTrunk": "صندوق السيارة (الجنطة)",
  "listing.partRoof": "السقف",
  "listing.partFrontLeftFender": "الجملغ الأمامي جهة السائق",
  "listing.partFrontRightFender": "الجملغ الأمامي الجهة المعاكسة للسائق",
  "listing.partRearLeftFender": "الجملغ الخلفي جهة السائق",
  "listing.partRearRightFender": "الجملغ الخلفي الجهة المعاكسة للسائق",
  "listing.partFrontLeftDoor": "الباب الأمامي جهة السائق",
  "listing.partFrontRightDoor": "الباب الأمامي الجهة المعاكسة للسائق",
  "listing.partRearLeftDoor": "الباب الخلفي جهة السائق",
  "listing.partRearRightDoor": "الباب الخلفي الجهة المعاكسة للسائق",
  "listing.condOriginal": "أصلي",
  "listing.condPainted": "مصبوغ",
  "listing.condReplaced": "مبدل",
  "listing.condNotSpecified": "غير محدد",
  "listing.dirFront": "أمام",
  "listing.dirRear": "خلف",
  "listing.groupFrontParts": "الأجزاء الأمامية (الدعامية، البنيد، الجملغ)",
  "listing.groupDoors": "الأبواب",
  "listing.groupRearParts": "الأجزاء الخلفية والسقف",
  "listing.noBodyCondition": "لم يتم تحديد حالة الهيكل",
  "listing.sqm": "م²",
  "listing.km": "كم",
  "listing.wholesaleRequirement": "لشراء منتجات الجملة، يجب أن يكون لديك متجر افتراضي أو محل مفرد",
  "listing.createVirtualStore": "إنشاء متجر افتراضي",
  "listing.addMore": "+ أضف المزيد",
  "listing.checkout": "إتمام الشراء",
  "listing.pleaseLogin": "يرجى تسجيل الدخول",
  "listing.loginToAddCart": "يجب تسجيل الدخول لإضافة المنتجات إلى السلة",
  "listing.confirmDelete": "هل أنت متأكد؟",
  "listing.confirmDeleteDesc": "لا يمكن التراجع عن هذا الإجراء. سيتم حذف إعلانك نهائياً.",
  "listing.cancel": "إلغاء",
  "listing.upgradePremium": "ترقية لإعلان مميز",
  "listing.upgradeDesc": "اجعل إعلانك يظهر في أعلى النتائج واحصل على مشاهدات أكثر",
  "listing.requestPending": "طلبك قيد المراجعة",
  "listing.requestApproved": "تمت الموافقة على طلبك",
  "listing.requestRejected": "تم رفض الطلب السابق",
  "listing.requestUpgrade": "طلب ترقية (خدمة مدفوعة)",
  "listing.openChat": "افتح دردشة مع البائع",
  "listing.loginToChat": "سجل دخولك للتواصل مع البائع",
  "listing.dropshipping": "متجر افتراضي",
  "listing.dropshippingDesc": "أضفه إلى متجرك دون شرائه مسبقًا، وأعد بيعه بسعرك ضمن الضوابط",
  "listing.addingToInventory": "جاري الإضافة...",
  "listing.addToInventory": "أضف لمخزوني",
  "listing.buying": "جاري الشراء...",
  "listing.buyAndResell": "اشتري وأعد البيع",
  "listing.removeFromCart": "إزالة من السلة",
  "listing.contactWhatsApp": "تواصل عبر واتساب",
  "listing.sellerInfo": "معلومات البائع",
  "listing.sellerStoreName": "متجر البائع",
  "listing.storeSpecialty": "اختصاص المتجر",
  "listing.storePhone": "هاتف المتجر",
  "listing.storeLocation": "موقع المتجر",
  "listing.visitStore": "زيارة المتجر",
  "listing.rateSeller": "قيّم البائع",
  "listing.loginToRate": "سجّل دخول لتقييم البائع",
  "listing.loginToReport": "سجّل دخول للإبلاغ عن الإعلان",
  "listing.premiumSeller": "معلن مميز",
  "listing.officeOwner": "صاحب المكتب:",
  "listing.user": "مستخدم",
  "listing.memberSince": "عضو منذ",
  "listing.customerReviews": "تقييمات الزبائن",
  "listing.customer": "زبون",
  "listing.verifiedBuyer": "مشتري موثق",
  "listing.moreReviews": "تقييمات أخرى...",
  "listing.andMore": "وهناك",
  "listing.safetyTips": "نصائح السلامة",
  "listing.safetyTip1": "قابل البائع في مكان عام وآمن",
  "listing.safetyTip2": "لا تحوّل المال قبل المعاينة",
  "listing.safetyTip3": "افحص حالة المنتج بعناية",
  "listing.reportListing": "الإبلاغ عن هذا الإعلان",
  "listing.shareExperience": "شاركنا تجربتك مع هذا البائع لمساعدة الآخرين",
  "listing.chooseRating": "اختر تقييمك",
  "listing.ratingBad": "سيء",
  "listing.ratingFair": "مقبول",
  "listing.ratingGood": "جيد",
  "listing.ratingVeryGood": "جيد جداً",
  "listing.ratingExcellent": "ممتاز",
  "listing.writeComment": "اكتب تعليقك (اختياري)...",
  "listing.sending": "جاري الإرسال...",
  "listing.submitRating": "إرسال التقييم",
  "listing.reportDialogTitle": "الإبلاغ عن هذا الإعلان",
  "listing.reportDialogDesc": "أرسل بلاغك للإدارة وسنقوم بمراجعته في أقرب وقت",
  "listing.listingLink": "رابط الإعلان:",
  "listing.yourName": "اسمك *",
  "listing.enterFullName": "أدخل اسمك الكامل",
  "listing.yourPhone": "رقم هاتفك (اختياري)",
  "listing.reportReason": "سبب الإبلاغ *",
  "listing.selectReason": "اختر سبب الإبلاغ",
  "listing.reasonFake": "إعلان وهمي / احتيال",
  "listing.reasonWrongCategory": "تصنيف خاطئ",
  "listing.reasonDuplicate": "إعلان مكرر",
  "listing.reasonInappropriate": "محتوى غير لائق",
  "listing.reasonWrongPrice": "سعر غير صحيح",
  "listing.reasonSold": "المنتج مباع",
  "listing.reasonContactIssue": "مشكلة في التواصل مع البائع",
  "listing.reasonQuality": "جودة المنتج لا تتطابق مع الوصف",
  "listing.reasonOther": "سبب آخر",
  "listing.complaintDetails": "تفاصيل الشكوى *",
  "listing.explainProblem": "اشرح المشكلة بالتفصيل...",
  "listing.submitReport": "إرسال البلاغ",
  "listing.chatWithSeller": "دردشة مع البائع",
  "listing.loginToContact": "سجل دخولك للتواصل",
  "listing.notFoundDesc": "ربما تم حذف هذا الإعلان أو أنه غير متوفر.",
  "comp.share": "مشاركة",
  "comp.copyLink": "نسخ الرابط",
  "comp.linkCopied": "تم نسخ الرابط",
  "comp.copyFailed": "فشل نسخ الرابط",
  "comp.whatsapp": "واتساب",
  "comp.telegram": "تيليجرام",
  "comp.facebook": "فيسبوك",
  "comp.compare": "مقارنة",
  "comp.inCompare": "في المقارنة",
  "comp.addedToCompare": "تمت الإضافة للمقارنة",
  "comp.removedFromCompare": "تمت الإزالة من المقارنة",
  "comp.priceAlert": "تنبيه السعر",
  "comp.cancelAlert": "إلغاء التنبيه",
  "comp.priceAlertCreated": "تم إنشاء تنبيه السعر",
  "comp.priceAlertNotify": "سنعلمك عند انخفاض السعر",
  "comp.priceAlertDeleted": "تم إلغاء تنبيه السعر",
  "comp.loginRequired": "يجب تسجيل الدخول",
  "comp.loginForAlerts": "سجل دخولك لإنشاء تنبيهات الأسعار",
  "comp.createPriceAlert": "إنشاء تنبيه سعر",
  "comp.alertDescription": "سنعلمك عندما ينخفض السعر إلى المبلغ المحدد أو أقل",
  "comp.currentPrice": "السعر الحالي",
  "comp.targetPrice": "السعر المستهدف",
  "comp.enterTargetPrice": "أدخل السعر المستهدف",
  "comp.enterValidPrice": "أدخل سعر صحيح",
  "comp.targetMustBeLower": "السعر المستهدف يجب أن يكون أقل من السعر الحالي",
  "comp.cancel": "إلغاء",
  "comp.createAlert": "إنشاء التنبيه",
  "comp.contactUs": "تواصل معنا",
  "comp.freeAd": "أضف منتجك",
  "comp.error": "خطأ",
  "attrVal.أبيض": "أبيض",
  "attrVal.أسود": "أسود",
  "attrVal.فضي": "فضي",
  "attrVal.رمادي": "رمادي",
  "attrVal.أحمر": "أحمر",
  "attrVal.أزرق": "أزرق",
  "attrVal.أخضر": "أخضر",
  "attrVal.بني": "بني",
  "attrVal.بيج": "بيج",
  "attrVal.ذهبي": "ذهبي",
  "attrVal.برتقالي": "برتقالي",
  "attrVal.أصفر": "أصفر",
  "attrVal.بنفسجي": "بنفسجي",
  "attrVal.برونزي": "برونزي",
  "attrVal.شامبين": "شامبين",
  "attrVal.لؤلؤي": "لؤلؤي",
  "attrVal.أخرى": "أخرى",
  "attrVal.بنزين": "بنزين",
  "attrVal.ديزل": "ديزل",
  "attrVal.كهربائي": "كهربائي",
  "attrVal.هجين": "هجين",
  "attrVal.هجين قابل للشحن": "هجين قابل للشحن",
  "attrVal.غاز (LPG)": "غاز (LPG)",
  "attrVal.غاز طبيعي (CNG)": "غاز طبيعي (CNG)",
  "attrVal.أوتوماتيك": "أوتوماتيك",
  "attrVal.مانيوال (عادي)": "مانيوال (عادي)",
  "attrVal.CVT": "CVT",
  "attrVal.DCT (دبل كلتش)": "DCT (دبل كلتش)",
  "attrVal.تيبترونيك": "تيبترونيك",
  "attrVal.نصف أوتوماتيك": "نصف أوتوماتيك",
  "attrVal.جديد": "جديد",
  "attrVal.مستعمل": "مستعمل",
  "attrVal.ممتاز": "ممتاز",
  "attrVal.جيد جداً": "جيد جداً",
  "attrVal.جيد": "جيد",
  "attrVal.مقبول": "مقبول",
  "attrVal.نعم": "نعم",
  "attrVal.لا": "لا",
  "attrVal.true": "نعم",
  "attrVal.false": "لا",
  "attrVal.وارد أمريكي": "وارد أمريكي",
  "attrVal.وارد خليجي": "وارد خليجي",
  "attrVal.وارد أوروبي": "وارد أوروبي",
  "attrVal.مفروش": "مفروش",
  "attrVal.نصف مفروش": "نصف مفروش",
  "attrVal.فارغ": "فارغ",
  "attrVal.طابو أخضر (ملكية)": "طابو أخضر (ملكية)",
  "attrVal.طابو أصفر (وقف)": "طابو أصفر (وقف)",
  "attrVal.حق تصرف": "حق تصرف",
  "attrVal.عقد خارجي": "عقد خارجي",
  "attrVal.بدون سند": "بدون سند",
  "attrVal.ذكر": "ذكر",
  "attrVal.أنثى": "أنثى",
  "attrVal.لا يوجد ضمان": "لا يوجد ضمان",
  "attrVal.ضمان المصنع": "ضمان المصنع",
  "attrVal.ضمان الوكيل": "ضمان الوكيل",
  "attrVal.كفالة الوكيل": "كفالة الوكيل",
  "attrVal.جديد (0 كم)": "جديد (0 كم)",
  "attrVal.مستعمل - ممتاز": "مستعمل - ممتاز",
  "attrVal.مستعمل - جيد جداً": "مستعمل - جيد جداً",
  "attrVal.مستعمل - جيد": "مستعمل - جيد",
  "attrVal.يحتاج صيانة": "يحتاج صيانة",
  "attrVal.متضررة": "متضررة",
  "attrVal.للقطع": "للقطع",
  "attrVal.معاد تعقيم": "معاد تعقيم",
  "attrVal.معاد تصنيع": "معاد تصنيع",
  "attrVal.سيدان": "سيدان",
  "attrVal.هاتشباك": "هاتشباك",
  "attrVal.SUV": "SUV",
  "attrVal.كروس أوفر": "كروس أوفر",
  "attrVal.بيك أب": "بيك أب",
  "attrVal.كوبيه": "كوبيه",
  "attrVal.كابريو": "كابريو",
  "attrVal.فان": "فان",
  "attrVal.ستيشن واجن": "ستيشن واجن",
  "attrVal.ليموزين": "ليموزين",
  "attrVal.دفع أمامي (FWD)": "دفع أمامي (FWD)",
  "attrVal.دفع خلفي (RWD)": "دفع خلفي (RWD)",
  "attrVal.دفع رباعي (4WD)": "دفع رباعي (4WD)",
  "attrVal.دفع كلي (AWD)": "دفع كلي (AWD)",
  "attrVal.خليجي": "خليجي",
  "attrVal.أمريكي": "أمريكي",
  "attrVal.أوروبي": "أوروبي",
  "attrVal.كوري": "كوري",
  "attrVal.ياباني": "ياباني",
  "attrVal.صيني": "صيني",
  "attrVal.عراقي": "عراقي",
  "attrVal.يوجد ضمان وكالة": "يوجد ضمان وكالة",
  "attrVal.يوجد ضمان طرف ثالث": "يوجد ضمان طرف ثالث",
  "attrVal.يوجد ضمان": "يوجد ضمان",
  "attrVal.صيانة وكالة كاملة": "صيانة وكالة كاملة",
  "attrVal.صيانة وكالة جزئية": "صيانة وكالة جزئية",
  "attrVal.صيانة خارجية": "صيانة خارجية",
  "attrVal.غير متوفر": "غير متوفر",
  "attrVal.بدون حوادث": "بدون حوادث",
  "attrVal.حادث بسيط": "حادث بسيط",
  "attrVal.حادث متوسط": "حادث متوسط",
  "attrVal.حادث شديد": "حادث شديد",
  "attrVal.غير معروف": "غير معروف",
  "attrVal.للبيع": "للبيع",
  "attrVal.للإيجار": "للإيجار",
  "attrVal.للإيجار اليومي": "للإيجار اليومي",
  "attrVal.شقة": "شقة",
  "attrVal.فيلا": "فيلا",
  "attrVal.منزل مستقل": "منزل مستقل",
  "attrVal.بيت طابقين": "بيت طابقين",
  "attrVal.بيت ريفي": "بيت ريفي",
  "attrVal.مزرعة": "مزرعة",
  "attrVal.محل تجاري": "محل تجاري",
  "attrVal.مكتب": "مكتب",
  "attrVal.مستودع": "مستودع",
  "attrVal.أرض": "أرض",
  "attrVal.أرض سكنية": "أرض سكنية",
  "attrVal.أرض تجارية": "أرض تجارية",
  "attrVal.أرض زراعية": "أرض زراعية",
  "attrVal.مصنع": "مصنع",
  "attrVal.فندق": "فندق",
  "attrVal.مطعم": "مطعم",
  "attrVal.استوديو": "استوديو",
  "attrVal.سرداب": "سرداب",
  "attrVal.طابق الحديقة": "طابق الحديقة",
  "attrVal.الأرضي": "الأرضي",
  "attrVal.طابق مرتفع": "طابق مرتفع",
  "attrVal.0 (جديد)": "0 (جديد)",
  "attrVal.1-5 سنوات": "1-5 سنوات",
  "attrVal.6-10 سنوات": "6-10 سنوات",
  "attrVal.11-15 سنة": "11-15 سنة",
  "attrVal.16-20 سنة": "16-20 سنة",
  "attrVal.21-25 سنة": "21-25 سنة",
  "attrVal.26-30 سنة": "26-30 سنة",
  "attrVal.أكثر من 30 سنة": "أكثر من 30 سنة",
  "attrVal.مفروش بالكامل": "مفروش بالكامل",
  "attrVal.غير مفروش": "غير مفروش",
  "attrVal.غاز طبيعي (كومبي)": "غاز طبيعي (كومبي)",
  "attrVal.تدفئة مركزية": "تدفئة مركزية",
  "attrVal.مكيف سبليت": "مكيف سبليت",
  "attrVal.تدفئة أرضية": "تدفئة أرضية",
  "attrVal.مدفأة": "مدفأة",
  "attrVal.بدون تدفئة": "بدون تدفئة",
  "attrVal.مكيف مركزي": "مكيف مركزي",
  "attrVal.مكيف شباك": "مكيف شباك",
  "attrVal.بدون تبريد": "بدون تبريد",
  "attrVal.غاز": "غاز",
  "attrVal.طاقة شمسية": "طاقة شمسية",
  "attrVal.مركزي": "مركزي",
  "attrVal.مصعد": "مصعد",
  "attrVal.موقف سيارات": "موقف سيارات",
  "attrVal.موقف سيارات مغطى": "موقف سيارات مغطى",
  "attrVal.حديقة خاصة": "حديقة خاصة",
  "attrVal.تراس": "تراس",
  "attrVal.بلكونة": "بلكونة",
  "attrVal.مسبح": "مسبح",
  "attrVal.مسبح مشترك": "مسبح مشترك",
  "attrVal.صالة رياضية": "صالة رياضية",
  "attrVal.ساونا": "ساونا",
  "attrVal.حمام تركي": "حمام تركي",
  "attrVal.أمن وحراسة 24 ساعة": "أمن وحراسة 24 ساعة",
  "attrVal.كاميرات مراقبة": "كاميرات مراقبة",
  "attrVal.إنتركم مرئي": "إنتركم مرئي",
  "attrVal.مولد كهربائي": "مولد كهربائي",
  "attrVal.خزان مياه": "خزان مياه",
  "attrVal.غرفة خادمة": "غرفة خادمة",
  "attrVal.غرفة غسيل": "غرفة غسيل",
  "attrVal.مخزن": "مخزن",
  "attrVal.غرفة ملابس (دريسنج)": "غرفة ملابس (دريسنج)",
  "attrVal.مطبخ مفتوح": "مطبخ مفتوح",
  "attrVal.مطبخ مغلق": "مطبخ مغلق",
  "attrVal.جاكوزي": "جاكوزي",
  "attrVal.شرفة زجاجية": "شرفة زجاجية",
  "attrVal.عازل حراري": "عازل حراري",
  "attrVal.عازل صوتي": "عازل صوتي",
  "attrVal.باب حديد": "باب حديد",
  "attrVal.ستائر": "ستائر",
  "attrVal.مكيفات": "مكيفات",
  "attrVal.أثاث مطبخ": "أثاث مطبخ",
  "attrVal.غاز مركزي": "غاز مركزي",
  "attrVal.إنترنت ألياف": "إنترنت ألياف",
  "attrVal.طابو ملك صرف سكني": "طابو ملك صرف سكني",
  "attrVal.طابو ملك صرف زراعي": "طابو ملك صرف زراعي",
  "attrVal.طابو ملك صرف صناعي": "طابو ملك صرف صناعي",
  "attrVal.طابو ملك صرف تجاري": "طابو ملك صرف تجاري",
  "attrVal.سند زراعي رقم 25": "سند زراعي رقم 25",
  "attrVal.سند زراعي رقم 17": "سند زراعي رقم 17",
  "attrVal.الجميع": "الجميع",
  "attrVal.عائلات فقط": "عائلات فقط",
  "attrVal.عزاب": "عزاب",
  "attrVal.طلاب": "طلاب",
  "attrVal.شركات": "شركات",
  "attrVal.يوم واحد": "يوم واحد",
  "attrVal.أسبوع": "أسبوع",
  "attrVal.شهر": "شهر",
  "attrVal.3 أشهر": "3 أشهر",
  "attrVal.6 أشهر": "6 أشهر",
  "attrVal.سنة": "سنة",
  "attrVal.أزرق غامق": "أزرق غامق",
  "attrVal.وردي": "وردي",
  "attrVal.متعدد الألوان": "متعدد الألوان",
  "attrVal.حديث الولادة (0-3 أشهر)": "حديث الولادة (0-3 أشهر)",
  "attrVal.رضيع (3-12 شهر)": "رضيع (3-12 شهر)",
  "attrVal.1-2 سنة": "1-2 سنة",
  "attrVal.3-5 سنوات": "3-5 سنوات",
  "attrVal.6-8 سنوات": "6-8 سنوات",
  "attrVal.9-12 سنة": "9-12 سنة",
  "attrVal.13+ سنة": "13+ سنة",
  "attrVal.جميع الأعمار": "جميع الأعمار",
  "attrVal.ولد": "ولد",
  "attrVal.بنت": "بنت",
  "attrVal.للجنسين": "للجنسين",
  "attrVal.مقاس موحد": "مقاس موحد",
  "attrVal.وزارة الصحة": "وزارة الصحة",
  "attrVal.بدون": "بدون",
  "attrVal.منزلي": "منزلي",
  "attrVal.في الموقع": "في الموقع",
  "attrVal.أونلاين": "أونلاين",
  "attrVal.الكل": "الكل",
  "attrVal.متاح يومياً": "متاح يومياً",
  "attrVal.أيام العمل فقط": "أيام العمل فقط",
  "attrVal.عطلة نهاية الأسبوع": "عطلة نهاية الأسبوع",
  "attrVal.بالموعد": "بالموعد",
  "attrVal.حضوري": "حضوري",
  "attrVal.كلاهما": "كلاهما",
  "attrVal.أقل من سنة": "أقل من سنة",
  "attrVal.1-3 سنوات": "1-3 سنوات",
  "attrVal.5-10 سنوات": "5-10 سنوات",
  "attrVal.أكثر من 10 سنوات": "أكثر من 10 سنوات",
  "attrVal.ابتدائي": "ابتدائي",
  "attrVal.متوسط": "متوسط",
  "attrVal.ثانوي": "ثانوي",
  "attrVal.جامعي": "جامعي",
  "attrVal.دوام كامل": "دوام كامل",
  "attrVal.دوام جزئي": "دوام جزئي",
  "attrVal.عن بعد": "عن بعد",
  "attrVal.عقد مؤقت": "عقد مؤقت",
  "attrVal.تدريب": "تدريب",
  "attrVal.لا يشترط": "لا يشترط",
  "attrVal.دبلوم": "دبلوم",
  "attrVal.بكالوريوس": "بكالوريوس",
  "attrVal.ماجستير": "ماجستير",
  "attrVal.دكتوراه": "دكتوراه",
  "attrVal.مؤقت": "مؤقت",
  "attrVal.يوفر سكن": "يوفر سكن",
  "attrVal.لا يوفر سكن": "لا يوفر سكن",
  "attrVal.أقل من شهر": "أقل من شهر",
  "attrVal.1-6 شهور": "1-6 شهور",
  "attrVal.6-12 شهر": "6-12 شهر",
  "attrVal.2-5 سنوات": "2-5 سنوات",
  "attrVal.أكثر من 5 سنوات": "أكثر من 5 سنوات",
  "attrVal.مطعّم": "مطعّم",
  "attrVal.غير مطعم": "غير مطعم",
  "attrVal.مسجلة": "مسجلة",
  "attrVal.غير مسجلة": "غير مسجلة",
  "attrVal.قيد التسجيل": "قيد التسجيل",
  "attrVal.مقطورة مسطحة": "مقطورة مسطحة",
  "attrVal.مقطورة صندوق": "مقطورة صندوق",
  "attrVal.مقطورة مبردة": "مقطورة مبردة",
  "attrVal.مقطورة صهريج": "مقطورة صهريج",
  "attrVal.مقطورة نقل سيارات": "مقطورة نقل سيارات",
  "attrVal.طائرة ركاب": "طائرة ركاب",
  "attrVal.طائرة شحن": "طائرة شحن",
  "attrVal.طائرة خاصة": "طائرة خاصة",
  "attrVal.طائرة تدريب": "طائرة تدريب",
  "attrVal.طائرة رياضية": "طائرة رياضية",
  "attrVal.طائرة زراعية": "طائرة زراعية",
  "attrVal.محرك مكبسي": "محرك مكبسي",
  "attrVal.توربيني": "توربيني",
  "attrVal.نفاث": "نفاث",
  "attrVal.نقل ركاب": "نقل ركاب",
  "attrVal.شحن": "شحن",
  "attrVal.طبي": "طبي",
  "attrVal.بحث وإنقاذ": "بحث وإنقاذ",
  "attrVal.سياحي": "سياحي",
  "attrVal.زراعي": "زراعي",
  "attrVal.قارب صيد": "قارب صيد",
  "attrVal.قارب نزهة": "قارب نزهة",
  "attrVal.قارب سباق": "قارب سباق",
  "attrVal.قارب عمل": "قارب عمل",
  "attrVal.خارجي": "خارجي",
  "attrVal.داخلي": "داخلي",
  "attrVal.شراعي": "شراعي",
  "attrVal.موتور يخت": "موتور يخت",
  "attrVal.كاتاماران": "كاتاماران",
  "attrVal.ميجا يخت": "ميجا يخت",
  "landing.backToHome": "العودة للرئيسية",
  "quickGuide.trigger": "كيف يعمل الموقع؟",
  "quickGuide.tooltip": "اضغط هنا لتعرف كيف يعمل الموقع!",
  "quickGuide.bannerText": "جديد هنا؟ اضغط لتعرف كيف يعمل الموقع ✨",
  "helpCenter.badge": "مركز المساعدة",
  "helpCenter.title": "مركز مساعدة Iraqsooq",
  "helpCenter.subtitle": "إجابات سريعة على أكثر الأسئلة شيوعاً",
  "helpCenter.buyer.title": "للمشترين",
  "helpCenter.buyer.q1": "كيف أضمن حقوقي كمشتري؟",
  "helpCenter.buyer.a1": "نظامنا يستخدم \"رمز التسليم\" (12 حرف). لا تعطِ هذا الرمز للسائق إلا بعد فحص المنتج وقبوله. هذا هو ضمانك الوحيد.",
  "helpCenter.buyer.q2": "ما هي طرق الدفع المتاحة؟",
  "helpCenter.buyer.a2": "نعتمد حالياً على الدفع عند الاستلام (COD)، وسنوفّر قريباً وسائل دفع إلكترونية مثل كيو كارد (Q-Card)، زين كاش (Zain Cash)، وآسيا حوالة (AsiaHawala).",
  "helpCenter.virtualStore.title": "لأصحاب المتاجر الافتراضية",
  "helpCenter.store.q1": "هل أحتاج رأس مال أو مخزن؟",
  "helpCenter.store.a1": "لا. التسجيل وإنشاء المتجر مجاني بالكامل. بيع منتجات متجرك الخاصة بلا أي عمولة للموقع، ويسلّمك مندوب التوصيل ثمنها مباشرة. وعند إضافة منتجات تجار الجملة تحدد هامش ربحك، وسنربح حين تربح على شكل ٢٠٪ من هامش ربحك فقط كأجور خزن سحابي.",
  "helpCenter.store.q2": "متى أقدر أسحب أرباحي؟",
  "helpCenter.store.a2": "أرباح إعادة بيع بضائع الجملة تظهر في محفظتك فوراً بعد التسليم، ويمكنك طلب سحبها بعد 24 إلى 48 ساعة من التسليم الناجح عبر كيو كارد، زين كاش، أو آسيا حوالة. أما ثمن منتجاتك الخاصة فيسلّمك إياه مندوب التوصيل مباشرة ولا يمر بالمحفظة.",
  "helpCenter.wholesaler.title": "لتجار الجملة",
  "helpCenter.wholesaler.q1": "من يتولى التوصيل؟",
  "helpCenter.wholesaler.a1": "أنت مسؤول عن التجهيز والتغليف. يمكنك استخدام خدمة التوصيل الخاصة بك أو الاعتماد على \"شبكة توصيل Iraqsooq\" التي تغطي جميع المحافظات.",
  "helpCenter.askAI": "اسأل مساعدنا الذكي",
  "helpCenter.aiPlaceholder": "اكتب سؤالك هنا...",
  "helpCenter.aiReplyLabel": "رد المساعد الذكي",
  "helpCenter.aiError": "عذراً، حدث خطأ. حاول مرة أخرى.",
  "stores.allStores": "المحلات الافتراضية",
  "stores.pageDescription": "تصفح جميع المحلات الافتراضية في سوق العراق",
  "stores.pageSubtitle": "تصفح المتاجر واكتشف أفضل المنتجات من تجار العراق",
  "stores.searchPlaceholder": "ابحث باسم المتجر...",
  "stores.filterByCategory": "فلترة حسب التخصص",
  "stores.allCategories": "جميع التخصصات",
  "stores.storeFound": "متجر",
  "stores.products": "منتج",
  "stores.visitStore": "زيارة المتجر",
  "stores.noStoresFound": "لا توجد متاجر",
  "stores.tryDifferentSearch": "جرب بحثاً مختلفاً أو غيّر الفلتر",
  "stores.noStoresYet": "لم يتم إنشاء متاجر افتراضية بعد",
  "stores.generalStore": "متجر عام",
  "stores.activeNow": "نشط الآن",
  "stores.activeToday": "نشط اليوم",
  "stores.inactive": "غير نشط",
  "placeholder.search": "ابحث...",
  "placeholder.searchBy": "ابحث عن {field}...",
  "placeholder.searchStore": "ابحث باسم المتجر...",
  "placeholder.searchBuyer": "ابحث باسم المشتري، المدينة، رقم الهاتف...",
  "placeholder.searchCategory": "ابحث عن قسم أو فرع...",
  "placeholder.searchSubcategory": "ابحث في الأقسام الفرعية...",
  "placeholder.writeDescription": "اكتب وصفاً...",
  "placeholder.writeMessage": "اكتب رسالتك...",
  "placeholder.askQuestion": "اكتب سؤالك هنا...",
  "filter.title": "الفلاتر",
  "filter.reset": "إعادة ضبط الفلاتر",
  "filter.moreFilters": "المزيد من الفلاتر",
  "filter.fewerFilters": "إخفاء الفلاتر الإضافية",
  "filter.clearAll": "مسح الكل",
  "filter.searchIn": "ابحث في {category}...",
  "filter.activeFilters": "الفلاتر المطبّقة",
  "filter.selectedSection": "القسم المحدد",
  "filter.removeFilter": "إزالة {label}",
  "filter.search": "البحث",
  "filter.status": "الحالة",
  "filter.newStatus": "الحالة الجديدة",
  "empty.noData": "لا توجد بيانات",
  "empty.noDeliveries": "لا توجد توصيلات",
  "empty.noStores": "لا توجد محلات",
  "empty.tryDifferent": "جرّب تغيير كلمة البحث",
  "market.shorja": "سوق الشورجة",
  "market.jamila": "سوق جميلة",
  "market.arabi": "السوق العربي",
  "market.nasara": "عگد النصارى",
  "market.sinak": "سوق السنك",
  "market.mutanabbi": "سوق المتنبي",
  "market.mredi": "سوق مريدي",
  "market.bayaa": "سوق البياع",
  "market.sinaa": "شارع الصناعة",
  "status.shipped": "تم التسليم لمندوب التوصيل",
  "status.delivered": "تم التسليم",
  "status.rejected": "تم الرفض",
  "status.approved": "تمت الموافقة",
  "status.paid": "تم الدفع",
  "status.pending": "في الانتظار",
  "label.productCondition": "حالة المنتج",
  "condition.requiredTitle": "حدّد حالة المنتج",
  "condition.requiredDesc": "اختر «جديد» أو «مستعمل» قبل الحفظ.",
  "condition.saved": "حُفظت حالة المنتج",
  "condition.saveError": "تعذّر حفظ حالة المنتج",
  "condition.promptTitle": "حدّد حالة هذا المنتج",
  "condition.promptDesc": "أُضيف هذا المنتج قبل اعتماد تصنيف «جديد / مستعمل». اختر حالته؛ يُحفظ الاختيار مباشرة دون إعادة نشر المنتج أو تغيير رقمه أو صوره أو سعره.",
  "condition.later": "لاحقًا",
  "condition.backToStore": "العودة إلى متجري",
  "condition.needsBadge": "يحتاج تحديد الحالة",
  "condition.banner": "لديك {count} من المنتجات تحتاج تحديد الحالة («جديد» أو «مستعمل») لتظهر في نتائج البحث بحسب حالتها.",
  "condition.allDone": "حُدّدت حالة جميع منتجاتك. شكرًا لك.",
  "condition.showAll": "عرض كل المنتجات",
  "condition.fixNow": "تصحيح منتجاتي",
  "condition.setAction": "حدّد الحالة",
  "label.paymentStatus": "حالة الدفع",
  "label.orderStatus": "حالة الطلب",
  "label.newStatus": "الحالة الجديدة",
  "label.condition": "الحالة",
  "label.updatePaymentStatus": "تحديث حالة الدفع",
  "label.certifiedAgent": "وكيل معتمد",
  "message.welcome": "مرحباً بك في سوق العراق!",
  "message.welcomeWholesaler": "مرحباً بك كتاجر جملة في سوق العراق!",
  "message.welcomeAdmin": "مرحباً بك في لوحة التحكم",
  "message.autoFilledFields": "تم ملء الحقول - يمكنك التعديل عليها",
  "message.paymentApproved": "سيتم الموافقة على سحب",
  "message.requestRejected": "سيتم رفض الطلب وإرجاع المبلغ للمستخدم",
  "message.qrAutoFilled": "تم ملء البيانات تلقائياً من رمز QR",
  "message.last4Digits": "أدخل آخر 4 أرقام من هاتف المشتري لإتمام التسليم",
  "message.agentNeedDigits": "المندوب سيحتاج آخر 4 أرقام من هاتف المشتري لإتمام التسليم",
  "message.noWholesaleProducts": "لم يتم العثور على منتجات جملة حالياً. يمكنك إضافة منتج جملة جديد.",
  "message.requireLogin": "يجب تسجيل الدخول",
  "message.loginRequired": "يجب تسجيل الدخول لإرسال طلب التمييز",
  "message.confirmReject": "بعد الرفض لا يمكن التراجع. سيتم إشعار المتجر الافتراضي والمشتري فوراً.",
  "message.transferNote": "تأكد من صحة الرقم — سيتم التحويل عبر شبكة آسيا حوالة خلال 24 ساعة من الموافقة.",
  "message.orderReceived": "✅ تم استلام طلبك بنجاح!",
  "message.maxProductsReached": "عذراً، الحد الأقصى للمنتجات هو",
  "message.deleteInactiveProducts": "يرجى حذف المنتجات غير النشطة لتتمكن من إضافة بضاعة جديدة.",
  "message.compressionInfo": "يتم ضغط الصورة قبل الرفع لتوفير البيانات",
  "message.autoCompression": "يتم ضغط الصور تلقائياً وتحويلها إلى WebP للحصول على أفضل جودة وأصغر حجم",
  "message.carRecognized": "تم التعرف على السيارة",
  "message.carNotRecognized": "لم يتم التعرف",
  "message.carRecognitionFailed": "لم نتمكن من التعرف على السيارة. حاول رفع صور أوضح.",
  "message.imageAnalysisError": "حدث خطأ أثناء تحليل الصور. يرجى المحاولة مرة أخرى.",
  "message.publishFailed": "فشل نشر الإعلان",
  "message.listingPublishError": "خطأ في نشر الإعلان",
  "message.loadListingsError": "فشل تحميل الإعلانات",
  "message.loadProductsError": "فشل في جلب المنتجات",
  "message.maxProductsExceeded": "تم الوصول للحد الأقصى",
  "message.imageUploadSuccess": "تم الرفع",
  "message.imagesUploaded": "تم رفع صورة بنجاح",
  "message.uploadError": "خطأ في الرفع",
  "message.imagePrimaryChanged": "تم تغيير الصورة الرئيسية",
  "message.wholesaleAddedSuccess": "تمت الإضافة بنجاح! 🎉",
  "message.wholesaleAddedDesc": "تم إضافة إلى مخزونك السحابي بسعر بيع",
  "message.wholesaleAddFailed": "فشل في الإضافة",
  "message.wholesaleAddError": "حدث خطأ أثناء إضافة المنتج. حاول مرة أخرى.",
  "message.wholesaleAdded": "تمت الإضافة",
  "message.notificationsEnabled": "تم تفعيل الإشعارات ✅",
  "message.completePurchase": "إتمام الشراء",
  "message.otpGenerated": "تم توليد رمز التحقق محلياً",
  "message.otpSendFailed": "فشل الإرسال",
  "message.otpVerifySuccess": "تم التحقق بنجاح ✅",
  "message.otpVerifyFailed": "فشل التحقق",
  "message.openDisputeFailed": "تم فتح النزاع",
  "message.disputeNotificationSoon": "سيتواصل معك الأدمن قريباً",
  "message.loginError": "خطأ في تسجيل الدخول",
  "message.serverError": "خطأ في الخادم",
  "message.aiError": "عذراً، حدث خطأ. حاول مرة أخرى.",
  "message.paymentStatusUpdated": "تم تحديث حالة الدفع بنجاح",
  "message.updatePaymentStatusFailed": "فشل في تحديث حالة الدفع",
  "message.listingStatusUpdated": "تم تحديث حالة الإعلان",
  "message.featureStatusUpdated": "تم تحديث حالة التمييز",
  "message.premiumAccountUpdated": "تم تحديث حالة الحساب المميز",
  "message.storeStatusUpdated": "تم تحديث حالة المتجر الافتراضي",
  "message.verifiedStoreUpdated": "تم تحديث حالة المتجر الموثق",
  "feature.listing": "تمييز الإعلان",
  "feature.store": "تمييز المتجر",
  "feature.virtualStore": "تمييز المتجر الافتراضي",
  "feature.product": "تمييز المنتج",
  "cat.clothing": "الملابس",
  "cat.auto": "قطع غيار واكسسوارات السيارات",
  "cat.food": "المواد الغذائية",
  "cat.cleaning": "مواد التنظيف",
  "cat.cosmetics": "مستحضرات التجميل",
  "cat.mobile": "اكسسوارات الموبايل",
  "cat.lighting": "الإنارة",
  "cat.stationery": "القرطاسية",
  "cat.sports": "مستلزمات رياضية",
  "cat.kids": "مستلزمات أطفال",
  "cat.medical": "مستلزمات طبية",
  "sort.newest": "الأحدث",
  "sort.lowestPrice": "أقل سعر جملة",
  "sort.highestProfit": "أعلى ربح",
  "quantity.1-5": "1-5 قطعة",
  "quantity.5-10": "5-10 قطعة",
  "quantity.10-50": "10-50 قطعة",
  "quantity.50+": "50+ قطعة",
  "unit.piece": "قطعة",
  "toast.addedToFavorites": "تمت الإضافة للمفضلة",
  "toast.removedFromFavorites": "تمت الإزالة من المفضلة",
  "toast.favoriteLoginRequired": "يجب تسجيل الدخول لحفظ المفضلة",
  "toast.messageSentSuccess": "تم إرسال الرسالة بنجاح!",
  "toast.messageSentError": "فشل إرسال الرسالة",
  "toast.listingAddedSuccess": "تم إضافة الإعلان بنجاح",
  "toast.listingUpdatedSuccess": "تم تحديث الإعلان بنجاح",
  "toast.listingDeletedSuccess": "تم حذف الإعلان بنجاح",
  "toast.inventoryAddedSuccess": "تمت الإضافة لمحلك بنجاح",
  "toast.inventoryDisplaySuccess": "تم عرض المنتج للبيع في السوق.",
  "toast.inventoryRemovedSuccess": "تم إزالة المنتج من العرض للبيع.",
  "toast.inventoryPriceUpdatedSuccess": "تم تحديث سعر المنتج بنجاح.",
  "toast.featureRequestSuccess": "تم إرسال طلب التمييز بنجاح! سيتم مراجعته من قبل الإدارة.",
  "toast.featureRequestError": "فشل في إرسال الطلب",
  "chatbot.title": "خبير التسويق",
  "chatbot.subtitle": "مستشارك للمحلات الافتراضية والتسويق",
  "chatbot.welcome": "خبير التسويق والمحلات الافتراضية",
  "chatbot.description": "أساعدك تبدأ مشروعك وتنجح بالتجارة الإلكترونية",
  "chatbot.placeholder": "اكتب رسالتك...",
  "chatbot.suggestion1": "ما هي المحلات الافتراضية؟",
  "chatbot.suggestion2": "كيف أسوّق وأزيد مبيعاتي؟",
  "chatbot.suggestion3": "كيف أختار المنتجات وأسعّرها؟",
  "chatbot.suggestion4": "كم أربح؟ أعطني مثال عملي",

  "return.reason.damaged": "المنتج وصل تالفاً",
  "return.reason.wrong_item": "وصلني منتج خاطئ",
  "return.reason.not_as_described": "المنتج لا يطابق الوصف",
  "return.reason.not_received": "لم يصلني المنتج",
  "return.reason.defective": "المنتج معطل",
  "return.reason.missing_parts": "أجزاء ناقصة",
  "return.reason.changed_mind": "تغيير الرأي",
  "return.reason.other": "سبب آخر",
  "return.orderType.regular": "طلب اعتيادي",
  "return.orderType.dropshipping": "متجر افتراضي (دروبشيبينغ)",
  "return.orderType.store_own": "متجر افتراضي (منتجات ذاتية)",
  "return.status.requested": "قيد المراجعة",
  "return.status.seller_review": "البائع يراجع الطلب",
  "return.status.approved": "تمت الموافقة",
  "return.status.in_transit": "قيد الإرجاع للبائع",
  "return.status.received": "استلم البائع المنتج",
  "return.status.refunded": "تم استرداد المبلغ",
  "return.status.closed": "مُغلق",
  "return.status.rejected": "مرفوض",
  "return.status.escalated": "محال إلى الإدارة",
  "return.status.admin_review": "الإدارة تراجع الطلب",
  "myReturns.loginRequired": "يرجى تسجيل الدخول لعرض طلبات الإرجاع الخاصة بك",
  "myReturns.title": "طلبات الإرجاع الخاصة بي",
  "myReturns.loadError": "تعذر تحميل طلبات الإرجاع",
  "myReturns.retry": "إعادة المحاولة",
  "myReturns.empty": "لا توجد طلبات إرجاع",
  "myReturns.emptyHint": "يمكنك طلب الإرجاع من صفحة طلباتي بعد استلام المنتج إذا واجهت مشكلة.",
  "myReturns.reason": "سبب الإرجاع",
  "myReturns.quantity": "الكمية",
  "myReturns.details": "التفاصيل",
  "myReturns.detailsTitle": "تفاصيل طلب الإرجاع",
  "myReturns.detailsDescription": "عرض حالة طلب الإرجاع وسجل التحديثات الخاصة به.",
  "myReturns.detailsLoadError": "تعذر تحميل تفاصيل طلب الإرجاع.",
  "myReturns.orderType": "نوع الطلب",
  "myReturns.orderNumber": "رقم الطلب",
  "myReturns.createdAt": "تاريخ الإنشاء",
  "myReturns.issueDetails": "تفاصيل المشكلة",
  "myReturns.attachedImages": "الصور المرفقة",
  "myReturns.imageAlt": "صورة",
  "myReturns.statusLog": "سجل الحالة",
  "myReturns.noUpdates": "لا توجد تحديثات بعد.",
  "site.name": "سوق العراق",
  "stores.verifiedBadge": "موثق",

  "myOrders.deliveryHeader": "طلبك في الطريق إليك",
  "myOrders.deliveryCodeLabel": "🔑 رمز الاستلام — أعطه للمندوب",
  "myOrders.statusDeliveryFailed": "فشل التسليم",
  "myOrders.statusAccepted": "مقبول",
  "myOrders.statusPreparing": "قيد التحضير",
  "myOrders.statusShipped": "تم التسليم لمندوب التوصيل",
  "myOrders.statusAcceptedByShop": "قبله المتجر",
  "myOrders.statusInProgress": "جاري التجهيز",
  "myOrders.statusAcceptedShort": "تم القبول",
  "myOrders.paymentAsiaHawala": "آسيا حوالة",
  "myOrders.currency": "د.ع",
  "myOrders.myReturnsLink": "إرجاعاتي",
  "myOrders.editAddressPhone": "تعديل العنوان / الهاتف",
  "myOrders.cantEditAfterProcessing": "لا يمكن تعديل أو إلغاء الطلب بعد بدء المعالجة",
  "myOrders.cantEditAfterAccepted": "لا يمكن تعديل أو إلغاء الطلب بعد قبوله من المتجر",
  "myOrders.requestReturn": "طلب إرجاع",
  "myOrders.openDispute": "فتح نزاع / إبلاغ عن مشكلة",
  "myOrders.orderPrefix": "طلب",
  "myOrders.cashOnDelivery": "الدفع عند الاستلام",
  "myOrders.rejectionReason": "سبب الرفض:",
  "myOrders.rateExperience": "قيّم تجربتك مع المتجر",
  "myOrders.alreadyRated": "قيّمت هذا الطلب — شكراً!",
  "myOrders.toastError": "خطأ",
  "myOrders.toastUpdateSuccess": "تم تحديث بيانات الطلب بنجاح",
  "myOrders.toastDisputeSent": "تم إرسال النزاع",
  "myOrders.toastDisputeDescription": "سيتابعه فريق الدعم ويظهر في «نزاعاتي».",
  "myOrders.toastRatingThanks": "شكراً على تقييمك!",
  "myOrders.toastRatingDescription": "تقييمك سيساعد المشترين الآخرين في اختيار المتاجر",
  "myOrders.deliveryInstructionsHTML": "حين يصل المندوب إلى بابك ستتلقى <strong>رمز الاستلام (4 أرقام)</strong> هنا وفي إشعاراتك — أعطه للمندوب لإتمام الاستلام",
  "myOrders.editDialogTitle": "تعديل بيانات الطلب",
  "myOrders.editDialogDesc": "يمكنك تعديل العنوان ورقم الهاتف قبل بدء معالجة الطلب",
  "myOrders.phoneLabel": "رقم الهاتف",
  "myOrders.cityLabel": "المدينة / المحافظة",
  "myOrders.cityPlaceholder": "بغداد، البصرة...",
  "myOrders.addressLabel": "العنوان التفصيلي",
  "myOrders.addressPlaceholder": "المنطقة، الزقاق، أقرب نقطة دالة...",
  "myOrders.saveChanges": "حفظ التعديلات",
  "myOrders.openDisputeTitle": "فتح نزاع",
  "myOrders.openDisputeDesc": "أخبرنا بالمشكلة وسيتواصل معك الدعم في أسرع وقت",
  "myOrders.disputeSubjectLabel": "موضوع النزاع",
  "myOrders.disputeSubjectPlaceholder": "مثال: لم يصلني الطلب، المنتج تالف...",
  "myOrders.charsMinLabel": "حرفاً — الحد الأدنى",
  "myOrders.charsLabel": "حرفاً",
  "myOrders.charsLabelShort": "أحرف",
  "myOrders.missingPrefix": "ناقص",
  "myOrders.issueDetailsLabel": "تفاصيل المشكلة",
  "myOrders.issueDetailsPlaceholder": "اشرح المشكلة بالتفصيل...",
  "myOrders.submitDispute": "إرسال النزاع",
  "myOrders.rateStoreTitle": "تقييم المتجر الافتراضي",
  "myOrders.rateOrderInfix": "طلب",
  "myOrders.responseSpeedLabel": "سرعة الاستجابة (كم سرعة المتجر في قبول الطلب؟)",
  "myOrders.overallExperienceLabel": "التجربة الكلية (الجودة، التواصل، الخدمة)",
  "myOrders.commentLabel": "تعليق (اختياري)",
  "myOrders.commentPlaceholder": "شارك تجربتك مع المشترين الآخرين...",
  "myOrders.submitRating": "إرسال التقييم",

  "createListing.toastSelectDistrict": "يرجى اختيار القضاء",
  "createListing.toastSelectNeighborhood": "يرجى اختيار الحي أو إدخال اسم الحي",
  "createListing.openButton": "أضف منتجك من هنا",
  "createListing.titleEdit": "تعديل الإعلان",
  "createListing.titleNew": "إضافة إعلان جديد",
  "createListing.descEdit": "تعديل بيانات الإعلان الحالي",
  "createListing.descNew": "إضافة إعلان جديد للسوق",
  "createListing.categoryLabel": "القسم *",
  "createListing.categoryPlaceholder": "اختر القسم",
  "createListing.importTypeLabel": "نوع الاستيراد",
  "createListing.importTypePlaceholder": "اختر نوع الاستيراد",
  "createListing.vinLabel": "رقم الشاصي (VIN)",
  "createListing.vinPlaceholder": "مثال: 1HGBH41JXMN109186",
  "createListing.vinHint": "رقم الشاصي المكون من 17 رمز",
  "createListing.damagedPartsLabel": "عدد القطع المتضررة",
  "createListing.paintedPartsLabel": "عدد القطع المصبوغة",
  "createListing.attributesLabel": "خصائص الإعلان",
  "createListing.brandPlaceholder": "اختر الماركة",
  "createListing.classPlaceholder": "اختر الفئة",
  "createListing.classNeedsBrand": "اختر الماركة أولاً",
  "createListing.modelPlaceholder": "اختر الموديل",
  "createListing.modelNeedsClass": "اختر الفئة أولاً",
  "createListing.yearPlaceholder": "اختر سنة الصنع",
  "createListing.fuelPlaceholder": "اختر نوع الوقود",
  "createListing.transmissionPlaceholder": "اختر ناقل الحركة",
  "createListing.engineSizePlaceholder": "اختر حجم المحرك",
  "createListing.kmPlaceholder": "أدخل المسافة المقطوعة بالكيلومتر",
  "createListing.attrSelectPrefix": "اختر",
  "createListing.attrTypePrefix": "اكتب",
  "createListing.attrInputPrefix": "أدخل",
  "createListing.conditionLabel": "الحالة",
  "createListing.conditionNew": "جديد",
  "createListing.conditionUsed": "مستعمل",
  "createListing.titleLabel": "اسم الإعلان *",
  "createListing.titlePlaceholder": "اسم الإعلان",
  "createListing.subcategoryLabel": "القسم الفرعي",
  "createListing.choose": "اختر",
  "createListing.priceLabel": "السعر *",
  "createListing.currencyLabel": "العملة *",
  "createListing.iqd": "د.ع",
  "createListing.quantityLabel": "الكمية المتاحة",
  "createListing.quantityHint": "إذا كان المنتج كارتون أو درزن يرجى كتابة عدد القطع وليس عدد الكراتين أو الدرازن",
  "createListing.minOrderLabel": "الحد الأدنى (شراء مباشر من التاجر)",
  "createListing.virtualStoresHeader": "المحلات الافتراضية",
  "createListing.dropshippingAvailable": "متاح للمحلات الافتراضية (إعادة البيع)",
  "createListing.dropshippingPriceHint": "سعر الجملة الذي حددته أعلاه هو السعر الذي ستبيع به للمتاجر الافتراضية",
  "createListing.provinceLabel": "المحافظة",
  "createListing.provinceLoading": "جاري التحميل...",
  "createListing.provincePlaceholder": "اختر المحافظة",
  "createListing.provinceSearch": "ابحث عن المحافظة...",
  "createListing.noResults": "لا توجد نتائج",
  "createListing.districtLabel": "القضاء",
  "createListing.districtPlaceholder": "اختر القضاء",
  "createListing.districtSearch": "ابحث عن القضاء...",
  "createListing.neighborhoodLabel": "الحي / المنطقة",
  "createListing.otherEllipsis": "أخرى...",
  "createListing.neighborhoodPlaceholder": "اختر الحي",
  "createListing.neighborhoodSearch": "ابحث عن الحي...",
  "createListing.neighborhoodInputPlaceholder": "أدخل اسم الحي",
  "createListing.descLabel": "الوصف *",
  "createListing.descPlaceholder": "وصف تفصيلي للإعلان...",
  "createListing.imagesLabel": "الصور",
  "createListing.imagesHint": "يمكنك رفع حتى 5 صور",
  "createListing.phoneLabel": "رقم الهاتف",
  "createListing.phoneHint": "اختياري — إذا أضفت رقمك سيظهر للمشترين في صفحة الإعلان. إذا تركته فارغاً يمكنهم التواصل عبر رسائل التطبيق.",
  "createListing.whatsappAvailable": "متاح على هذا الرقم",
  "createListing.cancel": "إلغاء",
  "createListing.saveChanges": "حفظ التغييرات",
  "createListing.publish": "نشر الإعلان",
  "createListing.importAmerican": "وارد أمريكي",
  "createListing.importGulf": "وارد خليجي",
  "createListing.importEuropean": "وارد أوروبي",
  "createListing.loginRequired": "يرجى تسجيل الدخول لنشر إعلانك",
  "createListing.marketTagLabel": "سيُعرض إعلانك في",
  "createListing.marketTagRemove": "إزالة السوق",
  "createListing.marketTagHint": "يُحفظ السوق على الإعلان، ويظهر الإعلان أيضًا في التصفح العام. السوق في بغداد، لذا المدينة بغداد.",
  "createListing.loginSubtitle": "سجل دخولك للاستفادة من جميع خدمات سوق العراق",
  "createListing.signIn": "تسجيل الدخول",
  "createListing.backHome": "العودة للرئيسية",
  "createListing.limitTitle": "وصلت إلى حد الإعلانات المجانية",
  "createListing.limitBody": "لقد استنفدت عدد الإعلانات المجانية المتاحة حالياً. للتوسعة أو تفعيل إعلانات إضافية، يرجى التواصل مع الإدارة.",
  "createListing.limitFreeLabel": "حد الإعلانات المجانية الحالي",
  "createListing.limitActiveLabel": "إعلاناتك النشطة",
  "createListing.limitRequestAdmin": "إرسال طلب للإدارة",
  "createListing.limitMyListings": "عرض إعلاناتي",
  "createListing.limitRequestMessage": "أطلب زيادة حد الإعلانات المجانية لحسابي حتى أتمكن من نشر إعلانات إضافية.",
  "createListing.toastSelectCategory": "يرجى اختيار القسم",
  "createListing.toastTitleShort": "العنوان قصير جداً",
  "createListing.toastDescShort": "الوصف قصير جداً",
  "createListing.toastInvalidPrice": "سعر غير صالح",
  "createListing.toastInvalidPriceDesc": "أدخل سعراً أكبر من صفر لمنتج المتجر.",
  "createListing.toastImageRequired": "صورة مطلوبة",
  "createListing.toastImageRequiredDesc": "أضف صورة واحدة على الأقل للمنتج.",
  "createListing.toastQuantityRequired": "الكمية مطلوبة",
  "createListing.toastQuantityRequiredDesc": "أدخل عدد القطع المتوفرة في المخزن (يجب أن يكون أكبر من صفر) قبل نشر المنتج.",
  "createListing.fetchProductError": "تعذر جلب المنتج",
  "createListing.confidenceHigh": "عالية",
  "createListing.confidenceMedium": "متوسطة",
  "createListing.confidenceLow": "منخفضة",
  "createListing.imagesHintPrefix": "يمكنك رفع حتى",
  "createListing.imagesHintSuffix": "صور",
  "imageUpload.maxReachedTitle": "الحد الأقصى",
  "imageUpload.maxReachedDescPrefix": "يمكنك رفع",
  "imageUpload.maxReachedDescSuffix": "صور فقط",
  "imageUpload.chooseFromAlbum": "اختر الصور من الألبوم",
  "imageUpload.maxLabel": "الحد الأقصى",
  "imageUpload.images": "صور",
  "imageUpload.invalidFileType": "يجب أن تكون الملفات صور فقط",
  "imageUpload.fileTooBigTitle": "الملف كبير جداً",
  "imageUpload.fileTooBigDesc": "الحد الأقصى 50 ميغابايت",
  "imageUpload.unsupportedTypeTitle": "نوع الملف غير مدعوم",
  "imageUpload.unsupportedTypeDesc": "يجب أن تكون الصورة بصيغة JPEG أو PNG أو WebP أو GIF",
  "imageUpload.mainImageHint": "الصورة الأولى هي الصورة الرئيسية للإعلان",
  "imageUpload.chooseImages": "اختر صور",
  "imageUpload.dragHint": "اسحب الصور لتغيير ترتيبها • الصورة الأولى هي الصورة الرئيسية",
  "imageUpload.imageAlt": "صورة",
  "imageUpload.mainImageBadge": "الصورة الرئيسية",
  "imageUpload.makeMain": "جعلها الصورة الرئيسية",
  "cart.maxStockTitle": "الكمية تجاوزت المتوفر",
  "cart.maxStockDescPrefix": "البائع يعرض",
  "cart.maxStockDescSuffix": "قطعة فقط من هذا المنتج، لا يمكن إضافة أكثر.",
};
export default ar;
